import Vue from 'vue';
import VueI18n from 'vue-i18n';

Vue.use(VueI18n);

const messages = {
	pt: {
		ACCESS_BASE: 'Acessar base',
		ACCESS_PLATFORM: 'Acessar plataforma',
		ACCESS__LOGIN: 'Login',
		ACCESS__RECOVER_PASSWORD: 'Recuperar senha',
		ACCESS__REMEMBER_EMAIL: 'Lembrar email',
		ACCESS__ACTION_BACK: 'Voltar ao login',
		ACCESS__MESSAGE_ACCESS__RECOVER_PASSWORD_USER:
			'Se este e-mail estiver cadastrado você receberá um link para recuperação de senha!',
		ACCESS__MESSAGE_ACCESS__RECOVER_PASSWORD:
			'Enviamos para você um e-mail de recuperação de senha. Clique no link do e-mail e atualize-a!',
		ACCESS__EMAIL_WAS_SENT_TO: 'Um e-mail foi enviado para',
		ACCESS__REMEMBER_ACCOUNT: 'Lembrar e-mail',
		ACCESS__EMAIL: 'E-mail',
		ACCESS__PASSWORD: 'Senha',
		ACCESS__CPF: 'CPF',
		ACCESS__NEW_PASSWORD: 'Nova senha',
		ACCESS__CONFIRM_PASSWORD: 'Senha não confere',
		ACCESS__CHANGE_PASSWORD: 'Alterar senha',
		ACCESS__RECOVERED_SUCCESS: 'Senha redefinida com sucesso',
		ACCESS__NEW_PASSWORD_REPEAT: 'Repita a nova senha',

		ACTION__ACTIONS: 'Actions',
		ACTION__NAME: 'Nome',
		ACTION__ACCOUNT: 'Conta',
		ACTION__TYPE: 'Tipo',
		ACTION__LANGUAGE: 'Linguagem',
		ACTION__STATUS: 'Status',
		ACTION__FILTER_ACTIONS: 'Filtrar actions',
		ACTION__CLIENT: 'Cliente',
		ACTION__ACTION: 'Action',
		ACTION__COMMENTS: 'Observações Gerais',
		ACTION__PERMISSION_GROUPS: 'Grupos de permissão',
		ACTION__CODE: 'Código',
		ACTION__ACTION_TYPE: 'Tipo de Action',
		ACTION__RETURN: 'Retorno',
		ACTION__SCRIPT: 'Script',
		ACTION__SCRIPT_CODE: 'Código script',
		ACTION__NEW_ACTION: 'Novo action',
		ACTION__ACTION_DETAILS: 'Detalhes do action',
		ACTION__MESSAGE_CREATED: 'Action adicionada com sucesso!',
		ACTION__MESSAGE_UPDATED: 'Action alterada com sucesso!',
		ACTION__MESSAGE_REMOVED: 'Action excluída com sucesso!',
		ACTION__TITLE_ADD: 'Adicionar action',
		ACTION__MESSAGE_ADD: 'Deseja adicionar nova action?',
		ACTION__TITLE_UPDATE: 'Alterar action',
		ACTION__MESSAGE_UPDATE: 'Deseja alterar a action?',
		ACTION__TITLE_REMOVE: 'Excluir action',
		ACTION__MESSAGE_REMOVE: 'Deseja realmente excluir a action?',

		BOARDS__BOARDS_REPOSITORY: 'Repositório de boards',
		BOARDS__BOARDS: 'Boards',
		BOARDS__STAGE: 'Estágio',
		BOARDS__FILTER_BOARDS: 'Filtrar boards',
		BOARDS__NAME: 'Nome',
		BOARDS__VERSION: 'Versão',
		BOARDS__RELEASE_DATE: 'Data liberação',
		BOARDS__EXPIRATION_DATE: 'Data expiração',
		BOARDS__BOARD_DETAILS: 'Detalhes do board',
		BOARDS__REGISTRATION: 'Cadastro',
		BOARDS__FIRMWARES: 'Firmwares',
		BOARDS__DOCUMENTATION: 'Documentação',
		BOARDS__CHANGELOG: 'Changelog',
		BOARDS__COMMENTS: 'Comentários',
		BOARDS__COMPATIBILITY: 'Compatibilidade',
		BOARDS__PRODUCT: 'Produto',
		BOARDS__FEATURES: 'Features',
		BOARDS__BOARD_FILE: 'Arquivo Board',
		BOARDS__DOCUMENTATION_FILE: 'Arquivo documentação',
		BOARDS__PREVIEW: 'Preview',
		BOARDS__MESSAGE_FILE_SIZE_LIMIT: 'O arquivo não pode ser superior a 4MB',
		BOARDS__NEW_BOARD: 'Novo board',
		BOARDS__MESSAGE_CREATED: 'Board adicionado com sucesso!',
		BOARDS__MESSAGE_UPDATED: 'Board alterado com sucesso!',
		BOARDS__MESSAGE_REMOVED: 'Board excluído com sucesso!',
		BOARDS__MESSAGE_FILE_REMOVED: 'Arquivo excluído com sucesso!',
		BOARDS__BOARD_ADD: 'Adicionar board',
		BOARDS__BOARD_MESSAGE_ADD: 'Deseja adicionar novo board?',
		BOARDS__TITLE_UPDATE: 'Alterar board',
		BOARDS__MESSAGE_UPDATE: 'Deseja alterar o board?',
		BOARDS__BOARD_REMOVE: 'Excluir board',
		BOARDS__BOARD_MESSAGE_REMOVE: 'Deseja realmente excluir o board?',

		BRIGADIER__PANEL: 'Painel Brigadista',
		BRIGADIER__NAME: 'Nome',
		BRIGADIER__ACCOUNT: 'Conta',
		BRIGADIER__STATUS: 'Status',
		BRIGADIER__FILTER_PANELS: 'Filtrar painéis',
		BRIGADIER__PANELS: 'Painéis',
		BRIGADIER__MONITOR: 'Monitorar',
		BRIGADIER__MIN_BRIGADIERS: 'Min. Brigadistas',
		BRIGADIER__MIN_MEMBERS: 'Min. Cipeiros',
		BRIGADIER__MONITORING: 'Monitoramento',
		BRIGADIER__BRIGADIERS: 'Brigadistas',
		BRIGADIER__IN_THIS_ENVIRONMENT_NOW: 'Neste Ambiente Agora',
		BRIGADIER__FORCE_EXIT: 'Forçar saída',
		BRIGADIER__MEMBER: 'Cipeiro',
		BRIGADIER__BRIGADIER: 'Brigadista',

		BULK__INVALID_RECORDS: 'registro(s) Inválido(s)',
		BULK__DOWNLOAD: 'Faça o download .csv',
		BULK__TEMPLATE_DOWNLOAD: 'Download template',
		BULK__TEMPLATE: 'Template',
		BULK__AS_EDIT: 'Edite as',
		BULK__INFORMATIONS: 'Informações',
		BULK__FILE_IMPORT: 'Importe o Arquivo',
		BULK__FILE_UPLOAD: 'Upload de Arquivo',
		BULK__TEMPLATE_UPLOAD: 'Upload de Template',
		BULK__COMPLETE: 'Completo',
		BULK__MESSAGE__FILE_SIZE_ERROR: 'O arquivo não pode ser superior a 4MB',
		BULK__INSTRUCTIONS:
			'Para concluir o processo de inclusão, corrija os registros inválidos em seu template e carregue-o novamente.<br /><strong>Nenhum Registro foi importado.</strong>',
		BULK__COMPLETE_INCLUSION: 'Concluir inclusão',
		BULK__INVALID_INFORMATION: 'Informação inválida',
		BULK__ROW: 'Linha',
		BULK__RECORDS_REVIEW: 'Revisão dos registros',

		CAMERA__NEW_CAMERA: 'Nova câmera',
		CAMERA__CAMERA: 'Câmera',
		CAMERA__CAMERAS: 'Câmeras',
		CAMERA__NAME: 'Nome',
		CAMERA__MODEL: 'Modelo',
		CAMERA__MANUFACTURER: 'Fabricante',
		CAMERA__ENVIRONMENT: 'Ambiente',
		CAMERA__FILTER_CAMERAS: 'Filtrar Câmeras',
		CAMERA__LOCATION: 'Localização',
		CAMERA__IP: 'IP',
		CAMERA__STATUS: 'Status',
		CAMERA__STATUS__ACTIVE: 'Ativo',
		CAMERA__STATUS__INACTIVE: 'Inativo',
		CAMERA__DETAILS: 'Detalhes da câmera',
		CAMERA__TAB_DETAILS: 'Detalhes',
		CAMERA__ENGINE_TAB: 'Engine',
		CAMERA__EVENTS_TAB: 'Eventos',
		CAMERA__IDENTIFICATION: 'Identificação',
		CAMERA__UNIT: 'Unidade',
		CAMERA__SELECT: 'Selecionar',
		CAMERA__DEPARTAMENT: 'Departamento',
		CAMERA__INFORMATION: 'Informações',
		CAMERA__CONNECTION: 'Conexão',
		CAMERA__CONNECT: 'Associar câmera',
		CAMERA__CONNECTION_URL: 'URL de conexão',
		CAMERA__KINESIS_URL: 'URL kinesis de conexão',
		CAMERA__SERIAL_NUMBER: 'Núm. Serie',
		CAMERA__UID: 'UID',
		CAMERA__FIRMWARE: 'Firmware',
		CAMERA__STAGE: 'Estágio',
		CAMERA__STAGE_PRODUCTION: 'Produção',
		CAMERA__STAGE_TEST: 'Teste',
		CAMERA__STAGE_STOCK: 'Estoque',
		CAMERA__STAGE_TRANSPORT: 'Transporte',
		CAMERA__STAGE_INSTALLED: 'Instalado',

		CAMERA__USER: 'Usuário',
		CAMERA__PASSWORD: 'Senha',
		CAMERA__RESOLUTION: 'Resolução',
		CAMERA__OBSERVATIONS: 'Observações',
		CAMERA__ASSOCIATIONS: 'Associações',
		CAMERA__ASSOCIATIONS_CAMERAS: 'Câmeras associadas',
		CAMERA__ENGINE_NAME: 'Nome',
		CAMERA__ENGINE_INCLUSION_DATE: 'Inclusão',
		CAMERA__ENGINE_QTD_PARAMETERS: 'Qtde. Parâmetros',
		CAMERA__DEVICE_TYPE__SOFTCORE: 'Softcore',
		CAMERA__CAMERAS_AVAILABLE: 'Câmeras disponíveis',
		CAMERA__ENGINE_TOTAL_EVENTS: 'Total Eventos',
		CAMERA__ENGINE_NEW_ENGINE: 'Nova Engine',
		CAMERA__CLASSES: 'Classes',
		CAMERA__REKOGNITION_CLASSES: 'Classes a ser reconhecida',
		CAMERA__CLASS_PRECISION: '% de confiabilidade do reconhecimento',
		CAMERA__VALUE__HELP: 'Escolha um valor entre 40 e 99',
		CAMERA__TIMEOUT_SHOOT: 'Timeout Disparo (segundos)',
		CAMERA__DESCRIPTION: 'Descrição',
		CAMERA__DEFAULT_CLASS_ORIENTATION:
			'Valor único para todas as classes definidas abaixo',

		CAMERA__TITLE_ADD: 'Adicionar câmera',
		CAMERA__MESSAGE_ADD: 'Deseja adicionar nova câmera?',
		CAMERA__ADD_SUCCESSFULLY: 'Câmera adicionada com sucesso!',
		CAMERA__TITLE_UPDATE: 'Alterar câmera',
		CAMERA__MESSAGE_UPDATE: 'Deseja alterar a câmera?',
		CAMERA__UPDATED_SUCCESSFULLY: 'Câmera alterada com sucesso!',
		CAMERA__TITLE_REMOVE: 'Excluir câmera',
		CAMERA__MESSAGE_REMOVE: 'Deseja realmente excluir a câmera?',
		CAMERA__MESSAGE_CREATED: 'Câmera adicionada com sucesso!',
		COMMON__ERROR__FORCE_EXIT: 'Erro ao forçar saída do colaborador',
		CAMERA__REMOVED_SUCCESSFULLY: 'Câmera removida com sucesso!',
		CAMERA__ERROR__LOAD_CAMERA: 'Erro ao carregar câmera',
		CAMERA__MESSAGE_UPDATED: 'Câmera alterada com sucesso!',
		CAMERA__MESSAGE_REMOVED: 'Câmera excluída com sucesso!',
		CAMERA__NEW_ENGINE: 'Nova engine',
		CAMERA__ENGINE_DETAILS: 'Detalhes da engine',
		CAMERA__ENGINE_SOFTCORE: 'Softcore',

		CLIENT__ACCOUNTS: 'Contas',
		CLIENT__ACCOUNT: 'Conta',
		CLIENT__NAME: 'Nome',
		CLIENT__ADDRESS: 'Endereço',
		CLIENT__ADDRESS__STATE: 'Estado',
		CLIENT__ADDRESS__CITY: 'Cidade',
		CLIENT__ADDRESS__ZIP_CODE: 'CEP',
		CLIENT__ADDRESS__STREET: 'Endereço',
		CLIENT__ADDRESS__STREET2: 'Complemento',
		CLIENT__ADDRESS__DISTRICT: 'Bairro',
		CLIENT__ADDRESS__NUMBER: 'Número',
		CLIENT__ASSOCIATION_DATE: 'Data associação',
		CLIENT__FILTER_ACCOUNTS: 'Filtrar contas',
		CLIENT__LOCATION: 'Local',
		CLIENT__ACCOUNT_DETAILS: 'Detalhes da conta',
		CLIENT__TRADE_NAME: 'Nome fantasia',
		CLIENT__COMPANY_NAME: 'Razão Social',
		CLIENT__ACCOUNT_NUMBER: 'Número da conta',
		CLIENT__CNPJ: 'CNPJ',
		CLIENT__IE: 'Inscrição estadual',
		CLIENT__IM: 'Inscrição municipal',
		CLIENT__COMMENTS: 'Dados adicionais',
		CLIENT__HELPER_CENTER: 'Help Center',
		CLIENT__TICKETS: 'Tickets',
		CLIENT__KNOWLEDGE_BASE: 'Base de conhecimento',
		CLIENT__SUPPORT_EMAIL: 'E-mail Suporte',
		CLIENT__SUPPORT_EMAIL_TEXT: 'E-mail Suporte Texto',
		CLIENT__SUPPORT_WHATSAPP: 'Whatsapp Suporte',
		CLIENT__SUPPORT_WHATSAPP_TEXT: 'Whastapp Suporte Texto',
		CLIENT__DOCUMENTATION_URL: 'Documentação',
		CLIENT__DATA_INSIGHT: 'Data Insight',
		CLIENT__CUSTOMIZATIONS: 'Customizações',
		CLIENT__URL: 'URL',
		CLIENT__COLORS: 'CORES',
		CLIENT__ACCESS_LINK: 'Link de acesso',
		CLIENT__PRIMARY_COLOR: 'Cor primária',
		CLIENT__SECONDARY_COLOR: 'Cor secundária',
		CLIENT__PRIMARY_COLOR_DESCRIPTION:
			'Sua principal cor utilizada em botões, menus, títulos e fontes em destaque.',
		CLIENT__SECONDARY_COLOR_DESCRIPTION:
			'Cor utilizada em botões de destaque e títulos das seções.',
		CLIENT__THEME_BACKGROUND: 'BACKGROUND',
		CLIENT__PREVIEW: 'Preview',
		CLIENT__MESSAGE_FILE_SIZE_LIMIT: 'O arquivo não pode ser superior a 4MB',
		CLIENT__SLOGAN: 'SLOGAN',
		CLIENT__LOGO: 'LOGOTIPO',
		CLIENT__NEW_CONTRACT: 'Novo contrato',
		CLIENT__NEW_ACCOUNT: 'Nova conta',
		CLIENT__ACCOUNT__MESSAGE_CREATED: 'Conta adicionada com sucesso!',
		CLIENT__ACCOUNT__MESSAGE_UPDATED: 'Conta alterada com sucesso!',
		CLIENT__ACCOUNT__MESSAGE_REMOVED: 'Conta excluída com sucesso!',
		CLIENT__ACCOUNT__MESSAGE_IMAGE_REMOVED: 'Imagem excluída com sucesso!',
		CLIENT__ACCOUNT_ADD: 'Adicionar conta',
		CLIENT__ACCOUNT_MESSAGE_ADD: 'Deseja adicionar nova conta?',
		CLIENT__ACCOUNT_UPDATE: 'Atualizar conta',
		CLIENT__ACCOUNT_MESSAGE_UPDATE: 'Deseja alterar a conta?',
		CLIENT__ACCOUNT_REMOVE: 'Excluir conta',
		CLIENT__ACCOUNT_MESSAGE_REMOVE: 'Deseja realmente excluir a conta?',

		CLIENT__LINK_DETAIL: 'Detalhe do link',
		CLIENT__GENERAL_INFORMATION: 'Informações gerais',
		CLIENT__TITLE: 'Título',
		CLIENT__SUBTITLE: 'Subtítulo',
		CLIENT__LINK: 'Link',
		CLIENT__REPORT_MESSAGE_CREATED: 'Relatório adicionado com sucesso!',
		CLIENT__REPORT_MESSAGE_UPDATED: 'Relatório alterado com sucesso!',
		CLIENT__REPORT_MESSAGE_REMOVED: 'Relatório excluído com sucesso!',
		CLIENT__CONTROL_DETAIL: 'Detalhe do controle',
		CLIENT__PRODUCT_DATA: 'Dados do produto',
		CLIENT__PRODUCT: 'Produto',
		CLIENT__HIRED: 'Contratado',
		CLIENT__DELIVERED: 'Entregue',
		CLIENT__QUANTITY_HIRED: 'Quantidade contratada',

		CLIENT__RESPONSIBLE: 'Responsável',
		CLIENT__RESPONSIBLES: 'Responsáveis',
		CLIENT__DETAIL: 'Detalhe do responsável',
		CLIENT__DATAS: 'Dados do responsável',
		CLIENT__CONTACT: 'Contato',
		CLIENT__PHONE: 'Telefone',
		CLIENT__EMAIL: 'E-mail',
		CLIENT__DEPARTMENT: 'Departamento',
		CLIENT__CONTRACTS: 'Contratos',
		CLIENT__CONTRACTS__ACTIVES_SUBTITLE: 'Ativos',
		CLIENT__CONTRACT_DETAIL: 'Detalhe do contrato',
		CLIENT__CONTRACT_DETAILS: 'Detalhes do contrato',
		CLIENT__REGISTRATION: 'Cadastro',
		CLIENT__CONTRACT_NUMBER: 'Número',
		CLIENT__CONTRACT__PURCHASE_ORDER: 'Ordem de compra',
		CLIENT__CONTRACT__START_DATE: 'Início',
		CLIENT__CONTRACT__END_DATE: 'Fim',
		CLIENT__CONTRACT__END_WARRANTY: 'Término garantia',
		CLIENT__CONTRACT__STATUS: 'Status',
		CLIENT__CONTRACT_FILES: 'Arquivos',
		CLIENT__CONTRACT__UPLOAD_FILES: 'Upload Arquivos Contrato',
		CLIENT__CONTRACT__ERROR_MESSAGE:
			'A soma dos arquivos não pode ser superior a 10MB',
		CLIENT__CONTRACT__ACTION_ADD: 'Adicionar',
		CLIENT__CONTRACT__CONTROL: 'Controle',
		CLIENT__CONTRACT__DEVICES_HIRED: 'Dispositivos contratados',
		CLIENT__CONTRACT__DEVICES__HANDED_OUT: 'Dispositivos entregues',
		CLIENT__CONTRACT__COMMENTS: 'Observações',
		CLIENT__CONTRACT__DEVICES: 'Dispositivos',
		CLIENT__CONTRACT__DEVICES_PRODUCT: 'Produto',
		CLIENT__CONTRACT__DEVICES_TYPE_PROFILE: 'Tipo / perfil',
		CLIENT__CONTRACT__DEVICES_SERIAL_NUMBER: 'Núm. Série',
		CLIENT__CONTRACT__DEVICES_UID: 'UID',
		CLIENT__CONTRACT__DEVICES_HARD_FIRM: 'Hard / Firm',
		CLIENT__CONTRACT__DEVICES_STAGE: 'Estágio',
		CLIENT__FILTER_CONTRACTS: 'Filtrar contratos',
		CLIENT__CONTRACT_NAME: 'Nome',
		CLIENT__CONTRACT_PHONE: 'Telefone',
		CLIENT__CONTRACT_EMAIL: 'E-mail',
		CLIENT__CONTRACT__DEVICES_TOTAL_HIRED: 'Contratados',
		CLIENT__CONTRACT__DEVICES_TOTAL: 'Vinculados',
		CLIENT__CONTRACT__DEVICES_HIRED_ASSOCIATES:
			'Dispositivos (contratados/associados)',
		CLIENT__CONTRACT__MESSAGE_CREATED: 'Contrato adicionado com sucesso!',
		CLIENT__CONTRACT__MESSAGE_UPDATED: 'Contrato alterado com sucesso!',
		CLIENT__CONTRACT__MESSAGE_REMOVED: 'Contrato excluído com sucesso!',
		CLIENT__CONTRACT__MESSAGE_FILE_REMOVED: 'Arquivo excluído com sucesso!',
		CLIENT_CONTRACT_TITLE: 'Título',
		CLIENT_CONTRACT_SUBTITLE: 'Subtítulo',
		CLIENT__CONTRACT__MODULES: 'Módulos',
		CLIENT__CONTRACT_MODALITY: 'Modalidade',
		CLIENT__CONTRACT_SUPPORT: 'Suporte',

		CLIENT__BACKGROUND_IMAGE:
			' Imagem para personalização do background de sua página de login. Aconselhável utilizar imagens em .jpg ou .jpeg, até 2mb, com tamanho mínimo de  1440x900px',
		CLIENT__MESSAGE_DOCUMENTATION_URL:
			'Link personalizado da conta, ao qual, servirá como acesso à documentação da APIo',
		CLIENT__MESSAGE_JIRA_URL:
			'Link personalizado da conta, ao qual, servirá como acesso à base de conhecimento do sistema no Jira',
		CLIENT__MESSAGE_CONNECT_URL:
			'Link personalizado da conta, ao qual, servirá como acesso a camera de monitoramento',
		CLIENT__MESSAGE_CONNECT_KINESIS_URL:
			'Link personalizado da conta, ao qual, servirá como acesso ao kinesis de monitoramento',
		CLIENT__LOGO_IMAGE:
			'Logotipo para sua página de login. Aconselhável utilizar .png com fundo transparente, tamanho mínimo 50x50px',
		CLIENT__MESSAGE_SUPPORT_EMAIL:
			'Email personalizado da conta, ao qual, servirá como canal para abertura de tickets no Jira',
		CLIENT__MESSAGE_SUPPORT_WHATSAPP:
			'Número de contato personalizado da conta, ao qual, servirá como canal para contato direto com o suporte técnico A4',
		CLIENT__MESSAGE_THEME_SLOGAN:
			'Slogan para personalização de sua página de login. Aconselhável utilizar no máximo 62 caracteres',
		CLIENT__MESSAGE_THEME_SLUG:
			'Definição da URL para acesso ao sistema A4 Solutions. Não utilize espaços, acentos ou caracteres especiais em sua url',
		CLIENT__MESSAGE_TICKET_URL:
			'Link personalizado da conta, ao qual, será acessado em caso de abertura e acompanhamento de tickets no Jira',

		COMMON__TABLE__LOADING_TEXT: 'Carregando dados...',
		COMMON__TABLE__NO_DATA_TEXT: 'Nenhum registro foi encontrado',
		COMMON__TABLE__NO_RESULTS_PAGE: 'Nenhum registro foi encontrado',
		COMMON__TABLE__ITEMS_PER_PAGE_TEXT: 'Itens por página',
		COMMON__FILTER: 'Filtro',
		COMMON__DETAILS: 'Detalhes',
		COMMOM__MODULES: 'Módulos',
		COMMON__SELECT: 'Selecione:',
		COMMON__ALL: 'Todos:',
		COMMON__ACTION__SAVE: 'Salvar',
		COMMON__ACTION__REMOVE: 'Excluir',
		COMMON__ACTION__BACK: 'Voltar',
		COMMON__ACTION__INSERT: 'Incluir',
		COMMON__ACTION__CANCEL: 'Cancelar',
		COMMON__ACTION__CONFIRM: 'Confirmar',
		COMMON__ACTION__APPLY: 'Aplicar',
		COMMON__ACTION__DOWNLOAD: 'Download',
		COMMON__ACTION__INSERT_BATCH: 'Incluir em lote',
		COMMON__ACTION__UPDATE_BATCH: 'Alterar em lote',
		COMMON__ACTION__REMOVE_BATCH: 'Excluir em lote',
		COMMON__ACTION__ASSOCIATE: 'Associar',
		COMMON__PAGE_TEXT_OF: 'de',
		COMMON__BULK__INCLUSION: 'Inclusão em lote',
		COMMON__BULK__UPDATE: 'Atualização em lote',
		COMMON__REQUIRED_FIELD: 'Campo obrigatório',
		COMMON__FIELD_MUST_BE_FILLED: 'Campo deve ser preenchido',
		COMMON__MINIMUM_CHARACTERS: 'Limite mínimo de caracteres',
		COMMON__MAXIMUM_CHARACTERS: 'Limite máximo de caracteres',
		COMMON__MAX_CHARACTERS: 'Limite máximo de caracteres',
		COMMON__INVALID_CPF: 'CPF inválido',
		COMMON__INVALID_CNPJ: 'CNPJ inválido',
		COMMON__INVALID_YEAR: 'Ano inválido',
		COMMON__INVALID_NUMBER: 'Número inválido',
		COMMON__INVALID_VALUE: 'Valor inválido',
		COMMON__PASSWORD_LOWERCASE_LETTERS:
			'Senha precisa conter caracteres minúsculos',
		COMMON__PASSWORD_UPPERCASE_LETTERS:
			'Senha precisa conter caracteres maiúsculos',
		COMMON__PASSWORD_NUMBERS: 'Senha precisa conter pelo menos um número',
		COMMON__PASSWORD_SPECIAL_CHARACTERS:
			'Senha precisa conter pelo menos um caracter especial',
		COMMON__PASSWORD_MINIMUM_CHARACTERS:
			'Senha precisa conter no mínimo 8 caracteres',
		COMMON__FILE_LESS_THAN: 'Arquivo deve ser inferior a',
		COMMON__PASSWORD_MINIMUM_LENGTH: 'Senha deve conter no mínimo 8 caracteres',
		COMMON__FILE__SIZE__LESS_THAN: 'Total de arquivo deve ser inferior a',
		COMMON__DATE_END_NOT_BE_BIGGER_THAN_START:
			'Data final não pode ser maior que a inicial',
		COMMON__DATE_EQUAL_TO: 'A data mámixa permitida deve ser de 7 dias',
		COMMON__DATE_BEFORE__OR__EQUAL_TO:
			'A data mámixa permitida deve ser de 7 dias',
		COMMON__DATE_AFTER__OR__EQUAL_TO:
			'A data mámixa permitida deve ser de 7 dias',
		COMMON__APPLICATION_LOGOUT_TITLE: 'Sair',
		COMMON__APPLICATION_ACTION_LOGOUT_OK: 'Ok',
		COMMON__APPLICATION_LOGOUT_ATTENTION: 'Atenção',
		COMMON__MESSAGE_APPLICATION_LOGOUT: 'Deseja realmente sair da aplicação?',
		COMMON__FILE_ACTION_REMOVE: 'Excluir arquivo',
		COMMON__MESSAGE_FILE_REMOVE: 'Deseja realmente excluir o arquivo?',
		COMMON__TITLE_ADD: 'Adicionar ação',
		COMMON__MESSAGE_ADD: 'Deseja adicionar nova ação?',
		COMMON__TITLE_UPDATE: 'Alterar ação',
		COMMON__MESSAGE_UPDATE: 'Deseja alterar a ação?',
		COMMON__TITLE_REMOVE: 'Excluir ação',
		COMMON__MESSAGE_REMOVE: 'Deseja realmente excluir a ação?',
		COMMON__YES: 'Sim',
		COMMON__NO: 'Não',
		COMMON__FILE_REMOVE: 'Excluir arquivo',

		SESSION_EXPIRED_ERROR_TOKEN:
			'Sessão retornou error. Você será redirecionado ao login. Faça login novamente.',

		DATA_INSIGHT__DATA_INSIGHT: 'Data Insight',
		DATA_INSIGHT__ACCOUNT: 'Conta',
		DATA_INSIGHT__REPORT: 'Relatório',
		DATA_INSIGHT__ACCOUNT_DETAILS: 'Detalhes da conta',
		DATA_INSIGHT__TITLE_ADD: 'Adicionar insight',
		DATA_INSIGHT__MESSAGE_ADD: 'Deseja adicionar novo insight?',
		DATA_INSIGHT__TITLE_UPDATE: 'Alterar insight',
		DATA_INSIGHT__MESSAGE_UPDATE: 'Deseja alterar o insight?',
		DATA_INSIGHT__TITLE_REMOVE: 'Excluir insight',
		DATA_INSIGHT__MESSAGE_REMOVE: 'Deseja realmente excluir o insight?',

		DASHBOARD__HOMEPAGE: 'Homepage',
		DASHBOARD__EVENTS_PER_MONTH: 'Eventos por mês',
		DASHBOARD__WELCOME: 'Seja Bem-Vindo!',
		DASHBOARD__DESCRIPTION: 'Acompanhe o desempenho do seu Smart Safety!',
		DASHBOARD__CLIENT_LIST__LABEL: 'Lista de contas',
		DASHBOARD__CLIENT_LIST__HEADER: 'Contas',
		DASHBOARD__CLIENT_LIST__SEARCH_PLACEHOLDER: 'Buscar uma conta',
		DASHBOARD__CLIENT_LIST__COLUMN__NAME: 'Nome',
		DASHBOARD__CLIENT_LIST__COLUMN__DEVICES: 'Dispositivos',
		DASHBOARD__CLIENT_LIST__COLUMN__EVENTS: 'Eventos',
		DASHBOARD__PRODUCT_STOCK_LIST__LABEL: 'Produtos em estoque',
		DASHBOARD__PRODUCT_STOCK_LIST__HEADER: 'Estoque',
		DASHBOARD__PRODUCT_STOCK_LIST__SEARCH_PLACEHOLDER: 'Buscar um produto',
		DASHBOARD__PRODUCT_STOCK_LIST__COLUMN__PRODUCT: 'Produto',
		DASHBOARD__PRODUCT_STOCK_LIST__COLUMN__QUANTITY: 'Quantidade',
		DASHBOARD__EVENT_LIST__LABEL: 'Eventos do Dia',
		DASHBOARD__EVENT_LIST__HEADER: 'Últimos eventos de aproximação',
		DASHBOARD__EVENT_LIST__SEARCH_PLACEHOLDER: 'Buscar um Evento',
		DASHBOARD__EVENT_LIST__COLUMN__TYPE: 'Tipo',
		DASHBOARD__EVENT_LIST__COLUMN__EQUIPMENT: 'Equipamento',
		DASHBOARD__EVENT_LIST__COLUMN__TIME: 'Horário',
		DASHBOARD__EVENT_LIST__COLUMN__EMPLOYEE: 'Colaborador',
		DASHBOARD__EMPLOYEE_LIST__LABEL: 'Ranking de Colaboradores',
		DASHBOARD__EMPLOYEE_LIST__HEADER: 'Colaboradores',
		DASHBOARD__EMPLOYEE_LIST__SEARCH_PLACEHOLDER: 'Buscar um Colaborador',
		DASHBOARD__EMPLOYEE_LIST__COLUMN__NAME: 'Nome',
		DASHBOARD__EMPLOYEE_LIST__COLUMN__EVENTS: 'Eventos',
		DASHBOARD__EMPLOYEE_LIST__COLUMN__LAST_EVENT: 'Último evento',
		DASHBOARD__METRICS__DEVICES__TITLE: 'Dispositivos',
		DASHBOARD__METRICS__DEVICES__SUBTITLE: 'Dispositivos',
		DASHBOARD__METRICS__EVENTS__TITLE: 'Eventos',
		DASHBOARD__METRICS__EVENTS__SUBTITLE: 'Hoje',
		DASHBOARD__METRICS__CLIENTS__TITLE: 'Contas',
		DASHBOARD__METRICS__CLIENTS__SUBTITLE: 'Cadastradas',
		DASHBOARD__METRICS__ACTIVE_DEVICES__TITLE: 'Dispositivos',
		DASHBOARD__METRICS__ACTIVE_DEVICES__SUBTITLE: 'Ativos hoje',
		DASHBOARD__METRICS__EQUIPMENTS__TITLE: 'Equipamentos',
		DASHBOARD__METRICS__EQUIPMENTS__SUBTITLE: 'Cadastrados',
		DASHBOARD__METRICS__EMPLOYEES__TITLE: 'Colaboradores',
		DASHBOARD__METRICS__EMPLOYEES__SUBTITLE: 'Cadastrados',

		DASHBOARD_VISION__WELCOME: 'Seja Bem-Vindo!',
		DASHBOARD_VISION__DESCRIPTION: 'Gerenciamento Vision',
		DASHBOARD_VISION__EVENT_LIST__HEADER: 'Últimos eventos',
		DASHBOARD_VISION__EVENT_LIST__LABEL: 'Eventos do Dia',
		DASHBOARD_VISION__QUICK_ACCESS: 'Acesso rápido',
		DASHBOARD_VISION__CHART_TITLE: 'Eventos dos últimos 12 meses',

		DASHBOARD_VISION__LINKS__ENVIRONMENT_TITLE: 'Ambientes',
		DASHBOARD_VISION__LINKS__ENVIRONMENT_SUBTITLE: 'Cadastro',
		DASHBOARD_VISION__LINKS__CAMERA_TITLE: 'Câmeras',
		DASHBOARD_VISION__LINKS__CAMERA_SUBTITLE: 'Cadastro',
		DASHBOARD_VISION__LINKS__MONITOR_TITLE: 'Monitorar',
		DASHBOARD_VISION__LINKS__MONITOR_SUBTITLE: 'Câmera',
		DASHBOARD_VISION__LINKS__NOTIFICATIONS_TITLE: 'Notificações',
		DASHBOARD_VISION__LINKS__NOTIFICATIONS_SUBTITLE: 'Grupos de e-mails',
		DASHBOARD_VISION__LINKS__REPORTS_TITLE: 'Relatórios',
		DASHBOARD_VISION__LINKS__REPORTS_SUBTITLE: 'Eventos',
		DASHBOARD_VISION__LOCAL: 'Local',
		DASHBOARD_VISION__CAMERA: 'Local',
		DASHBOARD_VISION__START: 'Início',
		DASHBOARD_VISION__HOUR: 'Horário da Captura',
		DASHBOARD_VISION__END: 'Fim',
		DASHBOARD_VISION__DURATION: 'Duração',
		DASHBOARD_VISION__ENVIRONMENT: 'Ambiente',
		DASHBOARD_VISION__ALGORITHM: 'Engine',
		DASHBOARD_VISION__THRESHOLD: 'Limiar de Confiança',
		DASHBOARD_VISION__DEVICE: 'Câmera',

		DEVICE__ALIAS: 'Alias',
		DEVICE__SMART_DEVICES: 'Dispositivos Smart',
		DEVICE__DEVICES: 'Dispositivos',
		DEVICE__DEVICE: 'Dispositivo',
		DEVICE__TYPE: 'Tipo',
		DEVICE__PROFILE: 'Perfil',
		DEVICE__SERIAL_NUMBER: 'Núm. Serie',
		DEVICE__DEVICES_AVAILABLE: 'Dispositivos disponíveis',
		DEVICE__UID: 'UID',
		DEVICE__HARDWARE: 'Hardware',
		DEVICE__HARDWARE_VERSION: 'Versão de hardware',
		DEVICE__FIRMWARE__VERSION: 'Versão de firmware',
		DEVICE__FIRMWARE: 'Firmware',
		DEVICE__CLIENT_NAME: 'Conta',
		DEVICE__LOT: 'Lote',
		DEVICE__STAGE: 'Estágio',
		DEVICE__STATUS: 'Status',
		DEVICE__CONTRACT: 'Contrato',
		DEVICE__ACTION__FILTER: 'Filtrar dispositivos',
		DEVICE__NO_CLIENT_ASSOCIATED: 'Sem cliente associado',
		DEVICE__NO_ASSOCIATED: 'Não associado',
		DEVICE__PRODUCT: 'Produto',
		DEVICE__TYPE_PROFILE: 'Tipo / perfil',
		DEVICE__HARD_FIRM: 'Hard / Firm',
		DEVICE__MANUFACTURE_DATE: 'Data de fabricação',
		DEVICE__MANUFACTURE: 'Fabricação',
		DEVICE__ADDITIONAL_DATA: 'Dados adicionais',
		DEVICE__MESSAGE_CREATED: 'Dispositivo(s) adicionado com sucesso!',
		DEVICE__MESSAGE_UPDATED: 'Dispositivo(s) alterado(s) com sucesso!',
		DEVICE__MESSAGE_REMOVED: 'Dispositivo(s) excluído(s) com sucesso!',
		DEVICE__MESSAGE__NO_DEVICE_FOUND: 'Nenhum dispositivo foi encontrado.',
		DEVICE__CONNECT: 'Associar dispositivo',
		DEVICE__ASSOCIATIONS: 'Associações',
		DEVICE__HISTORY: 'Histórico',
		DEVICE__NEW_SMART_DEVICE: 'Novo dispositivo smart',
		DEVICE__SMART_DEVICE_DETAILS: 'Detalhes do dispositivo smart',
		DEVICE__SMART_DEVICE_DOCUMENTS: 'Documentos do dispositivo',
		DEVICE_DOCUMENTS_TIME: 'Hora',
		DEVICE_DOCUMENTS_DROP_DOCUMENT: 'Arraste seus documentos aqui',
		DEVICE_DOCUMENTS_FILES_READY: 'Arquivos prontos',
		DEVICE__IDENTIFY_DEVICE: 'Identificar dispositivo',
		DEVICE__IDENTIFICATION: 'Identificação',
		DEVICE__INTERACTION: 'Interação',
		DEVICE__LAST_COMMUNICATION_DATE: 'Data da última comunicação',
		DEVICE__LAST_COMMUNICATION_TIME: 'Hora da última comunicação',
		DEVICE__TYPE_SERIAL_NUMBER: 'Digitar número de série',
		DEVICE__MESSAGE_SCAN_QRCODES:
			'Encontre o QR Code no dispositivo e posicione-o na área abaixo',
		DEVICE__READ_QR_CODE: 'Ler QR Code',
		DEVICE__MESSAGE_TYPE_SERIAL_NUMBER:
			'Digite abaixo o número de série que se encontra próximo ao QR Code',
		DEVICE__SELECT: 'Selecionar',
		DEVICE__ASSOCIATE_DEVICES: 'Associar dispositivos',
		DEVICE__BULK_INSTRUCTIONS:
			'1. Mantenha todas as colunas e ordenação do template baixado, mesmo que alguns dispositivos não possuam todas as informações de cadastro;<br /><br />2. Os campos UID e Número de Série são obrigatórios. Não é possivel deixa-los sem informação única.',
		DEVICE__UPDATE_BATCH: 'Edição em lote',
		DEVICE__SYSTEM_FIELD: 'Campo do sistema',
		DEVICE__NEW_VALUE: 'Novo valor',
		DEVICE__CONTRACT_SELECT: 'Selecione um contrato',
		DEVICE__TITLE_ADD: 'Adicionar dispositivo',
		DEVICE__MESSAGE_ADD: 'Deseja adicionar novo dispositivo?',
		DEVICE__TITLE_UPDATE: 'Alterar dispositivo',
		DEVICE__MESSAGE_UPDATE: 'Deseja alterar o dispositivo?',
		DEVICE__TITLE_REMOVE: 'Excluir dispositivo',
		DEVICE__MESSAGE_REMOVE: 'Deseja realmente excluir o dispositivo?',
		DEVICES__TITLE_REMOVE_BATCH: 'Excluir dispositivo(s)',
		DEVICES__MESSAGE_REMOVE_BATCH: 'Deseja realmente excluir os dispositivos?',
		DEVICES__TITLE_ADD_BATCH: 'Adicionar dispositivo(s)',
		DEVICES__MESSAGE_ADD_BATCH: 'Deseja adicionar novo(s) dispositivo(s)?',
		DEVICES__TITLE_UPDATE_BATCH: 'Alterar dispositivos(s)',
		DEVICES__MESSAGE_UPDATE_BATCH:
			'Deseja alterar o(s) dispositivo(s) selecionado(s)?',
		DEVICES__MESSAGE_REMOVE:
			'Deseja excluir o(s) dispositivo(s) selecionado(s)?',

		DEVICE__MAINTENANCE__DOWNLOAD_FILE: 'Download arquivo',
		DEVICE__MAINTENANCE_TITLE_ADD: 'Adicionar manutenção',
		DEVICE__MAINTENANCE_MESSAGE_ADD: 'Deseja adicionar nova manutenção?',
		DEVICE__MAINTENANCE_TITLE_UPDATE: 'Alterar manutenção',
		DEVICE__MAINTENANCE_MESSAGE_UPDATE: 'Deseja alterar a manutenção?',
		DEVICE__MAINTENANCE_TITLE_REMOVE: 'Excluir manutenção',
		DEVICE__MAINTENANCE_MESSAGE_REMOVE:
			'Deseja realmente excluir a manutenção?',
		DEVICE__MAINTENANCE__MESSAGE_CREATED: 'Manuntenção adicionado com sucesso!',
		DEVICE__MAINTENANCE__MESSAGE_UPDATED: 'Manuntenção alterado com sucesso!',
		DEVICE__MAINTENANCE__MESSAGE_REMOVED: 'Manuntenção excluído com sucesso!',
		DEVICE__MAINTENANCE__MESSAGE_FILE_REMOVED: 'Arquivo excluído com sucesso!',
		DEVICE__DOCUMENT__MESSAGE_FILE_REMOVED:
			'Deseja realmente excluir o arquivo?',
		DEVICE__DOCUMENT_TITLE_REMOVE: 'Excluir documento',
		DEVICE__DOCUMENT_TITLE_ADD: 'Adicionar documento',
		DEVICE__DOCUMENT__MESSAGE_FILE_ADD: 'Deseja adicionar novo documento?',
		DEVICE__DOCUMENT_TITLE_UPDATE: 'Alterar documento',

		DEVICE__DOCUMENT__FILE_REMOVED: 'Deseja realmente excluir o arquivo?',
		DEVICE__DOCUMENT__MESSAGE_REMOVED: 'Documento excluído com sucesso!',
		DEVICE__DOCUMENT__MESSAGE_ERROR: 'Erro ao excluir documento!',
		DEVICE__DOCUMENT__MESSAGE_DELETED: 'Documento excluído com sucesso!',

		DEVICE__MAINTENANCE_INFORMATION: 'Informações',
		DEVICE_MAINTENANCE_DOCUMENTS: 'Documentos',
		DEVICE_MAINTENANCE: 'Manutenção',
		DEVICE_MAINTENANCE__DATE: 'Data',
		DEVICE_MAINTENANCE__START_DATE: 'Data de início',
		DEVICE_MAINTENANCE__END_DATE: 'Data de término',
		DEVICE_MAINTENANCE__CREATE_DATE: 'Data de criação',
		DEVICE_MAINTENANCE__DATE_START: 'Data de início da manutenção',
		DEVICE_MAINTENANCE__WANTENTY_DATE: 'Data de garantia',
		DEVICE_MAINTENANCE__DATE_END: 'Data de término da manutenção',
		DEVICE_MAINTENANCE__TICKET: 'Ticket',
		DEVICE_MAINTENANCE__TYPE_SERVICE: 'Tipo atendimento',
		DEVICE__WARRANTY_MAINTENANCE: 'Garantia manutenção',
		DEVICE__OUT_WARRANTY: 'Fora da garantia',
		DEVICE__WARRANTY_CONTRACT_END: 'Término da garantia contratual',
		DEVICE__WARRANTY_MAINTENANCE_END: 'Término garantia manutenção',
		DEVICE__SUPPORT: 'Suporte',
		DEVICE__WARRANTY: 'Garantia',
		DEVICE__NO_DEFECT: 'Sem defeito',
		DEVICE__MISUSE: 'Mau uso',
		DEVICE__ACTION__MAINTENANCES_FILTER: 'Filtrar manutenções',
		DEVICE__ACTION__DOCUMENTS_FILTER: 'Filtrar documentos',
		DEVICE_DOCUMENTS_NAME: 'Nome do documento',
		DEVICE_DOCUMENTS_EXTENSION: 'Extensão',
		DEVICE__MAINTENANCE_HISTORY: 'Histórico de manutenções',
		DEVICE_MAINTENANCE__STATUS: 'Status',
		DEVICE__ADD: 'Adicionar',
		DEVICE__MAINTENANCE__ADD: 'Adicionar manutenção',
		DEVICE__MAINTENANCE__UPDATE: 'Atualizar manutenção',
		DEVICE__MAINTENANCE__REVOME: 'Remover manutenção',
		DEVICE__PROGRESS_START: 'Início de atendimento',
		DEVICE__CLAIMED_DEFECT: 'Defeito reclamado',
		DEVICE__DEFECT: 'Defeito',
		DEVICE__SOLUTION: 'Solução',
		DEVICE__REPORT: 'Laudo',
		DEVICE__ACTION__COMMENTS: 'Observações Gerais',
		DEVICE_MAINTENANCE_TYPE__RESOLVED: 'Resolvido',
		DEVICE_MAINTENANCE_TYPE__INPROGRESS: 'Em atendimento',
		DEVICE_MAINTENANCE_TYPE__UNRESOLVED: 'Não resolvido',
		DEVICE__DOCUMENT__MESSAGE_CREATED: 'Documento adicionado com sucesso!',
		DEVICE__DOCUMENT__MESSAGE_UPDATED: 'Documento alterado com sucesso!',
		DEVICE__DOCUMENTS__UPLOAD_FILES: 'Upload Arquivos do Dispositivo',
		DEVICE__MAINTENANCE__FILE_REMOVED: 'Arquivo excluído com sucesso!',
		DEVICE__DOCUMENTS: 'Documentos',

		DEVICE__PROFILE_SINGLE_POINT: 'SinglePoint',
		DEVICE__PROFILE_MULTI_POINT: 'MultiPoint',
		DEVICE__PROFILE_PORTAL: 'Portal',
		DEVICE__PROFILE_ZONE_MAP: 'ZoneMap',
		DEVICE__PROFILE_CROSS_POINT: 'CrossPoint',
		DEVICE__ABOUT_DEFECT: 'Sobre o defeito',
		DEVICE__SOLUTIONS: 'Soluções',
		DEVICE__DOCUMENTS__ERROR_MESSAGE:
			'A soma dos arquivos não pode ser superior a 4MB',

		EMPLOYEE__EMPLOYEES: 'Colaboradores',
		EMPLOYEE__EMPLOYEE: 'Colaborador',
		EMPLOYEE__NAME: 'Nome',
		EMPLOYEE__PROFILE: 'Perfil',
		EMPLOYEE__REGISTRATION: 'Matrícula',
		EMPLOYEE__BIRTH_DATE: 'Data de nascimento',
		EMPLOYEE__PICTURE: 'Foto',
		EMPLOYEE__MESSAGE__FILE_SIZE_ERROR: 'O arquivo não pode ser superior a 4MB',
		EMPLOYEE__IMAGE__ERROR_MESSAGE: 'Imagem deve conter no máximo 1MB',
		EMPLOYEE__BRIGADIER: 'Brigadista',
		EMPLOYEE__UNIT: 'Unidade',
		EMPLOYEE__DEPARTMENT: 'Departamento',
		EMPLOYEE__DEVICE: 'Dispositivo',
		EMPLOYEE__FULL_NAME: 'Nome completo',
		EMPLOYEE__SAFETY_TYPE: 'Segurança',
		EMPLOYEE__STATUS: 'Status',
		EMPLOYEE__FILTER_EMPLOYEE: 'Filtrar colaboradores',
		EMPLOYEE__CLIENT_NAME: 'Conta',
		EMPLOYEE__MESSAGE_CREATED: 'Colaborador adicionado com sucesso!',
		EMPLOYEE__MESSAGE_UPDATED: 'Colaborador(es) alterado(s) com sucesso!',
		EMPLOYEE__MESSAGE_REMOVED: 'Colaborador(es) excluído(s) com sucesso!',
		EMPLOYEE__PICTURE__REMOVED: 'Imagem excluída com sucesso!',
		EMPLOYEE__MESSAGE__DOCUMENT_FILE_REMOVED: 'Arquivo excluído com sucesso!',
		EMPLOYEE__CIPA: 'Cipeiro',
		EMPLOYEE__ACTION__ASSOCIATE: 'Associações',
		EMPLOYEE__CONNECT: 'Associar',
		EMPLOYEE__ASSOCIATED_GROUPS: 'Grupos associados',
		EMPLOYEE__EVENT_HISTORY: 'Histórico eventos',
		EMPLOYEE__EVENT: 'Evento',
		EMPLOYEE__TIME: 'Horário',
		EMPLOYEE__NEW: 'Novo colaborador',
		EMPLOYEE__DETAILS: 'Detalhes do colaborador',
		EMPLOYEE__DOCUMENTS_UPLOADS: 'Upload Arquivos Colaborador',
		EMPLOYEE__DOCUMENTS: 'Documentos',
		EMPLOYEE__DOCUMENTS__ERROR_MESSAGE:
			'A soma dos arquivos não pode ser superior a 4MB',

		EMPLOYEE__BULK_INSTRUCTIONS:
			'1. Mantenha todas as colunas e ordenação do template baixado, mesmo que alguns colaboradores não possuam todas as informações de cadastro;<br /><br />2. Os campos Nome completo, matrícula e status são obrigatórios, sendo que a matrícula é única por colaborador.',
		EMPLOYEE__BULK_CREATED: 'Colaboradores adicionados com sucesso!',
		EMPLOYEE__BATCH_UPDATE: 'Edição em lote',
		EMPLOYEE__SYSTEM_FIELD: 'Campo do sistema',
		EMPLOYEE__NEW_VALUE: 'Novo valor',
		EMPLOYEE_STATUS__ACTIVE: 'Ativo',
		EMPLOYEE_STATUS__INACTIVE: 'Inativo',
		EMPLOYEE__TITLE_ADD: 'Adicionar colaborador',
		EMPLOYEE__MESSAGE_ADD: 'Deseja adicionar novo colaborador?',
		EMPLOYEE__TITLE_UPDATE: 'Alterar colaborador',
		EMPLOYEE__MESSAGE_UPDATE: 'Deseja alterar o colaborador?',
		EMPLOYEE__TITLE_REMOVE: 'Excluir colaborador',
		EMPLOYEE__MESSAGE_REMOVE: 'Deseja realmente excluir o colaborador?',
		EMPLOYEES__TITLE_ADD_BATCH: 'Adicionar colaborador(es)',
		EMPLOYEES__MESSAGE_ADD_BATCH: 'Deseja adicionar novo(s) colaborador(es)?',
		EMPLOYEES__TITLE_UPDATE_BATCH: 'Alterar colaborador(es)',
		EMPLOYEES__MESSAGE_UPDATE_BATCH: 'Deseja alterar o(s) colaborador(es)?',
		EMPLOYEES__TITLE_REMOVE_BATCH: 'Excluir colaborador(es)',
		EMPLOYEES__MESSAGE_REMOVE_BATCH:
			'Deseja realmente excluir o(s) colaborador(es)?',

		EMPLOYEE__DOCUMENT_TITLE_REMOVE: 'Excluir documento',
		EMPLOYEE__DOCUEMNT_MESSAGE_REMOVE: 'Deseja realmente excluir o documento?',
		EMPLOYEE__TITLE_DOWNLOAD: 'Download documento',
		EMPLOYEE__MESSAGE_DOWNLOAD: 'Deseja realmente baixar o documento?',

		EQUIPMENT__EQUIPMENTS: 'Equipamentos',
		EQUIPMENT__EQUIPMENT: 'Equipamento',
		EQUIPMENT__NAME: 'Nome',
		EQUIPMENT__TYPE: 'Tipo',
		EQUIPMENT__UNIT: 'Unidade',
		EQUIPMENT__DEPARTMENT: 'Departamento',
		EQUIPMENT__DEVICE: 'Dispositivo',
		EQUIPMENT__STATUS: 'Status',
		EQUIPMENT__EVENT: 'Evento',
		EQUIPMENT__TIME: 'Horário',
		EQUIPMENT__FILTER_EQUIPMENT: 'Filtrar equipamentos',
		EQUIPMENT__NEW: 'Novo equipamento',
		EQUIPMENT__DETAILS: 'Detalhes do equipamento',
		EQUIPMENT__ACTION__ASSOCIATE: 'Associações',
		EQUIPMENT__CONNECT: 'Associar',
		EQUIPMENT__CLIENT_NAME: 'Conta',
		EQUIPMENT__ACTIVE__NUMBER: 'Nº Ativo',
		EQUIPMENT__MANUFACTURER: 'Fabricante',
		EQUIPMENT__YEAR__MANUFACTURER: 'Ano fabricação',
		EQUIPMENT__EVENT__HISTORY: 'Histórico eventos',
		EQUIPMENT__MODEL: 'Modelo',
		EQUIPMENT__ASSOCIATED_GROUPS: 'Grupos associados',
		EQUIPMENT__MESSAGE_CREATED: 'Equipamento adicionado com sucesso!',
		EQUIPMENT__MESSAGE_UPDATED: 'Equipamento(s) alterado(s) com sucesso!',
		EQUIPMENT__MESSAGE_REMOVED: 'Equipamento(s) excluído(s) com sucesso!',
		EQUIPMENT__UPDATE_BATCH: 'Edição em lote',
		EQUIPMENT__SYSTEM_FIELD: 'Campo do sistema',
		EQUIPMENT__NEW_VALUE: 'Novo valor',
		EQUIPMENTS__TITLE_ADD_BATCH: 'Adicionar equipamento(s)',
		EQUIPMENTS__MESSAGE_ADD_BATCH: 'Deseja adicionar novo(s) equipamento(s)?',
		EQUIPMENTS__TITLE_UPDATE_BATCH: 'Alterar equipamento(s)',
		EQUIPMENTS__MESSAGE_UPDATE_BATCH: 'Deseja alterar o(s) equipamento(s)?',
		EQUIPMENTS__TITLE_REMOVE_BATCH: 'Excluir equipamento(s)',
		EQUIPMENTS__MESSAGE_REMOVE_BATCH:
			'Deseja realmente excluir o(s) equipamento(s)?',

		EQUIPMENT__BULK_INSTRUCTIONS:
			'1. Mantenha todas as colunas e ordenação do template baixado, mesmo que alguns equipamentos não possuam todas as informações de cadastro; 2. Os campos nome, tipo e status são obrigatórios. Sendo que o tipo você deve escolher entre as opções pré-definidas no cadastro individual.',
		EQUIPMENT__BULK_CREATED: 'Equipmentos adicionados com sucesso!',

		EQUIPMENT__DOCUMENT: 'Documento',
		EQUIPMENT__DOCUMENTS__UPLOAD_FILES: 'Upload Arquivos Equipamento',
		EQUIPMENT__DOCUMENTS__ERROR_MESSAGE:
			'A soma dos arquivos não pode ser superior a 4MB',
		EQUIPMENT__DOCUMENTS: 'Documentos',

		ENGINES: 'Engines',
		ENGINE: 'Engine',
		ENGINE__LIST: 'Gestão de Engines',
		ENGINE__VERSION: 'Versão',
		ENGINE__NAME: 'Nome',
		ENGINE__TYPE: 'Tipo',
		ENGINE__STAGE: 'Estágio',
		ENGINE__IN_DEVELOPMENT: 'Em desenvolvimento',
		ENGINE__IN_TESTS: 'Em testes',
		ENGINE__STANDART: 'Standard',
		ENGINE__CUSTOM: 'Custom',
		ENGINE__APPROVED: 'Aprovado',
		ENGINE__ACCOUNT: 'Conta',
		ENGINE__ACCOUNTS: 'Contas',
		ENGINE__STATUS: 'Status',
		ENGINE__STATUS_ACTIVE: 'Ativo',
		ENGINE__STATUS_INACTIVE: 'Inativo',
		ENGINE__FILTER_ENGINES: 'Filtrar Engines',
		ENGINE__DETAILS_ENGINE: 'Detalhes da Engine',
		ENGINE__DETAILS: 'Detalhes',
		ENGINE__PARAMETERS: 'Parâmetros',
		ENGINE__GENERAL_INFORMATIONS: 'Informações Gerais',
		ENGINE__RELEASE: 'Liberação',
		ENGINE__LAST_UPDATE: 'Última Atualização',
		ENGINE__DESCRIPTION: 'Descrição',
		ENGINE__LICENSE: 'Licença',
		ENGINE__LICENSE_KEY: 'Chave de Licença',
		ENGINE__CLASS: 'Classes',
		ENGINE__VALUE: 'Valor',
		ENGINE_CLASS_ID: 'ID da Classe',
		ENGINE__OBS: 'Observações',
		ENGINE__DOCUMENTATIONS: 'Documentações',
		ENGINE__PARAMETER: 'Parâmetro',
		ENGINE__MODEL: 'Modelo',
		ENGINE__CHANGELOG: 'Changelog',
		ENGINE__COMMENTS: 'Comentários',
		ENGINE__INCLUDE_PARAMETER: 'Incluir Parâmetro',
		ENGINE__PARAMETER_DATA: 'Dados do Parâmetro',
		ENGINE__PARAMETER_REQUIRED: 'Parâmentro é obrigatório',
		ENGINE__VALUE_REQUIRED: 'Valor é obrigatório',
		ENGINE__CONTRACT: 'Contrato',
		ENGINE__FILTER_ACCOUNTS: 'Filtrar Contas',
		ENGINE__INIT: 'Início',
		ENGINE__END: 'Fim',
		ENGINE__SELECT_AN_CONTRACT: 'Selecione um contrato',
		ENGINE__SELECT_AN_ACCOUNT: 'Selecione uma conta',
		ENGINE__INCLUDE_ACCOUNT: 'Incluír Conta',
		ENGINE__ACCOUNT_DATA: 'Dados da Conta',
		ENGINE__CONTRACT_REQUIRED: 'Contrato é obrigatório',
		ENGINE__ACCOUNT_REQUIRED: 'Conta é obrigatória',
		ENGINE__NEW_ENGINE: 'Nova engine',
		ENGINE__CREATE_SUCCESS: 'Engine criada com sucesso!',
		ENGINE__CREATE_ERROR: 'Erro ao criar engine!',
		ENGINE__DELETE_ERROR: 'Erro ao remover a engine!',
		ENGINE__DELETE_SUCCESS: 'Engine removida com sucesso!',
		ENGINE__UPDATE_SUCCESS: 'Engine atualizada com sucesso!',
		ENGINE__UPDATE_ERROR: 'Erro ao atualizar engine!',
		ENGINE__TITLE_ADD: 'Adicionar engine',
		ENGINE__MESSAGE_ADD: 'Deseja adicionar nova engine?',
		ENGINE__TITLE_UPDATE: 'Alterar engine',
		ENGINE__MESSAGE_UPDATE: 'Deseja alterar engine?',
		ENGINE__TITLE_REMOVE: 'Excluir engine',
		ENGINE__MESSAGE_REMOVE: 'Deseja excluir engine?',
		ENGINE__ACTION__FILTER: 'Filtrar engines',
		ENGINE__CLASS_NAME: 'Nome da Classe',
		ENGINE__CLASS_DESCRIPTION: 'Descrição da Classe',
		ENGINE__CLASS_PRECISION: 'Precisão da Classe',
		ENGINE__CLASS_TIMEOUT: 'Tempo de execução',
		ENGINE__VALUE_SELECTION: 'Seleção de Valor',
		ENGINE__RELIABILIY_LEVEL: 'Nível de confiabilidade',
		ENGINE__PERCENTAGE: 'Porcentagem %',
		ENGINE__TIGGER_TIMEOUT: 'Tempo de Disparo',
		ENGINE__SECONDS: 'Segundos',
		ENGINE__EXPIRED: 'Expirado',
		ENGINE__NEAR_EXPIRED: 'Próximo a Expirar',
		ENGINE__ACTIVE: 'Ativo',

		FIRMWARE__FIRMWARES: 'Firmwares',
		FIRMWARE__COMPATIBLE_FIRMWARES: 'Firmwares compatíveis',
		FIRMWARE__NAME: 'Nome',
		FIRMWARE__NEW_FIRMWARE: 'Novo firmware',
		FIRMWARE__REGISTRATION: 'Cadastro',
		FIRMWARE__STAGE: 'Estágio',
		FIRMWARE__VERSION: 'Versão',
		FIRMWARE__RELEASE_DATE: 'Data liberação',
		FIRMWARE__EXPIRATION_DATE: 'Data expiração',
		FIRMWARE__BOARDS: 'Boards',
		FIRMWARE__DOCUMENTATION: 'Documentação',
		FIRMWARE__CHANGELOG: 'Changelog',
		FIRMWARE__COMMENTS: 'Comentários',
		FIRMWARE__COMPATIBILITY: 'Compatibilidade',
		FIRMWARE__PRODUCT: 'Produto',
		FIRMWARE__FEATURES: 'Features',
		FIRMWARE__DETAIL: 'Detalhe do firmware',
		FIRMWARE__DETAILS: 'Detalhes do firmware',
		FIRMWARE__FILTER_FIRMWARES: 'Filtrar firmwares',
		FIRMWARE__FIRMWARES_REPOSITORY: 'Repositório de firmwares',
		FIRMWARE__FILE: 'Arquivo Firmware',
		FIRMWARE__PREVIEW: 'Preview',
		FIRMWARE__MESSAGE_FILE_SIZE_LIMIT: 'O arquivo não pode ser superior a 4MB',
		FIRMWARE__DOCUMENTATION_FILE: 'Arquivo documentação',
		FIRMWARE__MESSAGE_CREATED: 'Firmware adicionado com sucesso!',
		FIRMWARE__MESSAGE_UPDATED: 'Firmware alterado com sucesso!',
		FIRMWARE__MESSAGE_REMOVED: 'Firmware excluído com sucesso!',
		FIRMWARE__MESSAGE_FILE_REMOVED: 'Arquivo excluído com sucesso!',
		FIRMWARE__TITLE_ADD: 'Adicionar firmware',
		FIRMWARE__MESSAGE_ADD: 'Deseja adicionar novo firmware?',
		FIRMWARE__TITLE_UPDATE: 'Alterar firmware',
		FIRMWARE__MESSAGE_UPDATE: 'Deseja alterar firmware?',
		FIRMWARE__TITLE_REMOVE: 'Excluir firmware',
		FIRMWARE__MESSAGE_REMOVE: 'Deseja excluir firmware?',

		HELLO__MESSAGE: 'Olá',

		HELPER_CENTER: 'Help Center',
		HELPER__HELPER_OPTIONS: 'Opções de ajuda',
		HELPER_SUPPORT: 'Suporte',
		HELPER__TICKET: 'Ticket',
		HELPER__BASE_OF: 'Base de',
		HELPER__KNOWLEDGE: 'Knowledge',
		HELPER__DOCUMENTATION: 'Documentação',
		HELPER__API_CONSULT: 'Consultar API',
		HELPER__INFO_TITLE: 'Se preferir, fale conosco!',
		HELPER__INFO_DESCRIPTION:
			'Caso nenhuma das opções de ajuda acima lhe auxiliaram, entre em contato conosco através dos canais de comunicação ao lado:',
		HELPER__DESCRIPTION_DOCUMENTATION:
			'Documentação pensada nos times de desenvolvimento e TI, para facilitar os processos de integrações.',
		HELPER__DESCRIPTIONS:
			'Artigos e documentos em uma vasta base de dados a respeito das ferramentas do sistema e otimização de resultados.',
		HELPER__OPEN_CALL_DESCRIPTIONS:
			'Abra solicitações e chamados para assuntos de assistência técnica, financeiro ou suporte.',

		INTEGRATION__INTEGRATIONS: 'Integrações',
		INTEGRATION__NAME: 'Nome',
		INTEGRATION__ACCOUNT: 'Conta',
		INTEGRATION__STATUS: 'Status',
		INTEGRATION__FILTER_ACTIONS: 'Filtrar integrações',
		INTEGRATION__INTEGRATION_DETAILS: 'Detalhes da integração',
		INTEGRATION__IDENTIFICATION: 'Identificação',
		INTEGRATION__ACCESS: 'Acesso',
		INTEGRATION__URL_SANDBOX: 'URL sandbox',
		INTEGRATION__URL_PRODUCTION: 'URL produção',
		INTEGRATION__CREDENTIAL: 'Credencial',
		INTEGRATION__TOKEN: 'Token',
		INTEGRATION__COPY_SECRET_KEY:
			'Copie esta chave e utilize-a na autenticação da API. Esta chave não aparecerá novamente.',
		INTEGRATION__PERMISSIONS: 'Permissões',
		INTEGRATION__NEW_INTEGRATION: 'Nova integração',
		INTEGRATION__CONTENT_COPIED: 'Conteúdo copiado!',
		INTEGRATION__MESSAGE_CREATED: 'Integração adicionada com sucesso!',
		INTEGRATION__MESSAGE_UPDATED: 'Integração alterada com sucesso!',
		INTEGRATION__MESSAGE_REMOVED: 'Integração excluída com sucesso!',

		LOG_SCHEMA__LOG_SCHEMAS: 'Esquemas de log',
		LOG_SCHEMA__LOG_SCHEMA: 'Esquema de log',
		LOG_SCHEMA__FILTER_LOG_SCHEMAS: 'Filtrar esquemas de logs',
		LOG_SCHEMA__NAME: 'Nome',
		LOG_SCHEMA__CODE_LOG: 'Code log',
		LOG_SCHEMA__DESCRIPTION: 'Descrição',
		LOG_SCHEMA__JSON_SCHEMAS: 'Esquemas JSON',
		LOG_SCHEMA__LOG_EXAMPLE: 'Exemplo de log',
		LOG_SCHEMA__LOG_DEFINITION: 'Definição do log',
		LOG_SCHEMA__LOG_METADATA: 'Metadados do log',
		LOG_SCHEMA__LABEL: 'Label',
		LOG_SCHEMA__PROPERTY: 'Propriedade',
		LOG_SCHEMA__TYPE: 'Tipo',
		LOG_SCHEMA__FIXED_VALUE: 'Valor fixo',
		LOG_SCHEMA__OUTPUT: 'Output',
		LOG_SCHEMA__MESSAGE_LOG: 'Mensagem de log',
		LOG_SCHEMA__MESSAGE_LOG_TEMPLATE: 'Template de mensagem de log',
		LOG_SCHEMA__USE_VARIABLES_IN_FORMAT: 'Utilize variáveis no formato',
		LOG_SCHEMA__GENERATED_LOG_MESSAGE: 'Mensagem de log gerada',
		LOG_SCHEMA__ACKNOWLEDGE: 'Acknowledge',
		LOG_SCHEMA__SUCCESS_ACK: 'ACK sucesso',
		LOG_SCHEMA__ERROR_ACK: 'ACK erro',
		LOG_SCHEMA__GENERATED_ERROR_ACK: 'ACK erro gerado',
		LOG_SCHEMA__MAIN_UID: 'UID principal',
		LOG_SCHEMA__EVENT_DATE: 'Data evento',
		LOG_SCHEMA__NEW_LOG_SCHEMA: 'Novo esquema de log',
		LOG_SCHEMA__LOG_SCHEMA_DETAILS: 'Detalhes do esquema de log',
		LOG_SCHEMA__MESSAGE_CREATED: 'Esquema de log adicionado com sucesso!',
		LOG_SCHEMA__MESSAGE_UPDATED: 'Esquema de log alterado com sucesso!',
		LOG_SCHEMA__MESSAGE_REMOVED: 'Esquema de log excluído com sucesso!',
		LOG_SCHEMA__TITLE_ADD: 'Adicionar esquema de log',
		LOG_SCHEMA__MESSAGE_ADD: 'Deseja adicionar novo esquema de log?',
		LOG_SCHEMA__TITLE_UPDATE: 'Alterar esquema de log',
		LOG_SCHEMA__MESSAGE_UPDATE: 'Deseja alterar esquema de log?',
		LOG_SCHEMA__TITLE_REMOVE: 'Excluir esquema de log',
		LOG_SCHEMA__MESSAGE_REMOVE: 'Deseja excluir esquema de log?',
		LOG_SCHEMA__PRIORITY:
			'Esquemas com prioridade alta serão processados antes para os logs recebidos',
		LOG_SCHEMA__TIMESTAMP: 'Timestamp',
		LOG_SCHEMA__UID: 'UID',
		LOG_SCHEMA_BATTERY: 'Bateria',
		LOG_SCHEMA__DEVICE_BATTERY: 'Dispositivo da bateria',
		LOG_SCHEMA__DRIVER_UID: 'Motorista',
		LOG_SCHEMA__KEEP_ALIVE: 'Keep Alive',
		LOG_SCHEMA__VALUE: 'Valor',

		LOG_TYPE__EVENT_ERROR_INFORMATIVE: 'Informativo',
		LOG_TYPE__EVENT_ERROR_ALERT: 'Alerta',
		LOG_TYPE__EVENT_ERROR_CRITICAL: 'Erro crítico',
		LOG_TYPE__EVENT_ERROR_SUPER_CRITICAL: 'Crítico',
		LOG_TYPE__EVENT_NO_ERROR_INFORMATION: 'Sem informação de erro',
		LOG_TYPE__TYPE_ERROR: 'Tipo de erro',
		LOG_TYPE__LOG_TYPES: 'Tipos de log',
		LOG_TYPE__LOG_TYPE: 'Tipo de log',
		LOG_TYPE__CODE: 'Code Log',
		LOG_TYPE__NAME: 'Nome',
		LOG_TYPE__ONE: 'Tipo 1',
		LOG_TYPE__TWO: 'Tipo 2',
		LOG_TYPE__ACTION__FILTER: 'Filtrar tipos de logs',
		LOG_TYPE__DESCRIPTION: 'Descrição',
		LOG_TYPE__UNIT: 'Unidade',
		LOG_TYPE__MESSAGE_CREATED: 'Tipo de log adicionado com sucesso!',
		LOG_TYPE__MESSAGE_UPDATED: 'Tipo de log alterado com sucesso!',
		LOG_TYPE__MESSAGE_REMOVED: 'Tipo de log excluído com sucesso!',
		LOG_TYPE__TITLE_ADD: 'Adicionar tipo de log',
		LOG_TYPE__MESSAGE_ADD: 'Deseja adicionar novo tipo de log?',
		LOG_TYPE__TITLE_UPDATE: 'Atualizar tipo de log',
		LOG_TYPE__MESSAGE_UPDATE: 'Deseja alterar tipo de log?',
		LOG_TYPE__TITLE_REMOVE: 'Excluir tipo de log',
		LOG_TYPE__MESSAGE_REMOVE: 'Deseja excluir tipo de log?',

		MENU__EXIT: 'Sair',
		MENU__GROUP__REGISTRATION: 'Cadastros',
		MENU__GROUP__VISION: 'Vision',
		MENU__GROUP__MONITORING: 'Análises',
		MENU__GROUP__DATA: 'Dados',
		MENU__GROUP__EXTRA: 'Extra',
		MENU__HOME__TITLE: 'Home',
		MENU__NOTIFICATIONS__TITLE: 'Notificações',
		MENU__USERS__TITLE: 'Usuários',
		MENU__USERS__DESCRIPTION: 'Gestão',
		MENU__CAMERAS__TITLE: 'Câmeras',
		MENU__VISION__MONITORING__TITLE: 'Monitorar',
		MENU__CLIENTS__TITLE: 'Contas',
		MENU__CLIENTS__DESCRIPTION: 'Gestão',
		MENU__CLIENT__TITLE: 'Minha conta',
		MENU__CLIENT__DESCRIPTION: 'Gestão',
		MENU__DEVICES__TITLE: 'Dispositivos',
		MENU__DEVICES__DESCRIPTION: 'Smart',
		MENU__ENGINES__TITLE: 'Engines VS',
		MENU__INTEGRATION__TITLE: 'Integrações',
		MENU__INTEGRATION__DESCRIPTION: 'Cadastro',
		MENU__ACTIONS__TITLE: 'Actions',
		MENU__ACTIONS__DESCRIPTION: 'Cadastro',
		MENU__PLACES__TITLE: 'Ambientes',
		MENU__PLACES__DESCRIPTION: 'Cadastro',
		MENU__EMPLOYEES__TITLE: 'Colaboradores',
		MENU__EMPLOYEES__DESCRIPTION: 'Cadastro',
		MENU__EQUIPMENTS__TITLE: 'Equipamentos',
		MENU__EQUIPMENTS__DESCRIPTION: 'Cadastro',
		MENU__PERMISSION_GROUPS__TITLE: 'Grupos de permissão',
		MENU__PERMISSION_GROUPS__DESCRIPTION: 'Cadastro',
		MENU__PRODUCTS__TITLE: 'Produtos',
		MENU__PRODUCTS__DESCRIPTION: 'Cadastro',
		MENU__LOG_TYPES__TITLE: 'Tipos de log',
		MENU__LOG_TYPES__DESCRIPTION: 'Cadastro',
		MENU__ZONEMAP__TITLE: 'Zone Map',
		MENU__ZONEMAP__DESCRIPTION: 'Monitoramento',
		MENU__BRIGADIER_PANEL__TITLE: 'Painel Brigadista',
		MENU__BRIGADIER_PANEL__DESCRIPTION: 'Monitoramento',
		MENU__MONITORING__TITLE: 'Status dos dispositivos',
		MENU__MONITORING__DESCRIPTION: 'Monitoramento',
		MENU__SYNOPTIC__TITLE: 'Sinóptico',
		MENU__SYNOPTIC__ANALYTIC__TITLE: 'Sinóptico Analítico',
		MENU__SYNOPTIC__DESCRIPTION: 'Monitoramento',
		MENU__REPORTS__TITLE: 'Relatórios',
		MENU__REPORTS__DESCRIPTION: 'Histórico',
		MENU__INSIGHTS__TITLE: 'Data Insight',
		MENU__INSIGHTS__DESCRIPTION: 'Histórico',
		MENU__SEARCH_DEVICE__TITLE: 'Identificar dispositivo',
		MENU__SEARCH_DEVICE__DESCRIPTION: 'Busca',
		MENU__FIRMWARES__TITLE: 'Firmwares',
		MENU__FIRMWARES__DESCRIPTION: 'Cadastro',
		MENU__BOARDS__TITLE: 'Boards',
		MENU__BOARDS__DESCRIPTION: 'Cadastro',
		MENU__TAGS__TITLE: 'Tags',
		MENU__TAGS__DESCRIPTION: 'Cadastro',
		MENU__LOG_SCHEMAS__TITLE: 'Esquemas log',
		MENU__LOG_SCHEMAS__DESCRIPTION: 'Cadastro',
		MENU__MODULES__TITLE: 'Módulos',

		MODALITY_TYPES__RENTAL: 'Locação',
		MODALITY_TYPES__SALE: 'Venda',

		MODULE_SELECTION__ACCESS: 'Acessar',
		MODULE_SELECTION__WELCOME: 'Seja Bem-Vindo!',
		MODULE_SELECTION__DESCRIPTION: 'Selecione um dos produtos A4 Solutions',
		MODULE_SELECTION__SMART_SAFETY_DESCRIPTION:
			'Solução para aumentar a  segurança no trabalho que monitora a posição de pessoas em áreas de risco.',
		MODULE_SELECTION__VISION_DESCRIPTION:
			'Com o VISION você pode extrair informações de negócios através de imagens estáticas ou monitoramento em tempo real.',

		MONITORING__MONITORING: 'Monitoramento',
		MONITORING__EVENT_HISTORY: 'Histórico de eventos',
		MONITORING__STATUS_DEVICES: 'Status dos dispositivos',
		MONITORING__TITLE: 'Status dos dispositivos',
		MONITORING__DASHBOARD: 'Dashboard',
		MONITORING__MONITOR_BY: 'Monitorar por',
		MONITORING__MONITOR: 'Monitorar',
		MONITORING__EMPLOYEES: 'Colaboradores',
		MONITORING__DATA_HOUR: 'Hora',
		MONITORING__EMPLOYEE__SUBTITLE: 'Todos os tipos de tags',
		MONITORING__FILTER_EMPLOYEES: 'Filtrar colaboradores',
		MONITORING__EQUIPMENT__SUBTITLE: 'Todos os dispositivos core',
		MONITORING__EQUIPMENT__FILTER: 'Filtrar equipamentos',
		MONITORING__PERMISSION_GROUP: 'Grupos de permissão',
		MONITORING__PERMISSION_GROUP__SUBTITLE: 'Dispositivos de um grupo',
		MONITORING__PERMISSION_GROUP__FILTER: 'Filtrar grupos de permissão',
		MONITORING__PLACES: 'Ambientes',
		MONITORING__PLACE__SUBTITLE: 'Dispositivos de um ambiente',
		MONITORING__PLACE__FILTER: 'Filtrar ambientes',
		MONITORING__ONLINE: 'Online',
		MONITORING__OFFLINE: 'Offline',
		MONITORING__WARNING: 'Warning',
		MONITORING__ACTIVE: 'Ativos',
		MONITORING__INACTIVE: 'Inativos',
		MONITORING__DEVICES: 'Dispositivos',
		MONITORING__EQUIPMENTS: 'Equipamentos',
		MONITORING__PERMISSION_GROUPS: 'Grupos de permissão',
		MONITORING__LAST_EVENTS: 'Últimos eventos',
		MONITORING__EVENT: 'Evento',
		MONITORING__START: 'Início',
		MONITORING__MIDIA: 'Mídia',
		MONITORING__TIME: 'Horário',
		MONITORING__CAMERA_FILTER: 'Filtrar câmeras',
		MONITORING__CAMERAS: 'Câmeras',
		MONITORING__CAMERA: 'Câmera',
		MONITORING__MOSAIC: 'Mosaico',
		MONITORING__CREATE_MOSAIC: 'Criar mosaico',
		MONITORING__MONITOR_CAMERA: 'Monitorar Câmera',
		MONITORING__MOSAIC_CAMERA: 'Monitorar Mosaico',
		MONITORING__MAX_MOSAIC: 'Limite máximo permitido é 6 cameras',

		NOTIFICATION__ALERT_PANIC: 'Alerta de Pânico',
		NOTIFICATION__EMPLOYEE: 'Colaborador',
		NOTIFICATION__REPORT_BY: 'Reportado por',
		NOTIFICATION__TIME: 'Horário',
		NOTIFICATION__MESSAGE_FINE: 'ESTÁ TUDO BEM?',
		NOTIFICATION__MESSAGE_NOTIFICATIONS:
			'Antes de fechar essa notificação, certifique-se que está tudo bem com os envolvidos.',
		NOTIFICATION__ALERT_CLOSE: 'Fechar Alerta',

		OPEN_TICKET: 'Abrir ticket',

		PERMISSION_GROUP__PERMISSION_GROUPS: 'Grupos de permissão',
		PERMISSION_GROUP__EMPLOYEES_GROUP: 'Grupos de colaboradores',
		PERMISSION_GROUP__EMPLOYEES: 'Colaboradores',
		PERMISSION_GROUP__EMPLOYEE: 'Colaborador',
		PERMISSION_GROUP__EQUIPMENTS_PLACES: 'Grupos de equipamentos / ambientes',
		PERMISSION_GROUP__EQUIPMENT_PLACE: 'Equipamento / Ambiente',
		PERMISSION_GROUP__PERMISSION_GROUP_DETAILS:
			'Detalhes do grupo de permissão',
		PERMISSION_GROUP__NAME: 'Nome',
		PERMISSION_GROUP__TYPE: 'Tipo',
		PERMISSION_GROUP__CREATED: 'Data',
		PERMISSION_GROUP__CLIENT: 'Cliente',
		PERMISSION_GROUP__ACCOUNT: 'Conta',
		PERMISSION_GROUP__NEW_PERMISSION_GROUP: 'Novo grupo de permissão',
		PERMISSION_GROUP__FILTER_PERMISSION_GROUP: 'Filtrar grupos de permissão',
		PERMISSION_GROUP__MESSAGE_CREATED:
			'Grupo de permissão adicionado com sucesso!',
		PERMISSION_GROUP__MESSAGE_UPDATED:
			'Grupo de permissão alterado com sucesso!',
		PERMISSION_GROUP__MESSAGE_REMOVED:
			'Grupo de permissão excluído com sucesso!',

		PERMISSION_GROUP_TITLE_ADD: 'Adicionar grupo de permissão',
		PERMISSION_GROUP_MESSAGE_ADD: 'Deseja adicionar novo grupo de permissão?',
		PERMISSION_GROUP_TITLE_UPDATE: 'Atualizar grupo de permissão',
		PERMISSION_GROUP_MESSAGE_UPDATE: 'Deseja atualizar grupo de permissão?',
		PERMISSION_GROUP_TITLE_REMOVE: 'Excluir grupo de permissão',
		PERMISSION_GROUP_MESSAGE_REMOVE: 'Deseja excluir grupo de permissão?',
		PERMISSION_GROUP_STATUS__ACTIVE: 'Ativo',
		PERMISSION_GROUP_STATUS__INACTIVE: 'Inativo',

		ACTIVE: 'Active',

		PLACE__PLACES: 'Ambientes',
		PLACE__PLACE: 'Ambiente',
		PLACE__NAME: 'Nome',
		PLACE__TYPE: 'Tipo',
		PLACE__TYPE__WAREHOUSE: 'Almoxarifado',
		PLACE__TYPE__REST_AREA: 'Área de Descanso',
		PLACE__TYPE__KITCHENETTE: 'Copa',
		PLACE__TYPE__STORAGE_SHED: 'Galpão',
		PLACE__TYPE__DINING_ROOM: 'Refeitório',
		PLACE__TYPE__LOUNGE: 'Sala',
		PLACE__CLIENT_NAME: 'Conta',
		PLACE__UNIT: 'Unidade',
		PLACE__DEPARTMENT: 'Departamento',
		PLACE__ACTION__STATUS: 'Status',
		PLACE__FILTER_PLACE: 'Filtrar ambientes',
		PLACE__ZONE_MAP: 'Zone Map',
		PLACE__ACTIVATE_ZONE_MAP: 'Ativar Zone map',
		PLACE__TIME_AVAILABLE_WEEK: 'Tempo Disponível na Semana (H)',
		PLACE__MAX_TIME_STAY: 'Tempo Máx. Permanência (m)',
		PLACE__BRIGADIER: 'Brigadista',
		PLACE__BRIGADIER_PANEL: 'Painel Brigadista',
		PLACE__ACTION__ACTIVATE_BRIGADIER_PANEL: 'Ativar Painel Brigadista',
		PLACE__MINIMUM_QUANTITY_CIPA: 'Quantidade Mínima Cipeiros',
		PLACE__BRIGADIER_MINIMUM_QUANTITY: 'Quantidade Mínima Brigadistas',
		PLACE__ACTION__ASSOCIATE: 'Associações',
		PLACE__ACTION__DEVICES_ASSOCIATED: 'Dispositivos associados',
		PLACE__CONNECT: 'Associar',
		PLACE__CONNECT_DEVICES: 'Associar dispositivos',
		PLACE__CONNECT_CAMERAS: 'Associar câmeras',
		PLACE__ASSOCIATED_GROUPS: 'Grupos associados',
		PLACE__EVENT_HISTORY: 'Histórico eventos',
		PLACE__EVENT: 'Evento',
		PLACE__TIME: 'Horário',
		PLACE__NEW: 'Novo ambiente',
		PLACE__DETAILS: 'Detalhes do ambiente',
		PLACE__MESSAGE_CREATED: 'Ambiente adicionado com sucesso!',
		PLACE__MESSAGE_UPDATED: 'Ambiente alterado com sucesso!',
		PLACE__MESSAGE_REMOVED: 'Ambiente excluído com sucesso!',
		PLACE__STATUS: 'Status',
		PLACE_STATUS__ACTIVE: 'Ativo',
		PLACE_STATUS__INACTIVE: 'Inativo',
		PLACE__TITLE_ADD: 'Adicionar ambiente',
		PLACE__MESSAGE_ADD: 'Deseja adicionar novo ambiente?',
		PLACE__TITLE_UPDATE: 'Atualizar ambiente',
		PLACE__MESSAGE_UPDATE: 'Deseja atualizar o ambiente?',
		PLACE__TITLE_REMOVE: 'Excluir ambiente',
		PLACE__DOCUMENT_TITLE_REMOVE: 'Excluir documento',
		PLACE__TITLE_DOWNLOAD: 'Download documento',
		PLACE__MESSAGE_REMOVE: 'Deseja excluir o ambiente?',
		PLACE__DOCUMENT_MESSAGE_REMOVE: 'Deseja excluir o documento?',
		PLACE__DOCUMENT__FILE_REMOVED: 'Documento excluído com sucesso!',
		PLACE__DOCUMENTS__ERROR_MESSAGE:
			'A soma dos arquivos não pode ser superior a 10MB',
		PLACE__DOCUMENTS__UPLOAD_FILES: 'Upload Arquivos Ambiente',
		PLACE__DOCUMENTS__DOCUMENT: 'Documento',
		PLACE__DOCUMENT_MESSAGE_DOWNLOAD: 'Deseja fazer download do documento?',

		PRODUCT__PRODUCTS: 'Produtos',
		PRODUCT__PRODUCT: 'Produto',
		PRODUCT__NAME: 'Nome',
		PRODUCT__PART_NUMBER: 'Part number',
		PRODUCT__ACTION__FILTER: 'Filtrar produtos',
		PRODUCT__TYPE: 'Tipo',
		PRODUCT__NEW: 'Novo produto',
		PRODUCT__DETAILS: 'Detalhes do produto',
		PRODUCT__PROFILES: 'Perfis',
		PRODUCT__MESSAGE_CREATED: 'Produto adicionado com sucesso!',
		PRODUCT__MESSAGE_UPDATED: 'Produto alterado com sucesso!',
		PRODUCT__MESSAGE_REMOVED: 'Produto excluído com sucesso!',
		PRODUCT__TITLE_ADD: 'Adicionar produto',
		PRODUCT__MESSAGE_ADD: 'Deseja adicionar novo produto?',
		PRODUCT__TITLE_UPDATE: 'Atualizar produto',
		PRODUCT__MESSAGE_UPDATE: 'Deseja atualizar produto?',
		PRODUCT__TITLE_REMOVE: 'Excluir produto',
		PRODUCT__MESSAGE_REMOVE: 'Deseja excluir produto?',

		REPORTS__REPORTS: 'Relatórios',
		REPORTS__ACCOUNTS: 'Contas',
		REPORTS__MANAGEMENT: 'Gestão',
		REPORTS__EMPLOYEES: 'Colaboradores',
		REPORTS__EQUIPMENTS: 'Equipamentos',
		REPORTS__PLACES: 'Ambientes',
		REPORTS__DEVICES: 'Dispositivos',
		REPORTS__SMART: 'Smart',
		REPORTS__GROUPS: 'Grupos',
		REPORTS__EVENTS: 'Eventos',
		REPORTS__REGISTER: 'Cadastro',
		REPORTS__EMPLOYEE_APPROXIMATION: 'Aproximação por colaborador',
		REPORTS__ALL_EVENTS: 'Todos os eventos',
		REPORTS__REPORT_EVENTS: 'Relatório de eventos',
		REPORTS__START_DATE: 'Data início',
		REPORTS__END_DATE: 'Data fim',
		REPORTS__DEVICE: 'Dispositivo',
		REPORTS__UID: 'UID',
		REPORTS__UID_TAG: 'UID Tag',
		REPORTS__PORTAL_UID: 'Portal - UID',
		REPORTS__EMPLOYEE: 'Colaborador',
		REPORTS__NAME: 'Nome',
		REPORTS__REGISTRATION: 'Matrícula',
		REPORTS__UNIT: 'Unidade',
		REPORTS__DEPARTMENT: 'Departamento',
		REPORTS__EQUIPMENT: 'Equipamento',
		REPORTS__ACTIVE_NUMBER: 'Nº Ativo',
		REPORTS__MAINTENANCE: 'Manutenção',
		REPORTS__MAINTENANCE_EVENTS: 'Eventos de manutenção',
		REPORTS__EVENT_PASSAGE: 'Eventos de passagem',
		REPORTS__EVENT_COD_LOG: 'Code logs: 508 e 509',

		SAFETY__DESCRIPTION_STEP1: 'Começe o processo',
		SAFETY__DESCRIPTION_STEP2: 'Tire sua self',
		SAFETY__DESCRIPTION_STEP3: 'Confirme a identificação',
		SAFETY__DESCRIPTION_STEP4: 'Pronto! Finalizado',
		SAFETY__CAPTURE_PHOTO: 'Reconhecer',
		SAFETY__INSTRUCTIONS:
			'Posicione seu rosto na área da foto e pressione o botão RECONHECER <br /> ou use a opção de identificação por MATRÍCULA.',
		SAFETY__EMPLOYEE_IDENTIFYING: 'Identificando colaborador...',
		SAFETY__REGISTRATION_NUMBER: 'Digite o número de sua matrícula!',
		SAFETY__LICENSE_PLATE: 'Digite a matrícula',
		SAFETY__IDENTIFY: 'Identificar',
		SAFETY__HELPER: 'Ajuda?',
		SAFETY__INSTRUCTION_PROCESS:
			'Confira os passos abaixo e faça o processo. Se continuar precisando de ajuda, utilize os botões abaixo:',
		SAFETY__PROCESS: 'Entendi, fazer o processo',
		SAFETY__EMPLOYEE: 'Olá, Colaborador!',
		SAFETY__MANDATORY_BRIGADIER_OR_EMPLOYEE:
			'Se você for Brigadista ou Cipeiro é obrigatório identificar-se. Confira o processo!',
		SAFETY__START: 'Começar',
		SAFETY__MESSAGE_ERROR: 'Não conseguimos identificar!',
		SAFETY__MESSAGE_CREATED: 'Identificação concluída com sucesso!',
		SAFETY__SELECT: 'Selecione uma das opções abaixo:',
		SAFETY__TRY_AGAIN: 'Tentar novamente',
		SAFETY__TYPE_IDENTIFICATION: 'Identificar com matrícula',
		SAFETY__VIEW_HELPER: 'Solicitar ajuda',
		SAFETY__REGISTRATION: 'Matrícula',
		SAFETY__EXIT: 'Saída',
		SAFETY__PROHIBITED: 'Entrada',
		SAFETY__CONFIRM: 'Sou eu, confirmar',
		SAFETY__REDO: 'Não sou eu, refazer',
		SAFETY__REGISTRATION_REDO: ' Não sou eu, refazer com matrícula',
		SAFATY__START_BACK: 'Voltando ao início em',

		SLOGAN_BOX__INFORMATION: 'Sua segurança, nosso patrimônio',
		SUPPORT__BASIC: 'Básico',
		SUPPORT__BUSINESS: 'Business',
		SUPPORT__NO_SUPPORT: 'Sem suporte',

		SYNOPTIC__SYNOPTIC: 'Sinóptico',
		SYNOPTIC__MAP: 'Mapa',
		SYNOPTIC__LEGEND: 'Legenda',
		SYNOPTIC__SECURITY_AREA: 'Área de segurança',
		SYNOPTIC__SECURITY_CROSSING: 'Faixa de pedestre',
		SYNOPTIC__ONLINE_DEVICE: 'Dispositivo online',
		SYNOPTIC__OFFLINE_DEVICE: 'Dispositivo off-line',
		SYNOPTIC__PASSAGE_EVENT: 'Evento de passagem',
		SYNOPTIC__EVENT_ERROR: 'Evento de erro',
		SYNOPTIC__EVENTS: 'Eventos',
		SYNOPTIC__EVENT: 'Evento',
		SYNOPTIC__SAFE_ZONE: 'Zona Segura',
		SYNOPTIC__ACCESS: 'Acessos',
		SYNOPTIC__EQUIPMENT: 'Empilhadeira',
		SYNOPTIC__TIME: 'Horário',
		SYNOPTIC__EMPLOYEE: 'Colaborador',
		SYNOPTIC__TF_PORTAL: 'Portal TF',

		SYNOPTIC__ANALYTIC_FORKLIFT_STOPS: 'PARADAS EMPILHADEIRAS',
		SYNOPTIC__ANALYTIC_ERROR_PASSAGE: 'PASSAGENS COM ERRO',
		SYNOPTIC__ANALYTIC_BATTERY: 'BATERIA',
		SYNOPTIC__ANALYTIC__EQUIPMENT: 'EMPILHADEIRA',
		SYNOPTIC__ANALYTIC__DEVICE: 'DISPOSITIVO',
		SYNOPTIC__ANALYTIC__ALERT: 'ALERTA',
		SYNOPTIC__ANALYTIC__EMPLOYEE: 'COLABORADOR',
		SYNOPTIC__ANALYTIC__APPROXIMATION: 'APROXIMAÇÃO',
		SYNOPTIC__ANALYTIC__DATE_HOUR: 'DATA/HORA',
		SYNOPTIC__ANALYTIC__PORTAL: 'PORTAL',
		SYNOPTIC__ANALYTIC__MSG: 'MENSAGEM',
		SYNOPTIC__ANALYTIC__CODE_LOG_122: 'Equipamento Aéreo',
		SYNOPTIC__ANALYTIC__CODE_LOG_131: 'TAG PLUS V3',
		SYNOPTIC__ANALYTIC__CODE_LOG_137: 'TAG STD V3',
		SYNOPTIC__ANALYTIC__CODE_LOG_140: '?',
		SYNOPTIC__ANALYTIC__CODE_LOG_510: 'Passagem entrada inválida',
		SYNOPTIC__ANALYTIC__CODE_LOG_513: 'Passagem de Saída Invalida',

		TAGS__TAGS: 'Tags',
		TAGS__TAG: 'Tag',
		TAGS__SCOPE: 'Escopo',
		TAGS__ACCOUNT: 'Conta',
		TAGS__GROUP: 'Grupo',
		TAGS__VALUE: 'Valor',
		TAGS__FILTER_TAGS: 'Filtrar tags',
		TAGS__TOTAL_REFERENCES: 'Total de referências',
		TAGS__NEW_TAG: 'Nova tag',
		TAGS__TAG_DETAILS: 'Detalhes da tag',
		TAGS__MESSAGE_UPDATED: 'Tag alterada com sucesso!',
		TAGS__MESSAGE_REMOVED: 'Tag excluída com sucesso!',
		TAGS__INSTRUCTIONS:
			'Digite um valor e pressione <strong>Enter</strong> para criar um novo item',
		TAGS__TITLE_REMOVE: 'Excluir tag',
		TAGS__MESSAGE_REMOVE: 'Deseja excluir a tag?',
		TAGS__SCOPE_APPLICATION: 'Aplicação',
		TAGS__SCOPE__APPLICATION_DESCRIPTION:
			'As tags são compartilhadas entre todos os clientes da aplicação',
		TAGS__SCOPE_CLIENT: 'Cliente',
		TAGS__SCOPE__CLIENT_DESCRIPTION:
			'As tags são compartilhadas somente para o mesmo cliente',
		TAGS__SCOPE_REGISTER: 'Cadastro',
		TAGS__SCOPE__REGISTER_DESCRIPTION:
			'As tags são compartilhadas somente para um cadastro em um cliente',

		USER__USERS: 'Usuários',
		USER__NAME: 'Nome',
		USER__ACCOUNT: 'Conta',
		USER__PROFILE: 'Perfil',
		USER__EMAIL: 'E-mail',
		USER__ACTION__FILTER: 'Filtrar usuários',
		USER__CLIENT: 'Cliente',
		USER_USER: 'Usuário',
		USER__NEW_USER: 'Novo usuário',
		USER__USER_DETAILS: 'Detalhes do usuário',
		USER__FULL_NAME: 'Nome completo',
		USER__CPF: 'CPF',
		USER__PHONE: 'Telefone',
		USER__MODULE: 'Módulos',
		USER__NEW_PASSWORD: 'Nova senha',
		USER__CONFIRM_PASSOWRD: 'Repita a senha',
		USER__MESSAGE_PASSWORD_ERROR: 'Senha não confere',
		USER__MESSAGE_CREATED: 'Usuário adicionado com sucesso!',
		USER__MESSAGE_UPDATE_USER:
			'Para aplicar as novas configurações de idioma, você será desconectado e precisará fazer login novamente. Obrigado pela compreensão',
		USER__MESSAGE_UPDATED: 'Usuário alterado com sucesso!',
		USER__MESSAGE_REMOVED: 'Usuário excluído com sucesso!',
		USER_STATUS__ACTIVE: 'Ativo',
		USER_STATUS__INACTIVE: 'Inativo',
		USER__MESSAGE_ADD: 'Deseja adicionar o usuário?',
		USER__MESSAGE_UPDATE: 'Deseja atualizar o usuário?',
		USER__TITLE_UPDATE: 'Atualizar usuário',
		USER__TITLE_ADD: 'Adicionar usuário',
		USER__TITLE_REMOVE: 'Excluir usuário',
		USER__MESSAGE_REMOVE: 'Deseja excluir o usuário?',
		USER__IDIOM: 'Idioma',
		USER__MESSAGE_CLIENT_WITHOUT__CONTRACT:
			'Não pode castrar usuário. Cliente não contém contrato ativo.',

		VISION__LIVE_CAMERA_TITLE: 'Monitor de câmera',
		VISION__CAMERA_LIST: 'Monitoramento',
		VISION__SELECTED_CAMERA: 'Câmera Selecionada',
		VISION__CAMERA_DATA: 'Dados da câmera',
		VISION__FAVORITE_CAMERA: 'Favoritar Câmera',
		VISION__CAMERA_AMBIENCE: 'Ambiente',
		VISION__INITIAL_HOUR: 'Hora',
		VISION__EVENT: 'Evento',
		VISION__MIDIA: 'Mídia',
		VISION__MONITORING__MONITOR: 'Monitorar',

		ZONE_MAP__ZONE_MAP: 'Zone Map',
		ZONE_MAP__ZONE_MAPS: 'Zone Maps',
		ZONE_MAP__NAME: 'Nome',
		ZONE_MAP__ACCOUNT: 'Conta',
		ZONE_MAP__TYPE: 'Tipo',
		ZONE_MAP__UNIT: 'Unidade',
		ZONE_MAP__DEPARTMENT: 'Departamento',
		ZONE_MAP__STATUS: 'Status',
		ZONE_MAP__STATUS__ACTIVE: 'Ativo',
		ZONE_MAP__STATUS__INACTIVE: 'Inativo',
		ZONE_MAP__FILTER_ZONES: 'Filtrar zonas',
		ZONE_MAP__ZONES: 'Zonas',
		ZONE_MAP__MONITOR: 'Monitorar',
		ZONE_MAP__MONITORING: 'Monitoramento',
		ZONE_MAP__DEVICES: 'Dispositivos',
		ZONE_MAP__IN_ZONE_NOW: 'Na Zona Agora',
		ZONE_MAP__MINUTES: 'Minutos',
		ZONE_MAP__MAX_STAY_TIME: 'Tempo Máximo Permanência',
		ZONE_MAP__STAY: 'Permanência',
		ZONE_MAP__FORCE_EXIT: 'Forçar saída',

		WELCOME_WELCOME: 'Obrigado',

		EQUIPMENT__FORKLIFT: 'Empilhadeira',
		EQUIPMENT__OVERHEAD_CRANE: 'Ponte Rolante',
		EQUIPMENT__TRUCK: 'Caminhão',
		EQUIPMENT__LOADER: 'Pá Carregadeira',
		EQUIPMENT__TRAIN: 'Trem',
		EQUIPMENT__AREA: 'Área',
		EQUIPMENT__CAR: 'Carro',
		EQUIPMENT__TRACTOR: 'Trator',
		EQUIPMENT__CRANE: 'Grua',
		EQUIPMENT__TITLE_ADD: 'Adicionar equipamento',
		EQUIPMENT__MESSAGE_ADD: 'Deseja adicionar novo equipamento?',
		EQUIPMENT__TITLE_UPDATE: 'Atualizar equipamento',
		EQUIPMENT__TITLE_DOWNLOAD: 'Download de documento',
		EQUIPMENT__MESSAGE_UPDATE: 'Deseja atualizar equipamento?',
		EQUIPMENT__TITLE_REMOVE: 'Excluir equipamento',
		EQUIPMENT__DOCUMENT_TITLE_REMOVE: 'Excluir documento',
		EQUIPMENT__MESSAGE_REMOVE: 'Deseja excluir equipamento?',
		EQUIPMENT__MESSAGE_ERROR_REMOVING_FILE: 'Erro ao excluir documento!',
		EQUIPMENT__DOCUMENT_MESSAGE_REMOVE: 'Deseja excluir documento?',
		EQUIPMENT__DOCUMENT_MESSAGE_DOWNLOAD: 'Deseja baixar documento?',
		EQUIPMENTS__TITLE_ADD: 'Adicionar equipamento(s)',
		EQUIPMENTS__MESSAGE_ADD: 'Deseja adicionar novo(s) equipamento(s)?',
		EQUIPMENTS__TITLE_UPDATE: 'Atualizar equipamento(s)',
		EQUIPMENTS__MESSAGE_UPDATE:
			'Deseja alterar o(s) equipamento(s) selecionado(s)?',
		EQUIPMENTS__TITLE_REMOVE: 'Excluir equipamento(s)',
		EQUIPMENTS__MESSAGE_REMOVE:
			'Deseja excluir o(s) equipamento(s) selecionado(s)?',
		EQUIPMENT__MESSAGE_REMOVED_FILE: 'Documento excluído com sucesso!',

		ACTION__ACTIVE: 'Ativo',
		ACTION__INACTIVE: 'Inativo',

		EQUIPMENT_STATUS__ACTIVE: 'Ativo',
		EQUIPMENT_STATUS__INACTIVE: 'Inativo',
		BRIGADIER_PANEL_STATUS__ACTIVE: 'Ativo',
		BRIGADIER_PANEL_STATUS__INACTIVE: 'Inativo',

		CONTRACT_STATUS__ACTIVE: 'Ativo',
		CONTRACT_STATUS__INACTIVE: 'Inativo',
		CONTRACT__TITLE_ADD: 'Adicionar contrato',
		CONTRACT__MESSAGE_ADD: 'Deseja adicionar novo contrato?',
		CONTRACT__TITLE_UPDATE: 'Atualizar contrato',
		CONTRACT__MESSAGE_UPDATE: 'Deseja atualizar contrato?',
		CONTRACT__TITLE_REMOVE: 'Excluir contrato',
		CONTRACT__MESSAGE_REMOVE: 'Deseja excluir contrato?',

		DEVICE_STAGE__PRODUCTION: 'Produção',
		DEVICE_STAGE__TEST: 'Teste',
		DEVICE_STAGE__STOCK: 'Estoque',
		DEVICE_STAGE__TRANSPORT: 'Transporte',
		DEVICE_STAGE__INSTALLED: 'Instalado',
		DEVICE_STATUS__ACTIVE: 'Ativo',
		DEVICE_STATUS__INACTIVE: 'Inativo',

		DEVICE_TYPE__CORE: 'Core',
		DEVICE_TYPE__TAG: 'Tag',
		DEVICE_TYPE__ACCESSORY: 'Acessório',
		DEVICE_TYPE__CAMERA: 'Câmera',
		DEVICE_TYPE__SOFTCORE: 'Softcore',

		BOARD_STAGES__TESTING: 'Em teste',
		BOARD_STAGES__APPROVED: 'Aprovado',
		BOARD_STAGES__NOT_APPROVED: 'Não aprovado',

		EVENT_LEVEL__ALERT: 'Alerta',
		EVENT_LEVEL__DANGER: 'Perigo',
		EVENT_LEVEL__INFORMATIVE: 'Informativo',

		EVENT_TYPE__APPROXIMATION: 'Aproximação',
		EVENT_TYPE__APPROXIMATION_4M: 'Aproximação 4 metros',
		EVENT_TYPE__APPROXIMATION_6M: 'Aproximação 6 metros',
		EVENT_TYPE__ENTRY: 'Entrada',
		EVENT_TYPE__EXIT: 'Saída',
		EVENT_TYPE__ERROR: 'Erro',

		FIRMWARE_STAGE__TESTING: 'Em teste',
		FIRMWARE_STAGE__APPROVED: 'Aprovado',
		FIRMWARE_STAGE__NOT_APPROVED: 'Reprovado',

		INTEGRATION_STATUS__ACTIVE: 'Ativo',
		INTEGRATION_STATUS__INACTIVE: 'Inativo',
		INTEGRATION__TITLE_ADD: 'Adicionar integração',
		INTEGRATION__MESSAGE_ADD: 'Deseja adicionar nova integração?',
		INTEGRATION__TITLE_UPDATE: 'Atualizar integração',
		INTEGRATION__MESSAGE_UPDATE: 'Deseja atualizar integração?',
		INTEGRATION__TITLE_REMOVE: 'Excluir integração',
		INTEGRATION__MESSAGE_REMOVE: 'Deseja excluir integração?',

		LANGUAGE__ENGLISH: 'Inglês',
		LANGUAGE__PORTUGUESE_BR: 'Português',
		LANGUAGE__SPANISH: 'Espanhol',

		LOG_PRIORITY__HIGH: 'Alta',
		LOG_PRIORITY__LOW: 'Baixa',

		LOG_TYPES__TEXT: 'Texto',
		LOG_TYPES__MEASUREMENT: 'Medida',
		LOG_TYPES__NULL: 'Nulo',
		LOG_TYPES__UID: 'UID',
		LOG_TYPES__TITLE_ADD: 'Adicionar tipo de log',
		LOG_TYPES__MESSAGE_ADD: 'Deseja adicionar novo tipo de log?',
		LOG_TYPES__TITLE_UPDATE: 'Atualizar tipo de log',
		LOG_TYPES__MESSAGE_UPDATE: 'Deseja atualizar tipo de log?',
		LOG_TYPES__TITLE_REMOVE: 'Excluir tipo de log',
		LOG__TYPES__TEMPERATURE: 'Temperatura',
	},
	en: {
		ACCESS_BASE: 'Access Database',
		ACCESS_PLATFORM: 'Access Platform',
		ACCESS__LOGIN: 'Login',
		ACCESS__RECOVER_PASSWORD: 'Recover Password',
		ACCESS__MESSAGE_ACCESS__RECOVER_PASSWORD_USER:
			'If this email is registered you will receive a link to recover your password!',
		ACCESS__REMEMBER_EMAIL: 'Remember Email',
		ACCESS__ACTION_BACK: 'Back to login',
		ACCESS__MESSAGE_ACCESS__RECOVER_PASSWORD:
			'We have sent you a password recovery email. Click on the link in the email and update it!',
		ACCESS__EMAIL_WAS_SENT_TO: 'An email has been sent to',
		ACCESS__REMEMBER_ACCOUNT: 'Remember email',
		ACCESS__EMAIL: 'Email',
		ACCESS__PASSWORD: 'Password',
		ACCESS__CPF: 'CPF',
		ACCESS__NEW_PASSWORD: 'New Password',
		ACCESS__CONFIRM_PASSWORD: 'Password does not match',
		ACCESS__CHANGE_PASSWORD: 'Update Password',
		ACCESS__RECOVERED_SUCCESS:
			'The password reset has been completed successfully.',
		ACCESS__NEW_PASSWORD_REPEAT: 'Repeat the new password',

		ACTION__ACTIONS: 'Actions',
		ACTION__NAME: 'Name',
		ACTION__ACCOUNT: 'Account',
		ACTION__TYPE: 'Type',
		ACTION__LANGUAGE: 'Language',
		ACTION__STATUS: 'Status',
		ACTION__FILTER_ACTIONS: 'Filter Actions',
		ACTION__CLIENT: 'Client',
		ACTION__ACTION: 'Action',
		ACTION__COMMENTS: 'General Comments',
		ACTION__PERMISSION_GROUPS: 'Permission Groups',
		ACTION__CODE: 'Code',
		ACTION__ACTION_TYPE: 'Action Type',
		ACTION__RETURN: 'Return',
		ACTION__SCRIPT: 'Script',
		ACTION__SCRIPT_CODE: 'Script Code',
		ACTION__NEW_ACTION: 'New Action',
		ACTION__ACTION_DETAILS: 'Action Details',
		ACTION__MESSAGE_CREATED: 'Action has been added successfully!',
		ACTION__MESSAGE_UPDATED: 'Action has been updated successfully!',
		ACTION__MESSAGE_REMOVED: 'Action has been removed successfully!',
		ACTION__TITLE_ADD: 'Add Action',
		ACTION__MESSAGE_ADD: 'Do you want to add a new action?',
		ACTION__TITLE_UPDATE: 'Update Action',
		ACTION__MESSAGE_UPDATE: 'Do you want to update the action?',
		ACTION__TITLE_REMOVE: 'Remove Action',
		ACTION__MESSAGE_REMOVE: 'Do you want to remove the action?',

		BOARDS__BOARDS_REPOSITORY: 'Boards Repository',
		BOARDS__BOARDS: 'Boards',
		BOARDS__STAGE: 'Stage',
		BOARDS__FILTER_BOARDS: 'Boards Filter',
		BOARDS__NAME: 'Name',
		BOARDS__VERSION: 'Version',
		BOARDS__RELEASE_DATE: 'Release Date',
		BOARDS__EXPIRATION_DATE: 'Expiration Date',
		BOARDS__BOARD_DETAILS: 'Details Board',
		BOARDS__REGISTRATION: 'Registration',
		BOARDS__FIRMWARES: 'Firmwares',
		BOARDS__DOCUMENTATION: 'Documentation',
		BOARDS__CHANGELOG: 'Changelog',
		BOARDS__COMMENTS: 'Comments',
		BOARDS__COMPATIBILITY: 'Compatibility',
		BOARDS__PRODUCT: 'Product',
		BOARDS__FEATURES: 'Features',
		BOARDS__BOARD_FILE: 'Board File',
		BOARDS__DOCUMENTATION_FILE: 'Documentation File',
		BOARDS__PREVIEW: 'Preview',
		BOARDS__MESSAGE_FILE_SIZE_LIMIT: 'The file size cannot exceed 4MB',
		BOARDS__NEW_BOARD: 'New Board',
		BOARDS__MESSAGE_CREATED: 'Board has been added successfully!',
		BOARDS__MESSAGE_UPDATED: 'Board has been updated successfully!',
		BOARDS__MESSAGE_REMOVED: 'Board has been removed successfully!',
		BOARDS__MESSAGE_FILE_REMOVED: 'File has been removed successfully!',
		BOARDS__BOARD_ADD: 'Add Board',
		BOARDS__BOARD_MESSAGE_ADD: 'Do you want to add a new board?',
		BOARDS__TITLE_UPDATE: 'Update Board',
		BOARDS__MESSAGE_UPDATE: 'Do you want to update the board?',
		BOARDS__TITLE_REMOVE: 'Remove Board',
		BOARDS__MESSAGE_REMOVE: 'Do you want to remove the board?',

		BRIGADIER__PANEL: 'Brigade Panel',
		BRIGADIER__NAME: 'Name',
		BRIGADIER__ACCOUNT: 'Account',
		BRIGADIER__STATUS: 'Status',
		BRIGADIER__FILTER_PANELS: 'Filter Panels',
		BRIGADIER__PANELS: 'Panels',
		BRIGADIER__MONITOR: 'Monitor',
		BRIGADIER__MIN_BRIGADIERS: 'Min. Brigade Members',
		BRIGADIER__MIN_MEMBERS: 'Min. CIPA Members',
		BRIGADIER__MONITORING: 'Monitoring',
		BRIGADIER__BRIGADIERS: 'Brigade Members',
		BRIGADIER__IN_THIS_ENVIRONMENT_NOW: 'This area now',
		BRIGADIER__FORCE_EXIT: 'Force Exit',
		BRIGADIER__MEMBER: 'CIPA Member',
		BRIGADIER__BRIGADIER: 'Brigade Member',

		BULK__INVALID_RECORDS: 'Invalid Records',
		BULK__DOWNLOAD: 'Download as .csv',
		BULK__TEMPLATE_DOWNLOAD: 'Template Download',
		BULK__TEMPLATE: 'Template',
		BULK__AS_EDIT: 'Edit the',
		BULK__INFORMATIONS: 'Informations',
		BULK__FILE_IMPORT: 'File Import',
		BULK__FILE_UPLOAD: 'File Upload',
		BULK__TEMPLATE_UPLOAD: 'Template Upload',
		BULK__COMPLETE: 'Complete',
		BULK__MESSAGE__FILE_SIZE_ERROR: 'The file size cannot exceed 4MB',
		BULK__INSTRUCTIONS:
			'To complete the inclusion process, correct the invalid records in your template and upload it again.<br /><strong>No records have been imported.</strong>',
		BULK__INVALID_INFORMATION: 'Invalid Information',
		BULK__ROW: 'Row',
		BULK__RECORDS_REVIEW: 'Records Review',
		BULK__COMPLETE_INCLUSION: 'Complete Inclusion',

		CAMERA__NEW_CAMERA: 'New Camera',
		CAMERA__CAMERA: 'Camera',
		CAMERA__CAMERAS: 'Cameras',
		CAMERA__NAME: 'Name',
		CAMERA__MODEL: 'Model',
		CAMERA__MANUFACTURER: 'Manufacturer',
		CAMERA__ENVIRONMENT: 'Area',
		CAMERA__FILTER_CAMERAS: 'Filter Cameras',
		CAMERA__LOCATION: 'Location',
		CAMERA__IP: 'IP',
		CAMERA__STATUS: 'Status',
		CAMERA__STATUS__ACTIVE: 'Active',
		CAMERA__STATUS__INACTIVE: 'Inactive',
		CAMERA__DETAILS: 'Camera Details',
		CAMERA__TAB_DETAILS: 'Details',
		CAMERA__ENGINE_TAB: 'Engine',
		CAMERA__EVENTS_TAB: 'Events',
		CAMERA__IDENTIFICATION: 'Identification',
		CAMERA__UNIT: 'Unit',
		CAMERA__SELECT: 'Select',
		CAMERA__DEPARTAMENT: 'Department',
		CAMERA__INFORMATION: 'Information',
		CAMERA__CONNECTION: 'Connection',
		CAMERA__CONNECT: 'Associate Camera',
		CAMERA__CONNECTION_URL: 'Connection URL',
		CAMERA__KINESIS_URL: 'kinesis URL connection',
		CAMERA__SERIAL_NUMBER: 'Serial Number',
		CAMERA__UID: 'UID',
		CAMERA__FIRMWARE: 'Firmware',
		CAMERA__STAGE: 'Stage',
		CAMERA__STAGE_PRODUCTION: 'Production',
		CAMERA__STAGE_TEST: 'Test',
		CAMERA__STAGE_STOCK: 'Stock',
		CAMERA__STAGE_TRANSPORT: 'Transport',
		CAMERA__STAGE_INSTALLED: 'Installed',

		CAMERA__USER: 'User',
		CAMERA__PASSWORD: 'Password',
		CAMERA__RESOLUTION: 'Resolution',
		CAMERA__OBSERVATIONS: 'Observations',
		CAMERA__ASSOCIATIONS: 'Associations',
		CAMERA__ASSOCIATIONS_CAMERAS: 'Associated Cameras',
		CAMERA__ENGINE_NAME: 'Engine Name',
		CAMERA__ENGINE_INCLUSION_DATE: 'Inclusion Date',
		CAMERA__ENGINE_QTD_PARAMETERS: 'Qtd. Parameters',
		CAMERA__ENGINE_SOFTCORE: 'Softcore',
		CAMERA__DEVICE_TYPE__SOFTCORE: 'Softcore',
		CAMERA__CAMERAS_AVAILABLE: 'Cameras Available',
		CAMERA__ENGINE_TOTAL_EVENTS: 'Total Events',
		CAMERA__ENGINE_NEW_ENGINE: 'New Engine',
		CAMERA__CLASSES: 'Classes',
		CAMERA__REKOGNITION_CLASSES: 'Rekognition Classes',
		CAMERA__CLASS_PRECISION: '% of recognition reliability',
		CAMERA__VALUE__HELP: 'Choose a value between 40 and 99',
		CAMERA__TIMEOUT_SHOOT: 'Timeout Shot (seconds)',
		CAMERA__DESCRIPTION: 'Description',
		CAMERA__DEFAULT_CLASS_ORIENTATION:
			'Single value for all classes defined below',

		CAMERA__TITLE_ADD: 'Add Camera',
		CAMERA__MESSAGE_ADD: 'Do you want to add a new camera?',
		CAMERA__TITLE_UPDATE: 'Update Camera',
		CAMERA__MESSAGE_UPDATE: 'Do you want to update the camera?',
		CAMERA__TITLE_REMOVE: 'Remove Camera',
		CAMERA__MESSAGE_REMOVE: 'Do you want to remove the camera?',
		CAMERA__MESSAGE_CREATED: 'Camera has been added successfully!',
		COMMON__ERROR__FORCE_EXIT:
			'You cannot force exit the camera, as it is not associated with any brigade panel.',
		CAMERA__MESSAGE_UPDATED: 'Camera has been updated successfully!',
		CAMERA__MESSAGE_REMOVED: 'Camera has been removed successfully!',
		CAMERA__ENGINE_DETAILS: 'Engine Details',
		CAMERA__NEW_ENGINE: 'New Engine',

		CLIENT__ACCOUNTS: 'Accounts',
		CLIENT__ACCOUNT: 'Account',
		CLIENT__NAME: 'Name',
		CLIENT__ADDRESS: 'Address',
		CLIENT__ADDRESS__STATE: 'State',
		CLIENT__ADDRESS__CITY: 'City',
		CLIENT__ADDRESS__ZIP_CODE: 'Zip Code',
		CLIENT__ADDRESS__STREET: 'Address',
		CLIENT__ADDRESS__STREET2: 'Complement',
		CLIENT__ADDRESS__DISTRICT: 'District',
		CLIENT__ADDRESS__NUMBER: 'Number',
		CLIENT__ASSOCIATION_DATE: 'Association date',
		CLIENT__FILTER_ACCOUNTS: 'Filter Accounts',
		CLIENT__LOCATION: 'Location',
		CLIENT__ACCOUNT_DETAILS: 'Account Details',
		CLIENT__TRADE_NAME: 'Trade Name',
		CLIENT__COMPANY_NAME: 'Company Name',
		CLIENT__ACCOUNT_NUMBER: 'Account Number',
		CLIENT__CNPJ: 'CNPJ',
		CLIENT__IE: 'State Registration',
		CLIENT__IM: 'Municipal Registration',
		CLIENT__COMMENTS: 'Comments',
		CLIENT__HELPER_CENTER: 'Help Center',
		CLIENT__TICKETS: 'Tickets',
		CLIENT__KNOWLEDGE_BASE: 'Knowledge Base',
		CLIENT__SUPPORT_EMAIL: 'Support Email',
		CLIENT__SUPPORT_EMAIL_TEXT: 'Text Support Email',
		CLIENT__SUPPORT_WHATSAPP: 'Suporte Whatsapp',
		CLIENT__SUPPORT_WHATSAPP_TEXT: 'Text Whatsapp Support',
		CLIENT__DOCUMENTATION_URL: 'Documentation',
		CLIENT__DATA_INSIGHT: 'Data Insight',
		CLIENT__CUSTOMIZATIONS: 'Customizations',
		CLIENT__URL: 'URL',
		CLIENT__COLORS: 'COLORS',
		CLIENT__ACCESS_LINK: 'Access Link',
		CLIENT__PRIMARY_COLOR: 'Primary Color',
		CLIENT__SECONDARY_COLOR: 'Secondary Color',
		CLIENT__PRIMARY_COLOR_DESCRIPTION:
			'Color used in buttons, menus, titles and highlighted fonts.',
		CLIENT__SECONDARY_COLOR_DESCRIPTION:
			'Color used for prominent buttons and section titles.',
		CLIENT__THEME_BACKGROUND: 'BACKGROUND',
		CLIENT__PREVIEW: 'Preview',
		CLIENT__MESSAGE_FILE_SIZE_LIMIT: 'The file size cannot exceed 4MB',
		CLIENT__SLOGAN: 'SLOGAN',
		CLIENT__LOGO: 'LOGO',
		CLIENT__NEW_CONTRACT: 'New Contract',
		CLIENT__NEW_ACCOUNT: 'New Account',
		CLIENT__ACCOUNT__MESSAGE_CREATED: 'Account has been added successfully!',
		CLIENT__ACCOUNT__MESSAGE_UPDATED: 'Account has been updated successfully!',
		CLIENT__ACCOUNT__MESSAGE_REMOVED: 'Account has been removed successfully!',
		CLIENT__ACCOUNT__MESSAGE_IMAGE_REMOVED:
			'Image has been removed successfully!',

		CLIENT__ACCOUNT_ADD: 'Add Account',
		CLIENT__ACCOUNT_MESSAGE_ADD: 'Do you want to add a new account?',
		CLIENT__ACCOUNT_UPDATE: 'Update Account',
		CLIENT__ACCOUNT_MESSAGE_UPDATE: 'Do you want to update the account?',
		CLIENT__ACCOUNT_REMOVE: 'Remove Account',
		CLIENT__ACCOUNT_MESSAGE_REMOVE: 'Do you want to remove the account?',

		CLIENT__LINK_DETAIL: 'Link details',
		CLIENT__GENERAL_INFORMATION: 'General Information',
		CLIENT__TITLE: 'Title',
		CLIENT__SUBTITLE: 'Subtitle',
		CLIENT__LINK: 'Link',
		CLIENT__REPORT_MESSAGE_CREATED: 'Report has been created successfully!',
		CLIENT__REPORT_MESSAGE_UPDATED: 'Report has been updated successfully!',
		CLIENT__REPORT_MESSAGE_REMOVED: 'Report has been removed successfully!',
		CLIENT__CONTROL_DETAIL: 'Control Detail',
		CLIENT__PRODUCT_DATA: 'Product Data',
		CLIENT__PRODUCT: 'Product',
		CLIENT__HIRED: 'Hired',
		CLIENT__DELIVERED: 'Delivered',
		CLIENT__QUANTITY_HIRED: 'Hired Quantity',

		CLIENT__RESPONSIBLE: 'Responsible',
		CLIENT__RESPONSIBLES: 'Responsibles',
		CLIENT__DETAIL: 'Responsible detail',
		CLIENT__DATAS: 'Responsible data',
		CLIENT__CONTACT: 'Contact',
		CLIENT__PHONE: 'Phone',
		CLIENT__EMAIL: 'Email',
		CLIENT__DEPARTMENT: 'Department',
		CLIENT__CONTRACTS: 'Contracts',
		CLIENT__CONTRACTS__ACTIVES_SUBTITLE: 'Actives',
		CLIENT__CONTRACT_DETAIL: 'Contract Detail',
		CLIENT__CONTRACT_DETAILS: 'Contract Details',
		CLIENT__REGISTRATION: 'Registration',
		CLIENT__CONTRACT_NUMBER: 'Number',
		CLIENT__CONTRACT__PURCHASE_ORDER: 'Purchase Order',
		CLIENT__CONTRACT__START_DATE: 'Start',
		CLIENT__CONTRACT__END_DATE: 'End',
		CLIENT__CONTRACT__END_WARRANTY: 'End of Warranty',
		CLIENT__CONTRACT__STATUS: 'Status',
		CLIENT__CONTRACT_FILES: 'Files',
		CLIENT__CONTRACT__UPLOAD_FILES: 'Contract Upload Files',
		CLIENT__CONTRACT__ERROR_MESSAGE:
			'The sum of the files must not exceed 10MB',
		CLIENT__CONTRACT__ACTION_ADD: 'Add',
		CLIENT__CONTRACT__CONTROL: 'Control',
		CLIENT__CONTRACT__DEVICES_HIRED: 'Hired Devices',
		CLIENT__CONTRACT__DEVICES__HANDED_OUT: 'Delivered Devices',
		CLIENT__CONTRACT__COMMENTS: 'Comments',
		CLIENT__CONTRACT__DEVICES: 'Devices',
		CLIENT__CONTRACT__DEVICES_PRODUCT: 'Product',
		CLIENT__CONTRACT__DEVICES_TYPE_PROFILE: 'Type / Profile',
		CLIENT__CONTRACT__DEVICES_SERIAL_NUMBER: 'Serial Number',
		CLIENT__CONTRACT__DEVICES_UID: 'UID',
		CLIENT__CONTRACT__DEVICES_HARD_FIRM: 'Hard / Firm',
		CLIENT__CONTRACT__DEVICES_STAGE: 'Stage',
		CLIENT__FILTER_CONTRACTS: 'Contracts Filter',
		CLIENT__CONTRACT_NAME: 'Name',
		CLIENT__CONTRACT_PHONE: 'Phone',
		CLIENT__CONTRACT_EMAIL: 'Email',
		CLIENT__CONTRACT__DEVICES_TOTAL_HIRED: 'Hired',
		CLIENT__CONTRACT__DEVICES_TOTAL: 'Associated',
		CLIENT__CONTRACT__DEVICES_HIRED_ASSOCIATES: 'Devices (hired/associated)',
		CLIENT__CONTRACT__MESSAGE_CREATED:
			'Contract has been created successfully!',
		CLIENT__CONTRACT__MESSAGE_UPDATED:
			'Contract has been updated successfully!',
		CLIENT__CONTRACT__MESSAGE_REMOVED:
			'Contract has been removed successfully!',
		CLIENT__CONTRACT__MESSAGE_FILE_REMOVED:
			'File has been removed successfully!',
		CLIENT_CONTRACT_TITLE: 'Title',
		CLIENT_CONTRACT_SUBTITLE: 'Subtitle',
		CLIENT__CONTRACT__MODULES: 'Modules',
		CLIENT__CONTRACT_MODALITY: 'Modality',
		CLIENT__CONTRACT_SUPPORT: 'Support',

		CLIENT__BACKGROUND_IMAGE:
			' Image for customizing the background of your login page. It is advisable to use .jpg or .jpeg images, up to 2mb, with a minimum size of 1440x900px',
		CLIENT__MESSAGE_DOCUMENTATION_URL:
			'Custom link for the account, which will serve as access to the API documentation',
		CLIENT__MESSAGE_JIRA_URL:
			'Custom link for the account, which will serve as access to the system`s knowledge base in Jira',
		CLIENT__MESSAGE_CONNECT_URL:
			'Customized link for the account, which will serve as access to the monitoring camera.',
		CLIENT__MESSAGE_CONNECT_KINESIS_URL:
			'Customized link for the account, which will serve as access to the kinesis monitoring camera.',
		CLIENT__LOGO_IMAGE:
			'Logo for your login page. It is advisable to use .png with a transparent background, minimum size 50x50px',
		CLIENT__MESSAGE_SUPPORT_EMAIL:
			'Custom email for the account, which will serve as a channel for opening tickets in Jira',
		CLIENT__MESSAGE_SUPPORT_WHATSAPP:
			'Custom contact number for the account, which will serve as a channel for direct contact with technical support A4',
		CLIENT__MESSAGE_THEME_SLOGAN:
			'Slogan for customizing your login page. It is advisable to use a maximum of 62 characters',
		CLIENT__MESSAGE_THEME_SLUG:
			'Definition of the URL for access to the A4 Solutions system. Do not use spaces, accents, or special characters in your URL',
		CLIENT__MESSAGE_TICKET_URL:
			'Custom link for the account, which will be accessed in case of opening and monitoring tickets in Jira',

		COMMON__TABLE__LOADING_TEXT: 'Loading...',
		COMMON__TABLE__NO_DATA_TEXT: 'No records found.',
		COMMON__TABLE__NO_RESULTS_PAGE: 'No records found',
		COMMON__TABLE__ITEMS_PER_PAGE_TEXT: 'Items per page',
		COMMON__FILTER: 'Filter',
		COMMON__DETAILS: 'Details',
		COMMOM__MODULES: 'Modules',
		COMMON__SELECT: 'Select:',
		COMMON__ALL: 'All:',
		COMMON__ACTION__SAVE: 'Save',
		COMMON__ACTION__REMOVE: 'Remove',
		COMMON__ACTION__BACK: 'Back',
		COMMON__ACTION__INSERT: 'Insert',
		COMMON__ACTION__CANCEL: 'Cancel',
		COMMON__ACTION__CONFIRM: 'Confirm',
		COMMON__ACTION__APPLY: 'Apply',
		COMMON__ACTION__DOWNLOAD: 'Download',
		COMMON__ACTION__INSERT_BATCH: 'Insert in batch',
		COMMON__ACTION__UPDATE_BATCH: 'Update in batch',
		COMMON__ACTION__REMOVE_BATCH: 'Remove in batch',
		COMMON__ACTION__ASSOCIATE: 'Associate',
		COMMON__PAGE_TEXT_OF: 'of',
		COMMON__BULK__INCLUSION: 'Insert in batch',
		COMMON__BULK__UPDATE: 'Update in batch',
		COMMON__REQUIRED_FIELD: 'Required field',
		COMMON__FIELD_MUST_BE_FILLED: 'The field must be filled in.',
		COMMON__MINIMUM_CHARACTERS: 'Minimum character length',
		COMMON__MAXIMUM_CHARACTERS: 'Maximum character length',
		COMMON__INVALID_CPF: 'Invalid CPF',
		COMMON__INVALID_CNPJ: 'Invalid CNPJ',
		COMMON__INVALID_YEAR: 'Invalid year',
		COMMON__INVALID_NUMBER: 'Invalid number',
		COMMON__INVALID_VALUE: 'Invalid value',
		COMMON__PASSWORD_LOWERCASE_LETTERS:
			'Password must contain lowercase letters',
		COMMON__PASSWORD_UPPERCASE_LETTERS:
			'Password must contain uppercase letters',
		COMMON__PASSWORD_NUMBERS: 'Password must contain at least one number',
		COMMON__PASSWORD_SPECIAL_CHARACTERS:
			'Password must contain at least one special character',
		COMMON__PASSWORD_MINIMUM_LENGTH:
			'Password must contain at least 8 characters',
		COMMON__FILE_LESS_THAN: 'File must be less than',
		COMMON__FILE__SIZE__LESS_THAN: 'Total file size must be less than',
		COMMON__DATE_END_NOT_BE_BIGGER_THAN_START:
			'End date cannot be greater than start date',
		COMMON__DATE_EQUAL_TO: 'The max date must be 7 days from today',
		COMMON__DATE_BEFORE__OR__EQUAL_TO: 'The max date must be 7 days from today',
		COMMON__DATE_AFTER__OR__EQUAL_TO: 'The max date must be 7 days from today',
		COMMON__APPLICATION_LOGOUT_TITLE: 'Exit',
		COMMON__APPLICATION_ACTION_LOGOUT_OK: 'OK',
		COMMON__APPLICATION_LOGOUT_ATTENTION: 'Attention',
		COMMON__MESSAGE_APPLICATION_LOGOUT: 'Do you want to exit the application?',
		COMMON__FILE_ACTION_REMOVE: 'Remove file',
		COMMON__MESSAGE_FILE_REMOVE: 'Do you want to remove the file?',
		COMMON__TITLE_ADD: 'Add action',
		COMMON__MESSAGE_ADD: 'Do you want to add a new action?',
		COMMON__TITLE_UPDATE: 'Update action',
		COMMON__MESSAGE_UPDATE: 'Do you want to update the action?',
		COMMON__TITLE_REMOVE: 'Remove action',
		COMMON__MESSAGE_REMOVE: 'Do you want to remove the action?',
		COMMON__YES: 'Yes',
		COMMON__NO: 'No',
		COMMON__FILE_REMOVE: 'Remove file',

		SESSION_EXPIRED_ERROR_TOKEN: 'Session whith error. Please log in again.',

		DATA_INSIGHT__DATA_INSIGHT: 'Data Insight',
		DATA_INSIGHT__ACCOUNT: 'Account',
		DATA_INSIGHT__REPORT: 'Report',
		DATA_INSIGHT__ACCOUNT_DETAILS: 'Account Details',
		DATA_INSIGHT__TITLE_ADD: 'Add Data Insight',
		DATA_INSIGHT__MESSAGE_ADD: 'Do you want to add new data insight?',
		DATA_INSIGHT__TITLE_UPDATE: 'Update Data Insight',
		DATA_INSIGHT__MESSAGE_UPDATE: 'Do you want to update data insight?',
		DATA_INSIGHT__TITLE_REMOVE: 'Remove Data Insight',
		DATA_INSIGHT__MESSAGE_REMOVE: 'Do you want to remove data insight?',

		DASHBOARD__HOMEPAGE: 'Homepage',
		DASHBOARD__EVENTS_PER_MONTH: 'Events per Month',
		DASHBOARD__WELCOME: 'Welcome!',
		DASHBOARD__DESCRIPTION: "Monitor your Smart Safety's performance!",
		DASHBOARD__CLIENT_LIST__LABEL: 'Accounts List',
		DASHBOARD__CLIENT_LIST__HEADER: 'Accounts',
		DASHBOARD__CLIENT_LIST__SEARCH_PLACEHOLDER: 'Search Account',
		DASHBOARD__CLIENT_LIST__COLUMN__NAME: 'Name',
		DASHBOARD__CLIENT_LIST__COLUMN__DEVICES: 'Devices',
		DASHBOARD__CLIENT_LIST__COLUMN__EVENTS: 'Events',
		DASHBOARD__PRODUCT_STOCK_LIST__LABEL: 'Products in Stock',
		DASHBOARD__PRODUCT_STOCK_LIST__HEADER: 'Stock',
		DASHBOARD__PRODUCT_STOCK_LIST__SEARCH_PLACEHOLDER: 'Search Product',
		DASHBOARD__PRODUCT_STOCK_LIST__COLUMN__PRODUCT: 'Product',
		DASHBOARD__PRODUCT_STOCK_LIST__COLUMN__QUANTITY: 'Quantity',
		DASHBOARD__EVENT_LIST__LABEL: 'Events of the Day',
		DASHBOARD__EVENT_LIST__HEADER: 'Latest Proximity Events',
		DASHBOARD__EVENT_LIST__SEARCH_PLACEHOLDER: 'Search Events',
		DASHBOARD__EVENT_LIST__COLUMN__TYPE: 'Type',
		DASHBOARD__EVENT_LIST__COLUMN__EQUIPMENT: 'Equipment',
		DASHBOARD__EVENT_LIST__COLUMN__TIME: 'Time',
		DASHBOARD__EVENT_LIST__COLUMN__EMPLOYEE: 'Employee',
		DASHBOARD__EMPLOYEE_LIST__LABEL: 'Employee Ranking',
		DASHBOARD__EMPLOYEE_LIST__HEADER: 'Employee',
		DASHBOARD__EMPLOYEE_LIST__SEARCH_PLACEHOLDER: 'Search Employee',
		DASHBOARD__EMPLOYEE_LIST__COLUMN__NAME: 'Name',
		DASHBOARD__EMPLOYEE_LIST__COLUMN__EVENTS: 'Events',
		DASHBOARD__EMPLOYEE_LIST__COLUMN__LAST_EVENT: 'Latest Event',
		DASHBOARD__METRICS__DEVICES__TITLE: 'Devices',
		DASHBOARD__METRICS__DEVICES__SUBTITLE: 'Devices',
		DASHBOARD__METRICS__EVENTS__TITLE: 'Events',
		DASHBOARD__METRICS__EVENTS__SUBTITLE: 'Today',
		DASHBOARD__METRICS__CLIENTS__TITLE: 'Accounts',
		DASHBOARD__METRICS__CLIENTS__SUBTITLE: 'Registered',
		DASHBOARD__METRICS__ACTIVE_DEVICES__TITLE: 'Devices',
		DASHBOARD__METRICS__ACTIVE_DEVICES__SUBTITLE: 'Active Today',
		DASHBOARD__METRICS__EQUIPMENTS__TITLE: 'Equipments',
		DASHBOARD__METRICS__EQUIPMENTS__SUBTITLE: 'Registered',
		DASHBOARD__METRICS__EMPLOYEES__TITLE: 'Employees',
		DASHBOARD__METRICS__EMPLOYEES__SUBTITLE: 'Registered',

		DASHBOARD_VISION__WELCOME: 'Welcome!',
		DASHBOARD_VISION__DESCRIPTION: 'Vision Management',
		DASHBOARD_VISION__EVENT_LIST__HEADER: 'Latest Events',
		DASHBOARD_VISION__EVENT_LIST__LABEL: 'Events of the Day',
		DASHBOARD_VISION__QUICK_ACCESS: 'Quick Access',
		DASHBOARD_VISION__CHART_TITLE: 'Events from the last 12 months',

		DASHBOARD_VISION__LINKS__ENVIRONMENT_TITLE: 'Area',
		DASHBOARD_VISION__LINKS__ENVIRONMENT_SUBTITLE: 'Register',
		DASHBOARD_VISION__LINKS__CAMERA_TITLE: 'Cameras',
		DASHBOARD_VISION__LINKS__CAMERA_SUBTITLE: 'Register',
		DASHBOARD_VISION__LINKS__MONITOR_TITLE: 'Monitor',
		DASHBOARD_VISION__LINKS__MONITOR_SUBTITLE: 'Camera',
		DASHBOARD_VISION__LINKS__NOTIFICATIONS_TITLE: 'Notifications',
		DASHBOARD_VISION__LINKS__NOTIFICATIONS_SUBTITLE: 'Group of Emails',
		DASHBOARD_VISION__LINKS__REPORTS_TITLE: 'Reports',
		DASHBOARD_VISION__LINKS__REPORTS_SUBTITLE: 'Events',
		DASHBOARD_VISION__LOCAL: 'Local',
		DASHBOARD_VISION__CAMERA: 'Camera',
		DASHBOARD_VISION__START: 'Start',
		DASHBOARD_VISION__HOUR: 'Capture time',
		DASHBOARD_VISION__END: 'End',
		DASHBOARD_VISION__DURATION: 'Duration',
		DASHBOARD_VISION__ENVIRONMENT: 'Area',
		DASHBOARD_VISION__ALGORITHM: 'Engine',
		DASHBOARD_VISION__THRESHOLD: 'Confidence Threshold',
		DASHBOARD_VISION__DEVICE: 'Camera',

		DEVICE__ALIAS: 'Alias',
		DEVICE__SMART_DEVICES: 'Smart Devices',
		DEVICE__DEVICES: 'Devices',
		DEVICE__DEVICE: 'Devices',
		DEVICE__TYPE: 'Type',
		DEVICE__PROFILE: 'Profile',
		DEVICE__SERIAL_NUMBER: 'Serial Number',
		DEVICE__DEVICES_AVAILABLE: 'Available Devices',
		DEVICE__UID: 'UID',
		DEVICE__HARDWARE: 'Hardware',
		DEVICE__HARDWARE_VERSION: 'Hardware Version',
		DEVICE__FIRMWARE__VERSION: 'Firmware Version',
		DEVICE__FIRMWARE: 'Firmware',
		DEVICE__CLIENT_NAME: 'Account',
		DEVICE__LOT: 'Lot',
		DEVICE__STAGE: 'Stage',
		DEVICE__STATUS: 'Status',
		DEVICE__CONTRACT: 'Contract',
		DEVICE__ACTION__FILTER: 'Filter Devices',
		DEVICE__NO_CLIENT_ASSOCIATED: 'No associated clients',
		DEVICE__NO_ASSOCIATED: 'Not Associated',
		DEVICE__PRODUCT: 'Product',
		DEVICE__TYPE_PROFILE: 'Type / Profile',
		DEVICE__HARD_FIRM: 'Hard / Firm',
		DEVICE__MANUFACTURE_DATE: 'Manufacture Date',
		DEVICE__MANUFACTURE: 'Manufacture',
		DEVICE__ADDITIONAL_DATA: 'Additional Data',
		DEVICE__MESSAGE_CREATED: 'Device has been created successfully!',
		DEVICE__MESSAGE_UPDATED: 'Device has been updated successfully!',
		DEVICE__MESSAGE_REMOVED: 'Device has been removed successfully!',
		DEVICE__MESSAGE__NO_DEVICE_FOUND: 'No devices were found.',
		DEVICE__CONNECT: 'Associate device',
		DEVICE__ASSOCIATIONS: 'Associations',
		DEVICE__HISTORY: 'History',
		DEVICE__NEW_SMART_DEVICE: 'New smart device',
		DEVICE__SMART_DEVICE_DETAILS: 'Smart device details',
		DEVICE__SMART_DEVICE_DOCUMENTS: 'Device documents',
		DEVICE_DOCUMENTS_TIME: 'Time',
		DEVICE_DOCUMENTS_DROP_DOCUMENT: 'Drag your documents here',
		DEVICE_DOCUMENTS_FILES_READY: 'Files ready',
		DEVICE__IDENTIFY_DEVICE: 'Identify Device',
		DEVICE__IDENTIFICATION: 'Identification',
		DEVICE__INTERACTION: 'Interaction',
		DEVICE__LAST_COMMUNICATION_DATE: 'Last communication date',
		DEVICE__LAST_COMMUNICATION_TIME: 'Last communication time',
		DEVICE__TYPE_SERIAL_NUMBER: 'Enter the serial number',
		DEVICE__MESSAGE_SCAN_QRCODES:
			'Find the QR Code on your device and place it in the area below',
		DEVICE__READ_QR_CODE: 'Read QR Code',
		DEVICE__MESSAGE_TYPE_SERIAL_NUMBER:
			'Enter the serial number, wich is next to the QR Code, in the area below',
		DEVICE__SELECT: 'Select',
		DEVICE__ASSOCIATE_DEVICES: 'Associate Devices',
		DEVICE__BULK_INSTRUCTIONS:
			'1. Keep all the columns and sorting of the downloaded template, even if some devices do not have all the registration information;<br /><br />2. The UID and Serial Number fields are mandatory. It is not possible to leave them without unique information.',
		DEVICE__UPDATE_BATCH: 'Batch update',
		DEVICE__SYSTEM_FIELD: 'System Field',
		DEVICE__NEW_VALUE: 'New Value',
		DEVICE__CONTRACT_SELECT: 'Select a contract',
		DEVICE__TITLE_ADD: 'Add Device',
		DEVICE__MESSAGE_ADD: 'Do you want to add a new device?',
		DEVICE__TITLE_UPDATE: 'Update Device',
		DEVICE__MESSAGE_UPDATE: 'Do you want to update this device?',
		DEVICE__TITLE_REMOVE: 'Remove Device',
		DEVICE__MESSAGE_REMOVE: 'Do you want to remove this device?',
		DEVICES__TITLE_ADD_BATCH: 'Add Device(s)',
		DEVICES__MESSAGE_ADD_BATCH: 'Do you want to add new device(s)?',
		DEVICES__TITLE_UPDATE_BATCH: 'Update Device(s)',
		DEVICES__MESSAGE_UPDATE_BATCH: 'Do you want to update this device(s)?',
		DEVICES__TITLE_REMOVE_BATCH: 'Remove Device(s)',
		DEVICES__MESSAGE_REMOVE_BATCH: 'Do you want to remove this device(s)?',
		DEVICE__PROFILE_SINGLE_POINT: 'SinglePoint',
		DEVICE__PROFILE_MULTI_POINT: 'MultiPoint',
		DEVICE__PROFILE_PORTAL: 'Portal',
		DEVICE__PROFILE_ZONE_MAP: 'ZoneMap',
		DEVICE__PROFILE_CROSS_POINT: 'CrossPoint',
		DEVICE__SOLUTIONS: 'Solutions',
		DEVICE__ABOUT_DEFECT: 'About Defect',
		DEVICE__MAINTENANCE_INFORMATION: 'Information',
		DEVICE_MAINTENANCE_DOCUMENTS: 'Documents',
		DEVICE_MAINTENANCE: 'Maintenance',
		DEVICE_MAINTENANCE__DATE: 'Date',
		DEVICE_MAINTENANCE__START_DATE: 'Start Date',
		DEVICE_MAINTENANCE__END_DATE: 'End Date',
		DEVICE_MAINTENANCE__CREATE_DATE: 'Create Date',
		DEVICE_MAINTENANCE__WANTENTY_DATE: 'Warranty Date',
		DEVICE_MAINTENANCE__DATE_START: 'Start Date maintenance',
		DEVICE_MAINTENANCE__DATE_END: 'End Date maintenance',
		DEVICE_MAINTENANCE__TICKET: 'Ticket',
		DEVICE_MAINTENANCE__TYPE_SERVICE: 'Service type',
		DEVICE__ACTION__MAINTENANCES_FILTER: 'Filter Maintenance',
		DEVICE__ACTION__DOCUMENTS_FILTER: 'Filter documents',
		DEVICE_DOCUMENTS_NAME: 'Document name',
		DEVICE_DOCUMENTS_EXTENSION: 'Extension',
		DEVICE__MAINTENANCE_HISTORY: 'Maintenance History',
		DEVICE_MAINTENANCE__STATUS: 'Status',
		DEVICE__WARRANTY_MAINTENANCE: 'Warranty Maintenance',
		DEVICE__WARRANTY_CONTRACT_END: 'Contractual warranty expiration',
		DEVICE__WARRANTY_MAINTENANCE_END: 'Warranty maintenance expiration',
		DEVICE__SUPPORT: 'Support',
		DEVICE__WARRANTY: 'Warranty',
		DEVICE__NO_DEFECT: 'No Defect',
		DEVICE__OUT_WARRANTY: 'Out of Warranty',
		DEVICE__MISUSE: 'Misuse',
		DEVICE__ADD: 'Add',
		DEVICE__MAINTENANCE__ADD: 'Add Maintenance',
		DEVICE__MAINTENANCE__UPDATE: 'Update Maintenance',
		DEVICE__PROGRESS_START: 'Start Progress',
		DEVICE__CLAIMED_DEFECT: 'Claimed Defect',
		DEVICE__SOLUTION: 'Solution',
		DEVICE__DEFECT: 'Defect',
		DEVICE__REPORT: 'Report',
		DEVICE__ACTION__COMMENTS: 'Comments',
		DEVICE_MAINTENANCE_TYPE__RESOLVED: 'Resolved',
		DEVICE_MAINTENANCE_TYPE__INPROGRESS: 'In Progress',
		DEVICE_MAINTENANCE_TYPE__UNRESOLVED: 'Unresolved',
		DEVICE__MAINTENANCE__DOWNLOAD_FILE: 'Download File',
		DEVICE__MAINTENANCE_TITLE_ADD: 'Add Maintenance',
		DEVICE__MAINTENANCE_MESSAGE_ADD: 'Do you want to add a new maintenance?',
		DEVICE__MAINTENANCE_TITLE_UPDATE: 'Update Maintenance',
		DEVICE__MAINTENANCE_MESSAGE_UPDATE:
			'Do you want to update this maintenance?',
		DEVICE__MAINTENANCE_TITLE_REMOVE: 'Remove Maintenance',
		DEVICE__MAINTENANCE_MESSAGE_REMOVE:
			'Do you want to remove this maintenance?',
		DEVICE__MAINTENANCE__MESSAGE_CREATED:
			'Maintenance has been added successfully!',
		DEVICE__MAINTENANCE_MESSAGE_UPDATED:
			'Maintenance has been updated successfully!',
		DEVICE__MAINTENANCE_MESSAGE_REMOVED:
			'Maintenance has been removed successfully!',
		DEVICE__MAINTENANCE__MESSAGE_UPDATED:
			'Maintenance has been updated successfully!',
		DEVICE__MAINTENANCE__MESSAGE_REMOVED:
			'Maintenance has been removed successfully!',
		DEVICE__MAINTENANCE__MESSAGE_FILE_REMOVED:
			'File has been removed successfully!',
		DEVICE__DOCUMENT__MESSAGE_FILE_REMOVED: 'Do you want to remove the file?',
		DEVICE__DOCUMENT_TITLE_REMOVE: 'Remove Document',
		DEVICE__DOCUMENT_MESSAGE_REMOVE: 'Do you want to remove this document?',
		DEVICE__DOCUMENT_TITLE_ADD: 'Add Document',
		DEVICE__DOCUMENT_MESSAGE_ADD: 'Do you want to add a new document?',
		DEVICE__DOCUMENT_TITLE_UPDATE: 'Update Document',
		DEVICE__DOCUMENT_MESSAGE_UPDATE: 'Do you want to update this document?',
		DEVICE__DOCUMENT__MESSAGE_CREATED: 'Document has been added successfully!',
		DEVICE__DOCUMENT_MESSAGE_UPDATED: 'Document has been updated successfully!',
		DEVICE__DOCUMENT_MESSAGE_REMOVED: 'Document has been removed successfully!',
		DEVICE__DOCUMENT__MESSAGE_DELETED:
			'Document has been deleted successfully!',
		DEVICE__DOCUMENTS__UPLOAD_FILES: 'Upload Files Device',
		DEVICE__DOCUMENTS__ERROR_MESSAGE:
			'The sum of the files must not exceed 4MB',
		DEVICE__DOCUMENTS: 'Documents',
		DEVICE__MAINTENANCE__FILE_REMOVED: 'File has been removed successfully!',
		DEVICE__DOCUMENT__FILE_REMOVED: 'File has been removed successfully!',

		EMPLOYEE__EMPLOYEES: 'Employees',
		EMPLOYEE__EMPLOYEE: 'Employee',
		EMPLOYEE__NAME: 'Name',
		EMPLOYEE__PROFILE: 'Profile',
		EMPLOYEE__REGISTRATION: 'Registration',
		EMPLOYEE__BIRTH_DATE: 'Birth date',
		EMPLOYEE__PICTURE: 'Picture',
		EMPLOYEE__MESSAGE__FILE_SIZE_ERROR: 'The file size cannot exceed 4MB',
		EMPLOYEE__IMAGE__ERROR_MESSAGE: 'Image must contain no more than 1MB',
		EMPLOYEE__BRIGADIER: 'Brigade',
		EMPLOYEE__UNIT: 'Unit',
		EMPLOYEE__DEPARTMENT: 'Department',
		EMPLOYEE__DEVICE: 'Device',
		EMPLOYEE__FULL_NAME: 'Full name',
		EMPLOYEE__SAFETY_TYPE: 'Safety',
		EMPLOYEE__STATUS: 'Status',
		EMPLOYEE__FILTER_EMPLOYEE: 'Filter Employee',
		EMPLOYEE__CLIENT_NAME: 'Account',
		EMPLOYEE__MESSAGE_CREATED: 'Employee has been created successfully!',
		EMPLOYEE__MESSAGE_UPDATED: 'Employee has been updated successfully!',
		EMPLOYEE__MESSAGE_REMOVED: 'Employee has been removed successfully!',
		EMPLOYEE__PICTURE__REMOVED: 'Image has been removed successfully!',
		EMPLOYEE__MESSAGE__DOCUMENT_FILE_REMOVED:
			'File has been removed successfully!',
		EMPLOYEE__CIPA: 'CIPA Member',
		EMPLOYEE__ACTION__ASSOCIATE: 'Associations',
		EMPLOYEE__CONNECT: 'Associate',
		EMPLOYEE__ASSOCIATED_GROUPS: 'Associated Groups',
		EMPLOYEE__EVENT_HISTORY: 'Events History',
		EMPLOYEE__EVENT: 'Event',
		EMPLOYEE__TIME: 'Time',
		EMPLOYEE__NEW: 'New Employee',
		EMPLOYEE__DETAILS: 'Employee details',
		EMPLOYEE__DOCUMENTS_UPLOADS: 'Upload Files Employee',
		EMPLOYEE__DOCUMENTS: 'Documents',
		EMPLOYEE__DOCUMENTS__ERROR_MESSAGE:
			'The sum of the files must not exceed 4MB',
		USER__MESSAGE_CLIENT_WITHOUT__CONTRACT:
			'No create user. Client without active contract',

		EMPLOYEE__BULK_INSTRUCTIONS:
			'1. Keep all the columns and sorting of the downloaded template, even if some employees do not have all the registration information;<br /><br />2. The fields full name, registration and status are mandatory, and the registration is unique per employee.',
		EMPLOYEE__BULK_CREATED: 'Employees has been created successfully!',
		EMPLOYEE__BATCH_UPDATE: 'Batch Update',
		EMPLOYEE__SYSTEM_FIELD: 'System Field',
		EMPLOYEE__NEW_VALUE: 'New Value',
		EMPLOYEE_STATUS__ACTIVE: 'Active',
		EMPLOYEE_STATUS__INACTIVE: 'Inactive',
		EMPLOYEE__TITLE_ADD: 'Add Employee',
		EMPLOYEE__MESSAGE_ADD: 'Do you want to add a new employee?',
		EMPLOYEE__TITLE_UPDATE: 'Update Employee',
		EMPLOYEE__MESSAGE_UPDATE: 'Do you want to update this employee?',
		EMPLOYEE__TITLE_REMOVE: 'Remove Employee',
		EMPLOYEE__MESSAGE_REMOVE: 'Do you want to remove this employee?',
		EMPLOYEES__TITLE_ADD: 'Add Employee(s)',
		EMPLOYEES__MESSAGE_ADD: 'Do you want to add new employee(s)?',
		EMPLOYEES__TITLE_UPDATE: 'Update Employee(s)',
		EMPLOYEES__MESSAGE_UPDATE: 'Do you want to update this employee(s)?',
		EMPLOYEES__TITLE_REMOVE: 'Remove Employee(s)',
		EMPLOYEES__MESSAGE_REMOVE: 'Do you want to remove this employee(s)?',
		EMPLOYEES__TITLE_UPDATE_BATCH: 'Update Employee(s)',
		EMPLOYEES__MESSAGE_UPDATE_BATCH: 'Do you want to update this employee(s)?',
		EMPLOYEES__TITLE_REMOVE_BATCH: 'Remove Employee(s)',
		EMPLOYEES__MESSAGE_REMOVE_BATCH: 'Do you want to remove this employee(s)?',
		EMPLOYEES__TITLE_ADD_BATCH: 'Add Employees',
		EMPLOYEES__MESSAGE_ADD_BATCH: 'Do you want to add new employees?',
		EMPLOYEE__DOCUEMNT_MESSAGE_REMOVE: 'Do you want to remove this document?',
		EMPLOYEE__DOCUMENT_TITLE_REMOVE: 'Remove Document',

		ENGINES: 'Engines',
		ENGINE: 'Engine',
		ENGINE__LIST: 'Engine management',
		ENGINE__VERSION: 'Version',
		ENGINE__NAME: 'Name',
		ENGINE__TYPE: 'Type',
		ENGINE__STAGE: 'Stage',
		ENGINE__IN_DEVELOPMENT: 'In Development',
		ENGINE__IN_TESTS: 'In Tests',
		ENGINE__APPROVED: 'Approved',
		ENGINE__STANDART: 'Standard',
		ENGINE__CUSTOM: 'Custom',
		ENGINE__ACCOUNT: 'Account',
		ENGINE__ACCOUNTS: 'Accounts',
		ENGINE__STATUS: 'Status',
		ENGINE__STATUS_ACTIVE: 'Active',
		ENGINE__STATUS_INACTIVE: 'Inactive',
		ENGINE__FILTER_ENGINES: 'Filter Engines',
		ENGINE__DETAILS_ENGINE: 'Engine Details',
		ENGINE__DETAILS: 'Details',
		ENGINE__PARAMETERS: 'Parameters',
		ENGINE__GENERAL_INFORMATIONS: 'General Informations',
		ENGINE__RELEASE: 'Release',
		ENGINE__LAST_UPDATE: 'Last Update',
		ENGINE__DESCRIPTION: 'Description',
		ENGINE__LICENSE: 'License',
		ENGINE__LICENSE_KEY: 'License Key',
		ENGINE__CLASS: 'Class',
		ENGINE__VALUE: 'Value',
		ENGINE_CLASS_ID: 'Class ID',
		ENGINE__OBS: 'Observations',
		ENGINE__DOCUMENTATIONS: 'Documentations',
		ENGINE__PARAMETER: 'Parameter',
		ENGINE__MODEL: 'Model',
		ENGINE__CHANGELOG: 'Changelog',
		ENGINE__COMMENTS: 'Comments',
		ENGINE__INCLUDE_PARAMETER: 'Include Parameter',
		ENGINE__PARAMETER_DATA: 'Parameter Data',
		ENGINE__PARAMETER_REQUIRED: 'Parameter is required',
		ENGINE__VALUE_REQUIRED: 'Value is required',
		ENGINE__CONTRACT: 'Contract',
		ENGINE__FILTER_ACCOUNTS: 'Filter Accounts',
		ENGINE__INIT: 'Start',
		ENGINE__END: 'End',
		ENGINE__SELECT_AN_CONTRACT: 'Select an contract',
		ENGINE__SELECT_AN_ACCOUNT: 'Select an account',
		ENGINE__INCLUDE_ACCOUNT: 'Include Account',
		ENGINE__ACCOUNT_DATA: 'Account Data',
		ENGINE__CONTRACT_REQUIRED: 'Contract is required',
		ENGINE__ACCOUNT_REQUIRED: 'Account is required',
		ENGINE__NEW_ENGINE: 'New Engine',
		ENGINE__CREATE_SUCCESS: 'Engine created successfully!',
		ENGINE__CREATE_ERROR: 'Error creating engine!',
		ENGINE__DELETE_ERROR: 'Error deleting engine!',
		ENGINE__DELETE_SUCCESS: 'Engine deleted successfully!',
		ENGINE__UPDATE_SUCCESS: 'Engine updated successfully!',
		ENGINE__UPDATE_ERROR: 'Error updating engine!',
		ENGINE__TITLE_ADD: 'Add Engine',
		ENGINE__MESSAGE_ADD: 'Do you want to add a new engine?',
		ENGINE__TITLE_UPDATE: 'Update Engine',
		ENGINE__MESSAGE_UPDATE: 'Do you want to update this engine?',
		ENGINE__TITLE_REMOVE: 'Remove Engine',
		ENGINE__MESSAGE_REMOVE: 'Do you want to remove this engine?',
		ENGINE__ACTION__FILTER: 'Filter Engine',
		ENGINE__CLASS_NAME: 'Class Name',
		ENGINE__CLASS_DESCRIPTION: 'Class Description',
		ENGINE__CLASS_PRECISION: 'Class Precision',
		ENGINE__CLASS_TIMEOUT: 'Class Timeout',
		ENGINE__VALUE_SELECTION: 'Value Selection',
		ENGINE__RELIABILIY_LEVEL: 'Reliability Level',
		ENGINE__PERCENTAGE: 'Percentage %',
		ENGINE__TIGGER_TIMEOUT: 'Trigger Timeout',
		ENGINE__SECONDS: 'Seconds',
		ENGINE__EXPIRED: 'Expired',
		ENGINE__NEAR_EXPIRED: 'Near Expired',
		ENGINE__ACTIVE: 'Active',

		EQUIPMENT__EQUIPMENTS: 'Equipments',
		EQUIPMENT__EQUIPMENT: 'Equipment',
		EQUIPMENT__NAME: 'Name',
		EQUIPMENT__TYPE: 'Type',
		EQUIPMENT__UNIT: 'Unit',
		EQUIPMENT__DEPARTMENT: 'Department',
		EQUIPMENT__DEVICE: 'Device',
		EQUIPMENT__STATUS: 'Status',
		EQUIPMENT__EVENT: 'Event',
		EQUIPMENT__TIME: 'Time',
		EQUIPMENT__FILTER_EQUIPMENT: 'Filter Equipment',
		EQUIPMENT__NEW: 'New Equipment',
		EQUIPMENT__DETAILS: 'Equipment Details',
		EQUIPMENT__ACTION__ASSOCIATE: 'Associations',
		EQUIPMENT__CONNECT: 'Association',
		EQUIPMENT__CLIENT_NAME: 'Account',
		EQUIPMENT__ACTIVE__NUMBER: 'Active Number',
		EQUIPMENT__MANUFACTURER: 'Manufacturer',
		EQUIPMENT__YEAR__MANUFACTURER: 'Manufacturer Year',
		EQUIPMENT__EVENT__HISTORY: 'Event History',
		EQUIPMENT__MODEL: 'Model',
		EQUIPMENT__ASSOCIATED_GROUPS: 'Associated Groups',
		EQUIPMENT__MESSAGE_CREATED: 'Equipment has been created successfully!',
		EQUIPMENT__MESSAGE_UPDATED: 'Equipment has been updated successfully!',
		EQUIPMENT__MESSAGE_REMOVED: 'Equipment has been removed successfully!',
		EQUIPMENT__UPDATE_BATCH: 'Batch update',
		EQUIPMENT__SYSTEM_FIELD: 'System Field',
		EQUIPMENT__NEW_VALUE: 'New value',
		EQUIPMENTS__TITLE_ADD_BATCH: 'Add Equipment(s)',
		EQUIPMENTS__MESSAGE_ADD_BATCH: 'Do you want to add new equipment(s)?',
		EQUIPMENTS__TITLE_UPDATE_BATCH: 'Update Equipment(s)',
		EQUIPMENTS__MESSAGE_UPDATE_BATCH:
			'Do you want to update this equipment(s)?',
		EQUIPMENTS__TITLE_REMOVE_BATCH: 'Remove Equipment(s)',
		EQUIPMENTS__MESSAGE_REMOVE_BATCH:
			'Do you want to remove this equipment(s)?',

		EQUIPMENT__BULK_INSTRUCTIONS:
			'1. Keep all the columns and orderings from the downloaded template, even if some devices do not have all the registration information; 2. The name, type and status fields are mandatory. The type must be chosen from the predefined options in the individual registration.',
		EQUIPMENT__BULK_CREATED: 'Equipments has been created successfully!',
		EQUIPMENT__DOCUMENT: 'Document',
		EQUIPMENT__DOCUMENTS__UPLOAD_FILES: 'Upload Files',
		EQUIPMENT__DOCUMENTS__ERROR_MESSAGE: 'File must contain no more than 4MB',

		FIRMWARE__FIRMWARES: 'Firmwares',
		FIRMWARE__COMPATIBLE_FIRMWARES: 'Compatible Firmwares',
		FIRMWARE__NAME: 'Name',
		FIRMWARE__NEW_FIRMWARE: 'New Firmware',
		FIRMWARE__REGISTRATION: 'Registration',
		FIRMWARE__STAGE: 'Stage',
		FIRMWARE__VERSION: 'Version',
		FIRMWARE__RELEASE_DATE: 'Release Date',
		FIRMWARE__EXPIRATION_DATE: 'Expiration Date',
		FIRMWARE__BOARDS: 'Boards',
		FIRMWARE__DOCUMENTATION: 'Documentation',
		FIRMWARE__CHANGELOG: 'Changelog',
		FIRMWARE__COMMENTS: 'Comments',
		FIRMWARE__COMPATIBILITY: 'Compatibility',
		FIRMWARE__PRODUCT: 'Product',
		FIRMWARE__FEATURES: 'Features',
		FIRMWARE__DETAIL: 'Firmware Detail',
		FIRMWARE__DETAILS: 'Firmware details',
		FIRMWARE__FILTER_FIRMWARES: 'Filter Firmwares',
		FIRMWARE__FIRMWARES_REPOSITORY: 'Firmwares Repository',
		FIRMWARE__FILE: 'Firmware File',
		FIRMWARE__PREVIEW: 'Preview',
		FIRMWARE__MESSAGE_FILE_SIZE_LIMIT: 'The file size cannot exceed 4MB',
		FIRMWARE__DOCUMENTATION_FILE: 'Documentation file',
		FIRMWARE__MESSAGE_CREATED: 'Firmware has been created successfully!',
		FIRMWARE__MESSAGE_UPDATED: 'Firmware has been updated successfully!',
		FIRMWARE__MESSAGE_REMOVED: 'Firmware has been removed successfully!',
		FIRMWARE__MESSAGE_FILE_REMOVED: 'File has been removed successfully!',
		FIRMWARE__TITLE_ADD: 'Add Firmware',
		FIRMWARE__MESSAGE_ADD: 'Do you want to add a new firmware?',
		FIRMWARE__TITLE_UPDATE: 'Update Firmware',
		FIRMWARE__MESSAGE_UPDATE: 'Do you want to update this firmware?',
		FIRMWARE__TITLE_REMOVE: 'Remove Firmware',
		FIRMWARE__MESSAGE_REMOVE: 'Do you want to remove this firmware?',

		HELLO__MESSAGE: 'Hello',

		HELPER_CENTER: 'Help Center',
		HELPER__HELPER_OPTIONS: 'Helper Options',
		HELPER_SUPPORT: 'Support',
		HELPER__TICKET: 'Ticket',
		HELPER__BASE_OF: 'Base of',
		HELPER__KNOWLEDGE: 'Knowledge',
		HELPER__DOCUMENTATION: 'Documentation',
		HELPER__API_CONSULT: 'API Consult',
		HELPER__INFO_TITLE: 'If you prefer, talk to us!',
		HELPER__INFO_DESCRIPTION:
			'If none of the above options have helped, please contact us using the communication channels opposite:',
		HELPER__DESCRIPTION_DOCUMENTATION:
			'Documentation designed for development and IT teams to facilitate integration processes.',
		HELPER__DESCRIPTIONS:
			'Articles and documents in a vast database on system tools and optimizing results.',
		HELPER__OPEN_CALL_DESCRIPTIONS:
			'Open requests and tickets for technical, financial or support issues.',

		INTEGRATION__INTEGRATIONS: 'Integrations',
		INTEGRATION__NAME: 'Name',
		INTEGRATION__ACCOUNT: 'Account',
		INTEGRATION__STATUS: 'Status',
		INTEGRATION__FILTER_ACTIONS: 'Filter actions',
		INTEGRATION__INTEGRATION_DETAILS: 'Integration details',
		INTEGRATION__IDENTIFICATION: 'Identification',
		INTEGRATION__ACCESS: 'Access',
		INTEGRATION__URL_SANDBOX: 'URL Sandbox',
		INTEGRATION__URL_PRODUCTION: 'URL Production',
		INTEGRATION__CREDENTIAL: 'Credencial',
		INTEGRATION__TOKEN: 'Token',
		INTEGRATION__COPY_SECRET_KEY:
			'Copy this key and use it for API authentication. This key will not appear again.',
		INTEGRATION__PERMISSIONS: 'Permissions',
		INTEGRATION__NEW_INTEGRATION: 'New Integration',
		INTEGRATION__CONTENT_COPIED: 'Content has been copied!',
		INTEGRATION__MESSAGE_CREATED: 'Integration has been created successfully!',
		INTEGRATION__MESSAGE_UPDATED: 'Integration has been updated successfully!',
		INTEGRATION__MESSAGE_REMOVED: 'Integration has been removed successfully!',

		LOG_SCHEMA__LOG_SCHEMAS: 'Log Schemas',
		LOG_SCHEMA__LOG_SCHEMA: 'Log Schemas',
		LOG_SCHEMA__FILTER_LOG_SCHEMAS: 'Filter Log Schemas',
		LOG_SCHEMA__NAME: 'Name',
		LOG_SCHEMA__CODE_LOG: 'Code log',
		LOG_SCHEMA__DESCRIPTION: 'Description',
		LOG_SCHEMA__JSON_SCHEMAS: 'JSON Schemas',
		LOG_SCHEMA__LOG_EXAMPLE: 'Log Example',
		LOG_SCHEMA__LOG_DEFINITION: 'Log Definition',
		LOG_SCHEMA__LOG_METADATA: 'Log Metadata',
		LOG_SCHEMA__LABEL: 'Label',
		LOG_SCHEMA__PROPERTY: 'Property',
		LOG_SCHEMA__TYPE: 'Type',
		LOG_SCHEMA__FIXED_VALUE: 'Fixed Value',
		LOG_SCHEMA__OUTPUT: 'Output',
		LOG_SCHEMA__MESSAGE_LOG: 'Log Message',
		LOG_SCHEMA__MESSAGE_LOG_TEMPLATE: 'Log message template',
		LOG_SCHEMA__USE_VARIABLES_IN_FORMAT: 'Use variables in the format',
		LOG_SCHEMA__GENERATED_LOG_MESSAGE: 'Log message generated',
		LOG_SCHEMA__ACKNOWLEDGE: 'Acknowledge',
		LOG_SCHEMA__SUCCESS_ACK: 'Success ACK',
		LOG_SCHEMA__ERROR_ACK: 'Error ACK',
		LOG_SCHEMA__GENERATED_ERROR_ACK: 'Generated Error ACK',
		LOG_SCHEMA__MAIN_UID: 'Main UID',
		LOG_SCHEMA__EVENT_DATE: 'Event Date',
		LOG_SCHEMA__NEW_LOG_SCHEMA: 'New Log Schema',
		LOG_SCHEMA__LOG_SCHEMA_DETAILS: 'Log Schema Details',
		LOG_SCHEMA__MESSAGE_CREATED: 'Log schema has been created successfully!',
		LOG_SCHEMA__MESSAGE_UPDATED: 'Log schema has been updated successfully!',
		LOG_SCHEMA__MESSAGE_REMOVED: 'Log schema has been removed successfully!',
		LOG_SCHEMA__TITLE_ADD: 'Add Log Schema',
		LOG_SCHEMA__MESSAGE_ADD: 'Do you want to add a new log schema?',
		LOG_SCHEMA__TITLE_UPDATE: 'Update Log Schema',
		LOG_SCHEMA__MESSAGE_UPDATE: 'Do you want to update this log schema?',
		LOG_SCHEMA__TITLE_REMOVE: 'Remove Log Schema',
		LOG_SCHEMA__MESSAGE_REMOVE: 'Do you want to remove this log schema?',
		LOG_SCHEMA__PRIORITY:
			'Schemas with high priority will be processed first for the received logs',
		LOG_SCHEMA__TIMESTAMP: 'Timestamp',
		LOG_SCHEMA__UID: 'UID',
		LOG_SCHEMA_BATTERY: 'Battery',
		LOG_SCHEMA__DEVICE_BATTERY: 'Device Battery',
		LOG_SCHEMA__DRIVER_UID: 'Driver',
		LOG_SCHEMA__KEEP_ALIVE: 'Keep Alive',
		LOG_SCHEMA__VALUE: 'Value',

		LOG_TYPE__EVENT_ERROR_INFORMATIVE: 'Informative',
		LOG_TYPE__EVENT_ERROR_ALERT: 'Alert',
		LOG_TYPE__EVENT_ERROR_CRITICAL: 'Critical Error',
		LOG_TYPE__EVENT_ERROR_SUPER_CRITICAL: 'Critical',
		LOG_TYPE__EVENT_NO_ERROR_INFORMATION: 'No Error Information',
		LOG_TYPE__TYPE_ERROR: 'Log type of error',
		LOG_TYPE__LOG_TYPES: 'Log Types',
		LOG_TYPE__LOG_TYPE: 'Log Types',
		LOG_TYPE__CODE: 'Code Log',
		LOG_TYPE__NAME: 'Name',
		LOG_TYPE__ONE: 'Type 1',
		LOG_TYPE__TWO: 'Type 2',
		LOG_TYPE__ACTION__FILTER: 'Filter Log Types',
		LOG_TYPE__DESCRIPTION: 'Description',
		LOG_TYPE__UNIT: 'Unit',
		LOG_TYPE__MESSAGE_CREATED: 'Log type has been created successfully!',
		LOG_TYPE__MESSAGE_UPDATED: 'Log type has been updated successfully!',
		LOG_TYPE__MESSAGE_REMOVED: 'Log type has been removed successfully!',
		LOG_TYPE__TITLE_ADD: 'Add Log Type',
		LOG_TYPE__MESSAGE_ADD: 'Do you want to add a new log type?',
		LOG_TYPE__TITLE_UPDATE: 'Update Log Type',
		LOG_TYPE__MESSAGE_UPDATE: 'Do you want to update this log type?',
		LOG_TYPE__TITLE_REMOVE: 'Remove Log Type',
		LOG_TYPE__MESSAGE_REMOVE: 'Do you want to remove this log type?',
		LOG__TYPES__TEMPERATURE: 'Temperature',

		MENU__EXIT: 'Exit',
		MENU__GROUP__REGISTRATION: 'Registration',
		MENU__GROUP__VISION: 'Vision',
		MENU__GROUP__MONITORING: 'Monitoring',
		MENU__GROUP__DATA: 'Data',
		MENU__GROUP__EXTRA: 'Extra',
		MENU__HOME__TITLE: 'Home',
		MENU__NOTIFICATIONS__TITLE: 'Notifications',
		MENU__USERS__TITLE: 'Users',
		MENU__USERS__DESCRIPTION: 'Management',
		MENU__CAMERAS__TITLE: 'Cameras',
		MENU__VISION__MONITORING__TITLE: 'Monitor',
		MENU__CLIENTS__TITLE: 'Accounts',
		MENU__CLIENTS__DESCRIPTION: 'Management',
		MENU__CLIENT__TITLE: 'My account',
		MENU__CLIENT__DESCRIPTION: 'Management',
		MENU__DEVICES__TITLE: 'Devices',
		MENU__DEVICES__DESCRIPTION: 'Smart',
		MENU__INTEGRATION__TITLE: 'Integrations',
		MENU__INTEGRATION__DESCRIPTION: 'Registration',
		MENU__ACTIONS__TITLE: 'Actions',
		MENU__ACTIONS__DESCRIPTION: 'Registration',
		MENU__PLACES__TITLE: 'Areas',
		MENU__PLACES__DESCRIPTION: 'Registration',
		MENU__EMPLOYEES__TITLE: 'Employees',
		MENU__EMPLOYEES__DESCRIPTION: 'Registration',
		MENU__EQUIPMENTS__TITLE: 'Equipments',
		MENU__EQUIPMENTS__DESCRIPTION: 'Registration',
		MENU__PERMISSION_GROUPS__TITLE: 'Permission Groups',
		MENU__PERMISSION_GROUPS__DESCRIPTION: 'Registration',
		MENU__PRODUCTS__TITLE: 'Products',
		MENU__PRODUCTS__DESCRIPTION: 'Registration',
		MENU__LOG_TYPES__TITLE: 'Log types',
		MENU__LOG_TYPES__DESCRIPTION: 'Registration',
		MENU__ZONEMAP__TITLE: 'Zone Map',
		MENU__ZONEMAP__DESCRIPTION: 'Monitor',
		MENU__BRIGADIER_PANEL__TITLE: 'Brigade Panel',
		MENU__BRIGADIER_PANEL__DESCRIPTION: 'Monitor',
		MENU__MONITORING__TITLE: 'Devices status',
		MENU__MONITORING__DESCRIPTION: 'Monitor',
		MENU__SYNOPTIC__TITLE: 'Sinoptic',
		MENU__SYNOPTIC__ANALYTIC__TITLE: 'Analytic Sinoptic',
		MENU__SYNOPTIC__DESCRIPTION: 'Monitor',
		MENU__REPORTS__TITLE: 'Reports',
		MENU__REPORTS__DESCRIPTION: 'History',
		MENU__INSIGHTS__TITLE: 'Data Insight',
		MENU__INSIGHTS__DESCRIPTION: 'History',
		MENU__SEARCH_DEVICE__TITLE: 'Identify Device',
		MENU__SEARCH_DEVICE__DESCRIPTION: 'Search',
		MENU__FIRMWARES__TITLE: 'Firmwares',
		MENU__FIRMWARES__DESCRIPTION: 'Registration',
		MENU__BOARDS__TITLE: 'Boards',
		MENU__BOARDS__DESCRIPTION: 'Registration',
		MENU__TAGS__TITLE: 'Tags',
		MENU__TAGS__DESCRIPTION: 'Registration',
		MENU__LOG_SCHEMAS__TITLE: 'Log Schemas',
		MENU__LOG_SCHEMAS__DESCRIPTION: 'Registration',
		MENU__MODULES__TITLE: 'Modules',
		MENU__ENGINES__TITLE: 'Engines VS',

		MODALITY_TYPES__RENTAL: 'Rental',
		MODALITY_TYPES__SALE: 'Sale',

		MODULE_SELECTION__ACCESS: 'Access',
		MODULE_SELECTION__WELCOME: 'Welcome!',
		MODULE_SELECTION__DESCRIPTION: 'Select one of the A4 Solutions products',
		MODULE_SELECTION__SMART_SAFETY_DESCRIPTION:
			'Solution to increase safety at work that monitors the position of people in risk areas.',
		MODULE_SELECTION__VISION_DESCRIPTION:
			'With VISION you can extract business information through static images or real-time monitoring.',

		MONITORING__MONITORING: 'Monitoring',
		MONITORING__EVENT_HISTORY: 'Event History',
		MONITORING__STATUS_DEVICES: 'Devices Status',
		MONITORING__TITLE: 'Devices Status',
		MONITORING__DASHBOARD: 'Dashboard',
		MONITORING__MONITOR_BY: 'Monitor by',
		MONITORING__MONITOR: 'Monitor',
		MONITORING__EMPLOYEES: 'Employee',
		MONITORING__DATA_HOUR: 'Hour',

		MONITORING__EMPLOYEE__SUBTITLE: 'All tag types',
		MONITORING__FILTER_EMPLOYEES: 'Filter employees',
		MONITORING__EQUIPMENT__SUBTITLE: 'All core devices',
		MONITORING__EQUIPMENT__FILTER: 'Filter Devices',
		MONITORING__PERMISSION_GROUP: 'Permission Group',
		MONITORING__PERMISSION_GROUP__SUBTITLE: 'Devices of a Group',
		MONITORING__PERMISSION_GROUP__FILTER: 'Filter permission group',
		MONITORING__PLACES: 'Area',
		MONITORING__PLACE__SUBTITLE: 'Devices in a Area',
		MONITORING__PLACE__FILTER: 'Filter Area',
		MONITORING__ONLINE: 'Online',
		MONITORING__OFFLINE: 'Offline',
		MONITORING__WARNING: 'Warning',
		MONITORING__ACTIVE: 'Actives',
		MONITORING__INACTIVE: 'Inactives',
		MONITORING__DEVICES: 'Devices',
		MONITORING__EQUIPMENTS: 'Equipments',
		MONITORING__PERMISSION_GROUPS: 'Permission Groups',
		MONITORING__LAST_EVENTS: 'Latest Events',
		MONITORING__EVENT: 'Event',
		MONITORING__MIDIA: 'Media',
		MONITORING__START: 'Start',
		MONITORING__TIME: 'Time',
		MONITORING__CAMERA_FILTER: 'Filter Cameras',
		MONITORING__CAMERAS: 'Cameras',
		MONITORING__CAMERA: 'Camera',
		MONITORING__MOSAIC: 'Mosaic',
		MONITORING__CREATE_MOSAIC: 'Create Mosaic',
		MONITORING__MONITOR_CAMERA: 'Monitor Camera',
		MONITORING__MOSAIC_CAMERA: 'Monitor Mosaic',
		MONITORING__MAX_MOSAIC: 'The maximum allowed limit is 6 cameras',

		NOTIFICATION__ALERT_PANIC: 'Panic Alert',
		NOTIFICATION__EMPLOYEE: 'Employee',
		NOTIFICATION__REPORT_BY: 'Reported by',
		NOTIFICATION__TIME: 'Time',
		NOTIFICATION__MESSAGE_FINE: 'IS EVERYTHING OK?',
		NOTIFICATION__MESSAGE_NOTIFICATIONS:
			'Before closing this notification, make sure that everything is fine with those involved.',
		NOTIFICATION__ALERT_CLOSE: 'Close alert',

		OPEN_TICKET: 'Open ticket',

		PERMISSION_GROUP__PERMISSION_GROUPS: 'Permission Groups',
		PERMISSION_GROUP__EMPLOYEES_GROUP: 'Employees groups',
		PERMISSION_GROUP__EMPLOYEES: 'Employees',
		PERMISSION_GROUP__EMPLOYEE: 'Employee',
		PERMISSION_GROUP__EQUIPMENTS_PLACES: 'Equipment / Area Groups',
		PERMISSION_GROUP__EQUIPMENT_PLACE: 'Equipment / Area',
		PERMISSION_GROUP__PERMISSION_GROUP_DETAILS: 'Details of permission group',
		PERMISSION_GROUP__NAME: 'Name',
		PERMISSION_GROUP__TYPE: 'Type',
		PERMISSION_GROUP__CREATED: 'Date',
		PERMISSION_GROUP__CLIENT: 'Client',
		PERMISSION_GROUP__ACCOUNT: 'Account',
		PERMISSION_GROUP__NEW_PERMISSION_GROUP: 'New permission group',
		PERMISSION_GROUP__FILTER_PERMISSION_GROUP: 'Filter permission group',
		PERMISSION_GROUP__MESSAGE_CREATED:
			'Permission group has been created successfully!',
		PERMISSION_GROUP__MESSAGE_UPDATED:
			'Permission group has been updated successfully!',
		PERMISSION_GROUP__MESSAGE_REMOVED:
			'Permission group has been removed successfully!!',

		PERMISSION_GROUP_TITLE_ADD: 'Add Permission Group',
		PERMISSION_GROUP_MESSAGE_ADD: 'Do you want to add a new permission group?',
		PERMISSION_GROUP_TITLE_UPDATE: 'Update Permission Group',
		PERMISSION_GROUP_MESSAGE_UPDATE:
			'Do you want to update this permission group?',
		PERMISSION_GROUP_TITLE_REMOVE: 'Remove Permission Group',
		PERMISSION_GROUP_MESSAGE_REMOVE:
			'Do you want to remove this permission group?',
		PERMISSION_GROUP_STATUS__ACTIVE: 'Active',
		PERMISSION_GROUP_STATUS__INACTIVE: 'Inactive',

		PLACE__PLACES: 'Areas',
		PLACE__PLACE: 'Areas',
		PLACE__NAME: 'Name',
		PLACE__TYPE: 'Type',
		PLACE__TYPE__WAREHOUSE: 'Warehouse',
		PLACE__TYPE__REST_AREA: 'Rest Area',
		PLACE__TYPE__KITCHENETTE: 'Kitchenette',
		PLACE__TYPE__STORAGE_SHED: 'Storage Shed',
		PLACE__TYPE__DINING_ROOM: 'Dining Room',
		PLACE__TYPE__LOUNGE: 'Lounge',
		PLACE__CLIENT_NAME: 'Account',
		PLACE__UNIT: 'Unit',
		PLACE__DEPARTMENT: 'Department',
		PLACE__ACTION__STATUS: 'Status',
		PLACE__FILTER_PLACE: 'Filter Areas',
		PLACE__ZONE_MAP: 'Zone Map',
		PLACE__ACTIVATE_ZONE_MAP: 'Activate Zone Map',
		PLACE__TIME_AVAILABLE_WEEK: 'Time available in the week (H)',
		PLACE__MAX_TIME_STAY: 'Max. time to stay (m)',
		PLACE__BRIGADIER: 'Brigade Member',
		PLACE__BRIGADIER_PANEL: 'Brigade Panel',
		PLACE__ACTION__ACTIVATE_BRIGADIER_PANEL: 'Activate Brigade Panel',
		PLACE__MINIMUM_QUANTITY_CIPA: 'Min. quantity of CIPA members)',
		PLACE__BRIGADIER_MINIMUM_QUANTITY: 'Min. quantity of brigade members',
		PLACE__ACTION__ASSOCIATE: 'Associations',
		PLACE__ACTION__DEVICES_ASSOCIATED: 'Devices Associated',
		PLACE__CONNECT: 'Associate',
		PLACE__CONNECT_DEVICES: 'Associate Devices',
		PLACE__CONNECT_CAMERAS: 'Associate Cameras',
		PLACE__ASSOCIATED_GROUPS: 'Associated Groups',
		PLACE__EVENT_HISTORY: 'Events History',
		PLACE__EVENT: 'Event',
		PLACE__TIME: 'Time',
		PLACE__NEW: 'New Area',
		PLACE__DETAILS: 'Area Details',
		PLACE__MESSAGE_CREATED: 'Area has been created successfully!',
		PLACE__MESSAGE_UPDATED: 'Area has been updated successfully!',
		PLACE__MESSAGE_REMOVED: 'Area has been removed successfully!',
		PLACE__STATUS: 'Status',
		PLACE_STATUS__ACTIVE: 'Active',
		PLACE_STATUS__INACTIVE: 'Inactive',
		PLACE__TITLE_ADD: 'Add Area',
		PLACE__MESSAGE_ADD: 'Do you want to add a new area?',
		PLACE__TITLE_UPDATE: 'Update area',
		PLACE__MESSAGE_UPDATE: 'Do you want to update this area?',
		PLACE__TITLE_REMOVE: 'Remove Area',
		PLACE__MESSAGE_REMOVE: 'Do you want to remove this area?',
		PLACE__DOCUMENT_MESSAGE_REMOVE: 'Do you want to remove this document?',
		PLACE__DOCUMENT__FILE_REMOVED: 'Document has been removed successfully!',
		PLACE__DOCUMENT_TITLE_REMOVE: 'Remove Document',
		PLACE__TITLE_DOWNLOAD: 'Download Document',
		PLACE__DOCUMENT_MESSAGE_DOWNLOAD: 'Do you want to download this document?',

		PRODUCT__PRODUCTS: 'Products',
		PRODUCT__PRODUCT: 'Product',
		PRODUCT__NAME: 'Name',
		PRODUCT__PART_NUMBER: 'Part Number',
		PRODUCT__ACTION__FILTER: 'Filter Products',
		PRODUCT__TYPE: 'Type',
		PRODUCT__NEW: 'New Product',
		PRODUCT__DETAILS: 'Product Details',
		PRODUCT__PROFILES: 'Profiles',
		PRODUCT__MESSAGE_CREATED: 'Product has been created successfully!',
		PRODUCT__MESSAGE_UPDATED: 'Product has been updated successfully!',
		PRODUCT__MESSAGE_REMOVED: 'Product has been removed successfully!',
		PRODUCT__TITLE_ADD: 'Add Product',
		PRODUCT__MESSAGE_ADD: 'Do you want to add a new product?',
		PRODUCT__TITLE_UPDATE: 'Update Product',
		PRODUCT__MESSAGE_UPDATE: 'Do you want to update this product?',
		PRODUCT__TITLE_REMOVE: 'Remove Product',
		PRODUCT__MESSAGE_REMOVE: 'Do you want to remove this product?',
		PLACE__DOCUMENTS__ERROR_MESSAGE: 'File must contain no more than 10MB',
		PLACE__DOCUMENTS__UPLOAD_FILES: 'Upload Files',
		PLACE__DOCUMENTS__DOCUMENT: 'Document',

		REPORTS__REPORTS: 'Reports',
		REPORTS__ACCOUNTS: 'Accounts',
		REPORTS__MANAGEMENT: 'Management',
		REPORTS__EMPLOYEES: 'Employees',
		REPORTS__EQUIPMENTS: 'Equipments',
		REPORTS__EQUIPMENT: 'Equipment',
		REPORTS__PLACES: 'Area',
		REPORTS__DEVICES: 'Devices',
		REPORTS__SMART: 'Smart',
		REPORTS__GROUPS: 'Groups',
		REPORTS__EVENTS: 'Events',
		REPORTS__ALL_EVENTS: 'All Events',
		REPORTS__REGISTER: 'Registration',
		REPORTS__EMPLOYEE_APPROXIMATION: 'Approximation per employee',
		REPORTS__REPORT_EVENTS: 'Events report',
		REPORTS__START_DATE: 'Start date',
		REPORTS__END_DATE: 'End date',
		REPORTS__DEVICE: 'Device',
		REPORTS__UID: 'UID',
		REPORTS__UID_TAG: 'UID Tag',
		REPORTS__PORTAL_UID: 'Portal - UID',
		REPORTS__EMPLOYEE: 'Employee',
		REPORTS__NAME: 'Name',
		REPORTS__REGISTRATION: 'Registration',
		REPORTS__UNIT: 'Unit',
		REPORTS__DEPARTMENT: 'Department',
		REPORTS__ACTIVE_NUMBER: 'Active number',
		REPORTS__MAINTENANCE: 'Maintenance',
		REPORTS__MAINTENANCE_EVENTS: 'Maintenance events',
		REPORTS__EVENT_PASSAGE: 'Passage event',
		REPORTS__EVENT_COD_LOG: 'Event code log: 508 and 509',

		SAFETY__DESCRIPTION_STEP1: 'Start the process',
		SAFETY__DESCRIPTION_STEP2: 'Take your selfie',
		SAFETY__DESCRIPTION_STEP3: 'Confirm the identification',
		SAFETY__DESCRIPTION_STEP4: 'Done! Finished',
		SAFETY__CAPTURE_PHOTO: 'Recognize',
		SAFETY__INSTRUCTIONS:
			'Position your face in the photo area and press the RECOGNIZE button or use the registration number IDENTIFICATION OPTION.',
		SAFETY__EMPLOYEE_IDENTIFYING: 'Identifying employee...',
		SAFETY__REGISTRATION_NUMBER: 'Enter your registration number!',
		SAFETY__LICENSE_PLATE: 'Enter the registration number',
		SAFETY__IDENTIFY: 'Identify',
		SAFETY__HELPER: 'Help?',
		SAFETY__INSTRUCTION_PROCESS:
			'Check out the steps below and go through the process. If you still need help, use the buttons below:',
		SAFETY__PROCESS: 'Got it, do the process',
		SAFETY__EMPLOYEE: 'Hello, employee!',
		SAFETY__MANDATORY_BRIGADIER_OR_EMPLOYEE:
			'If you are a brigade member or a CIPA member, you must identify yourself. Check out the process!',
		SAFETY__START: 'Start',
		SAFETY__MESSAGE_ERROR: 'We could not identify!',
		SAFETY__MESSAGE_CREATED: 'Identification successfully completed!',
		SAFETY__SELECT: 'Select one of the options below:',
		SAFETY__TRY_AGAIN: 'Try again',
		SAFETY__TYPE_IDENTIFICATION: 'Identify with the registration number',
		SAFETY__VIEW_HELPER: 'Ask for help',
		SAFETY__REGISTRATION: 'Registration',
		SAFETY__EXIT: 'Exit',
		SAFETY__PROHIBITED: 'Enter',
		SAFETY__CONFIRM: 'It is me, confirm',
		SAFETY__REDO: 'It is not me, redo',
		SAFETY__REGISTRATION_REDO: ' It is not me, redo with registration',
		SAFATY__START_BACK: 'Going back to the beginning in',

		SLOGAN_BOX__INFORMATION: 'Your safety, our asset',
		SUPPORT__BASIC: 'Basic',
		SUPPORT__BUSINESS: 'Business',
		SUPPORT__NO_SUPPORT: 'No support',

		SYNOPTIC__SYNOPTIC: 'Sinoptic',
		SYNOPTIC__MAP: 'Map',
		SYNOPTIC__LEGEND: 'Legend',
		SYNOPTIC__SECURITY_AREA: 'Security area',
		SYNOPTIC__SECURITY_CROSSING: 'Crosswalk',
		SYNOPTIC__ONLINE_DEVICE: 'Online device',
		SYNOPTIC__OFFLINE_DEVICE: 'Offline device',
		SYNOPTIC__PASSAGE_EVENT: 'Passage event',
		SYNOPTIC__EVENT_ERROR: 'Error event',
		SYNOPTIC__EVENTS: 'Events',
		SYNOPTIC__EVENT: 'Event',
		SYNOPTIC__SAFE_ZONE: 'Safe zone',
		SYNOPTIC__ACCESS: 'Access',
		SYNOPTIC__EQUIPMENT: 'Forklift',
		SYNOPTIC__TIME: 'Time',
		SYNOPTIC__EMPLOYEE: 'Employee',
		SYNOPTIC__TF_PORTAL: 'TF Portal',

		SYNOPTIC__ANALYTIC_FORKLIFT_STOPS: 'FORKLIFT STOP',
		SYNOPTIC__ANALYTIC_ERROR_PASSAGE: 'ERROR PASSAGE',
		SYNOPTIC__ANALYTIC_BATTERY: 'BATTERY',
		SYNOPTIC__ANALYTIC__EQUIPMENT: 'FORKLIFT',
		SYNOPTIC__ANALYTIC__DEVICE: 'DEVICE',
		SYNOPTIC__ANALYTIC__ALERT: 'ALERT',
		SYNOPTIC__ANALYTIC__EMPLOYEE: 'EMPLOYEE',
		SYNOPTIC__ANALYTIC__APPROXIMATION: 'APPROXIMATION',
		SYNOPTIC__ANALYTIC__DATE_HOUR: 'DATE/TIME',
		SYNOPTIC__ANALYTIC__PORTAL: 'PORTAL',
		SYNOPTIC__ANALYTIC__MSG: 'MESSAGE',
		SYNOPTIC__ANALYTIC__CODE_LOG_122: 'Equipamento Aéreo',
		SYNOPTIC__ANALYTIC__CODE_LOG_131: 'TAG PLUS V3',
		SYNOPTIC__ANALYTIC__CODE_LOG_137: 'TAG STD V3',
		SYNOPTIC__ANALYTIC__CODE_LOG_140: '?',
		SYNOPTIC__ANALYTIC__CODE_LOG_510: 'Invalid entry passage',
		SYNOPTIC__ANALYTIC__CODE_LOG_513: 'Invalid exit passage',

		TAGS__TAGS: 'Tags',
		TAGS__TAG: 'Tag',
		TAGS__SCOPE: 'Scope',
		TAGS__ACCOUNT: 'Account',
		TAGS__GROUP: 'Group',
		TAGS__VALUE: 'Value',
		TAGS__FILTER_TAGS: 'Filter Tags',
		TAGS__TOTAL_REFERENCES: 'Total of References',
		TAGS__NEW_TAG: 'New Tag',
		TAGS__TAG_DETAILS: 'Tag Details',
		TAGS__MESSAGE_UPDATED: 'Tag has been updated successfully!',
		TAGS__MESSAGE_REMOVED: 'Tag has been removed successfully!',
		TAGS__INSTRUCTIONS:
			'Enter a value and press <strong>Enter</strong> to create a new item',

		TAGS__TITLE_REMOVE: 'Remove Tag',
		TAGS__SCOPE_APPLICATION: 'Application',
		TAGS__SCOPE__APPLICATION_DESCRIPTION:
			'The tags are shared among all application clients.',
		TAGS__SCOPE_CLIENT: 'Client',
		TAGS__SCOPE__CLIENT_DESCRIPTION:
			'The tags are shared only within the same client.',
		TAGS__SCOPE_REGISTER: 'Register',
		TAGS__SCOPE__REGISTER_DESCRIPTION:
			'The tags are shared only for a registration within a client.',

		USER__USERS: 'Users',
		USER__NAME: 'Name',
		USER__ACCOUNT: 'Account',
		USER__PROFILE: 'Profile',
		USER__EMAIL: 'Email',
		USER__ACTION__FILTER: 'Filter Users',
		USER__CLIENT: 'Client',
		USER_USER: 'Users',
		USER__NEW_USER: 'New User',
		USER__USER_DETAILS: 'User Details',
		USER__FULL_NAME: 'Full Name',
		USER__CPF: 'CPF',
		USER__PHONE: 'Phone',
		USER__MODULE: 'Module',
		USER__NEW_PASSWORD: 'New Password',
		USER__CONFIRM_PASSOWRD: 'Repeat Password',
		USER__MESSAGE_PASSWORD_ERROR: 'Password does not match',
		USER__MESSAGE_CREATED: 'User has been created sucessfully!',
		USER__MESSAGE_UPDATE_USER:
			'To apply the new language settings, you will be logged out and will need to log in again. Thank you for your understanding.',
		USER__MESSAGE_UPDATED: 'User has been updated sucessfully!',
		USER__MESSAGE_REMOVED: 'User has been removed sucessfully!',
		USER_STATUS__ACTIVE: 'Active',
		USER_STATUS__INACTIVE: 'Inactive',
		USER__MESSAGE_ADD: 'Do you want to add the user?',
		USER__MESSAGE_UPDATE: 'Do you want to update the user?',
		USER__TITLE_UPDATE: 'Update user',
		USER__TITLE_ADD: 'Add user',
		USER__TITLE_REMOVE: 'Delete user',
		USER__MESSAGE_REMOVE: 'Do you want to remove the user?',
		USER__IDIOM: 'Language',

		VISION__LIVE_CAMERA_TITLE: 'Live Camera',
		VISION__CAMERA_LIST: 'Camera List',
		VISION__SELECTED_CAMERA: 'Selected Camera',
		VISION__CAMERA_DATA: 'Camera Data',
		VISION__FAVORITE_CAMERA: 'Favorite Camera',
		VISION__CAMERA_AMBIENCE: 'Camera Ambience',
		VISION__INITIAL_HOUR: 'Hour',
		VISION__EVENT: 'Event',
		VISION__MIDIA: 'Midia',
		VISION__MONITORING__MONITOR: 'Monitor',

		ZONE_MAP__ZONE_MAP: 'Zone Map',
		ZONE_MAP__ZONE_MAPS: 'Zone Maps',
		ZONE_MAP__NAME: 'Name',
		ZONE_MAP__ACCOUNT: 'Account',
		ZONE_MAP__TYPE: 'Type',
		ZONE_MAP__UNIT: 'Unit',
		ZONE_MAP__DEPARTMENT: 'Department',
		ZONE_MAP__STATUS: 'Status',
		ZONE_MAP__STATUS__ACTIVE: 'Active',
		ZONE_MAP__STATUS__INACTIVE: 'Inactive',
		ZONE_MAP__FILTER_ZONES: 'Filter Zones',
		ZONE_MAP__ZONES: 'Zones',
		ZONE_MAP__MONITOR: 'Monitor',
		ZONE_MAP__MONITORING: 'Monitoring',
		ZONE_MAP__DEVICES: 'Devices',
		ZONE_MAP__IN_ZONE_NOW: 'In the zone now',
		ZONE_MAP__MINUTES: 'Minutes',
		ZONE_MAP__MAX_STAY_TIME: 'Maximum stay time',
		ZONE_MAP__STAY: 'Stay',
		ZONE_MAP__FORCE_EXIT: 'Force exit',

		WELCOME_WELCOME: 'Thank You!',

		EQUIPMENT__FORKLIFT: 'Forklift',
		EQUIPMENT__OVERHEAD_CRANE: 'Overhead Crane',
		EQUIPMENT__TRUCK: 'Truck',
		EQUIPMENT__LOADER: 'Loades',
		EQUIPMENT__TRAIN: 'Train',
		EQUIPMENT__AREA: 'Area',
		EQUIPMENT__CAR: 'Car',
		EQUIPMENT__TRACTOR: 'Tractor',
		EQUIPMENT__CRANE: 'Crane',
		EQUIPMENT__TITLE_ADD: 'Add Equipment',
		EQUIPMENT__MESSAGE_ADD: 'Do you want to add a new equipment?',
		EQUIPMENT__TITLE_UPDATE: 'Update Equipment',
		EQUIPMENT__MESSAGE_UPDATE: 'Do you want to update this equipment?',
		EQUIPMENT__TITLE_REMOVE: 'Remove Equipment',
		EQUIPMENT__DOCUMENT_TITLE_REMOVE: 'Remove Document of Equipment',
		EQUIPMENT__TITLE_DOWNLOAD: 'Download Document',
		EQUIPMENT__MESSAGE_REMOVE: 'Do you want to remove this equipment?',
		EQUIPMENT__MESSAGE_ERROR_REMOVING_FILE: 'Error removing document!',
		EQUIPMENT__MESSAGE_REMOVED_FILE: 'Document has been removed successfully!',
		EQUIPMENT__DOCUMENT_MESSAGE_REMOVE: 'Do you want to remove this document?',
		EQUIPMENT__DOCUMENT_MESSAGE_DOWNLOAD:
			'Do you want to download this document?',
		EQUIPMENTS__TITLE_ADD: 'Add Equipments',
		EQUIPMENTS__MESSAGE_ADD: 'Do you want to add a new(s) equipment(s)?',

		ACTION__ACTIVE: 'Active',
		ACTION__INACTIVE: 'Inactive',

		EQUIPMENT_STATUS__ACTIVE: 'Active',
		EQUIPMENT_STATUS__INACTIVE: 'Inactive',
		BRIGADIER_PANEL_STATUS__ACTIVE: 'Active',
		BRIGADIER_PANEL_STATUS__INACTIVE: 'Inactive',

		CONTRACT_STATUS__ACTIVE: 'Active',
		CONTRACT_STATUS__INACTIVE: 'Inactive',
		CONTRACT__TITLE_ADD: 'Add Contract',
		CONTRACT__MESSAGE_ADD: 'Do you want to add a new contract?',
		CONTRACT__TITLE_UPDATE: 'Update Contract',
		CONTRACT__MESSAGE_UPDATE: 'Do you want to update this contract?',
		CONTRACT__TITLE_REMOVE: 'Remove Contract',

		DEVICE_STAGE__PRODUCTION: 'Production',
		DEVICE_STAGE__TEST: 'Test',
		DEVICE_STAGE__STOCK: 'Stock',
		DEVICE_STAGE__TRANSPORT: 'Transport',
		DEVICE_STAGE__INSTALLED: 'Installed',
		DEVICE_STATUS__ACTIVE: 'Active',
		DEVICE_STATUS__INACTIVE: 'Inactive',

		DEVICE_TYPE__CORE: 'Core',
		DEVICE_TYPE__TAG: 'Tag',
		DEVICE_TYPE__ACCESSORY: 'Accessory',
		DEVICE_TYPE__CAMERA: 'Camera',
		DEVICE_TYPE__SOFTCORE: 'Softcore',

		BOARD_STAGES__TESTING: 'Testing',
		BOARD_STAGES__APPROVED: 'Approved',
		BOARD_STAGES__NOT_APPROVED: 'Not approved',

		EVENT_LEVEL__ALERT: 'Alert',
		EVENT_LEVEL__DANGER: 'Danger',
		EVENT_LEVEL__INFORMATIVE: 'Informative',

		EVENT_TYPE__APPROXIMATION: 'Approximation',
		EVENT_TYPE__APPROXIMATION_4M: 'Approximation 4 meters',
		EVENT_TYPE__APPROXIMATION_6M: 'Approximation 6 meters',
		EVENT_TYPE__ENTRY: 'Entry',
		EVENT_TYPE__EXIT: 'Exit',
		EVENT_TYPE__ERROR: 'Error',

		FIRMWARE_STAGE__TESTING: 'Testing',
		FIRMWARE_STAGE__APPROVED: 'Approved',
		FIRMWARE_STAGE__NOT_APPROVED: 'Not Approved',

		INTEGRATION_STATUS__ACTIVE: 'Active',
		INTEGRATION_STATUS__INACTIVE: 'Inactive',
		INTEGRATION__TITLE_ADD: 'Add Integration',
		INTEGRATION__MESSAGE_ADD: 'Do you want to add a new integration?',
		INTEGRATION__TITLE_UPDATE: 'Update Integration',
		INTEGRATION__MESSAGE_UPDATE: 'Do you want to update this integration?',
		INTEGRATION__TITLE_REMOVE: 'Remove Integration',
		INTEGRATION__MESSAGE_REMOVE: 'Do you want to remove this integration?',

		LANGUAGE__ENGLISH: 'English',
		LANGUAGE__PORTUGUESE_BR: 'Portuguese',
		LANGUAGE__SPANISH: 'Spanish',

		LOG_PRIORITY__HIGH: 'High',
		LOG_PRIORITY__LOW: 'Low',

		LOG_TYPES__TEXT: 'Text',
		LOG_TYPES__MEASUREMENT: 'Measurement',
		LOG_TYPES__NULL: 'Null',
		LOG_TYPES__UID: 'UID',
		LOG_TYPES__TITLE_ADD: 'Add Log Type',
		LOG_TYPES__MESSAGE_ADD: 'Do you want to add a new log type?',
		LOG_TYPES__TITLE_UPDATE: 'Update Log Type',
		LOG_TYPES__MESSAGE_UPDATE: 'Do you want to update this log type?',
		LOG_TYPES__TITLE_REMOVE: 'Remove Log Type',
		LOG_TYPES__MESSAGE_REMOVE: 'Do you want to remove this log type?',
	},
	es: {
		ACCESS_BASE: 'Acceso a la base',
		ACCESS_PLATFORM: 'Acceso a la plataforma',
		ACCESS__LOGIN: 'Login',
		ACCESS__MESSAGE_ACCESS__RECOVER_PASSWORD_USER:
			'Si este correo electrónico está registrado, recibirá un enlace para recuperar su contraseña.',
		ACCESS__RECOVER_PASSWORD: 'Recuperar contraseña',
		ACCESS__REMEMBER_EMAIL: 'Recordar el correo electrónico',
		ACCESS__ACTION_BACK: 'Volver al inicio de sesión',
		ACCESS__MESSAGE_ACCESS__RECOVER_PASSWORD:
			'Te hemos enviado un correo electrónico de recuperación de contraseña. Haga clic en el enlace del correo electrónico y actualícela!',
		ACCESS__EMAIL_WAS_SENT_TO: 'Se ha enviado un correo electrónico a',
		ACCESS__REMEMBER_ACCOUNT: 'Recordar el correo electrónico',
		ACCESS__EMAIL: 'Correo electrónico',
		ACCESS__PASSWORD: 'Contraseña',
		ACCESS__CPF: 'CPF',
		ACCESS__NEW_PASSWORD: 'Nueva contraseña',
		ACCESS__CONFIRM_PASSWORD: 'La contraseña no coincide',
		ACCESS__CHANGE_PASSWORD: 'Cambiar contraseña',
		ACCESS__RECOVERED_SUCCESS: 'Contraseña restablecida correctamente',
		ACCESS__NEW_PASSWORD_REPEAT: 'Repita la nueva contraseña',

		ACTION__ACTIONS: 'Actions',
		ACTION__NAME: 'Nombre',
		ACTION__ACCOUNT: 'Cuenta',
		ACTION__TYPE: 'Tipo',
		ACTION__LANGUAGE: 'Lenguaje',
		ACTION__STATUS: 'Status',
		ACTION__FILTER_ACTIONS: 'Filtrar actions',
		ACTION__CLIENT: 'Cliente',
		ACTION__ACTION: 'Action',
		ACTION__COMMENTS: 'Observaciones Generales',
		ACTION__PERMISSION_GROUPS: 'Grupos de permisos',
		ACTION__CODE: 'Codigo',
		ACTION__ACTION_TYPE: 'Tipo de Action',
		ACTION__RETURN: 'Retorno',
		ACTION__SCRIPT: 'Script',
		ACTION__SCRIPT_CODE: 'Codigo script',
		ACTION__NEW_ACTION: 'Nuevo action',
		ACTION__ACTION_DETAILS: 'Detalles de action',
		ACTION__MESSAGE_CREATED: '¡Acción añadida con éxito!',
		ACTION__MESSAGE_UPDATED: '¡Acción modificada con éxito!',
		ACTION__MESSAGE_REMOVED: '¡Acción eliminada con éxito!',
		ACTION__TITLE_ADD: 'Añadir acción',
		ACTION__MESSAGE_ADD: 'Quieres añadir una nueva acción?',
		ACTION__TITLE_UPDATE: 'Actualizar acción',
		ACTION__MESSAGE_UPDATE: 'Quieres actualizar esta acción?',
		ACTION__TITLE_REMOVE: 'Eliminar acción',
		ACTION__MESSAGE_REMOVE: 'Quieres eliminar esta acción?',

		BOARDS__BOARDS_REPOSITORY: 'Repositorio de boards',
		BOARDS__BOARDS: 'Boards',
		BOARDS__STAGE: 'Etapa',
		BOARDS__FILTER_BOARDS: 'Filtrar boards',
		BOARDS__NAME: 'Nombre',
		BOARDS__VERSION: 'Versión',
		BOARDS__RELEASE_DATE: 'Fecha de publicación',
		BOARDS__EXPIRATION_DATE: 'Fecha de vencimiento',
		BOARDS__BOARD_DETAILS: 'Detalles del board',
		BOARDS__REGISTRATION: 'Inscripción',
		BOARDS__FIRMWARES: 'Firmwares',
		BOARDS__DOCUMENTATION: 'Documentación',
		BOARDS__CHANGELOG: 'Changelog',
		BOARDS__COMMENTS: 'Observaciones',
		BOARDS__COMPATIBILITY: 'Compatibilidad',
		BOARDS__PRODUCT: 'Producto',
		BOARDS__FEATURES: 'Features',
		BOARDS__BOARD_FILE: 'Archivo Board',
		BOARDS__DOCUMENTATION_FILE: 'Archivo documentación',
		BOARDS__PREVIEW: 'Preview',
		BOARDS__MESSAGE_FILE_SIZE_LIMIT: 'El archivo no debe superar los 4 MB',
		BOARDS__NEW_BOARD: 'Nuevo board',
		BOARDS__MESSAGE_CREATED: '¡Board añadido con éxito!',
		BOARDS__MESSAGE_UPDATED: '¡Board modificado con éxito!',
		BOARDS__MESSAGE_REMOVED: '¡Board eliminado con éxito!',
		BOARDS__MESSAGE_FILE_REMOVED: '¡Archivo eliminado con éxito!',
		BOARDS__BOARD_ADD: 'Añadir board',
		BOARDS__BOARD_MESSAGE_ADD: 'Quieres añadir un nuevo board?',
		BOARDS__TITLE_UPDATE: 'Actualizar board',
		BOARDS__MESSAGE_UPDATE: 'Quieres actualizar este board?',
		BOARDS__BOARD_REMOVE: 'Eliminar board',
		BOARDS__BOARD_MESSAGE_REMOVE: 'Quieres eliminar este board?',

		BRIGADIER__PANEL: 'Panel Brigadista',
		BRIGADIER__NAME: 'Nombre',
		BRIGADIER__ACCOUNT: 'Cuenta',
		BRIGADIER__STATUS: 'Status',
		BRIGADIER__FILTER_PANELS: 'Filtrar paneles',
		BRIGADIER__PANELS: 'Paneles',
		BRIGADIER__MONITOR: 'Monitorear',
		BRIGADIER__MIN_BRIGADIERS: 'Min. Brigadistas',
		BRIGADIER__MIN_MEMBERS: 'Min. miembros CIPA',
		BRIGADIER__MONITORING: 'Monitoreo',
		BRIGADIER__BRIGADIERS: 'Brigadistas',
		BRIGADIER__BRIGADIER: 'Brigadistas',
		BRIGADIER__IN_THIS_ENVIRONMENT_NOW: 'En este entorno ahora',
		BRIGADIER__FORCE_EXIT: 'Salir forzosamente',
		BRIGADIER__MEMBER: 'Miembro de CIPA',

		BULK__INVALID_RECORDS: 'Registro(s) incorrecto(s)',
		BULK__DOWNLOAD: 'Descargar el archivo en formato .csv',
		BULK__TEMPLATE_DOWNLOAD: 'Descargar modelo',
		BULK__TEMPLATE: 'Modelo',
		BULK__AS_EDIT: 'Editar las',
		BULK__INFORMATIONS: 'Informaciones',
		BULK__FILE_IMPORT: 'Importar el Archivo',
		BULK__FILE_UPLOAD: 'Carga de Archivos',
		BULK__TEMPLATE_UPLOAD: 'Carga de Modelo',
		BULK__COMPLETE: 'Completo',
		BULK__MESSAGE__FILE_SIZE_ERROR: 'El archivo no debe superar los 4 MB',
		BULK__INSTRUCTIONS:
			'Para completar el proceso de inclusión, corrija los registros no válidos en su plantilla y cárguela de nuevo.<br /><strong>No se ha importado ningún registro.</strong>',
		BULk__COMPLETE_INCLUSION: 'Finalizar la inclusión',
		BULK__INVALID_INFORMATION: 'Información no válida',
		BULK__ROW: 'Línea',
		BULK__RECORDS_REVIEW: 'Revisión de los registros',
		BULK__COMPLETE_INCLUSION: 'Finalizar la inclusión',

		CAMERA__NEW_CAMERA: 'Nueva cámara',
		CAMERA__CAMERA: 'Cámara',
		CAMERA__CAMERAS: 'Cámaras',
		CAMERA__NAME: 'Nombre',
		CAMERA__MODEL: 'Modelo',
		CAMERA__MANUFACTURER: 'Fabricante',
		CAMERA__ENVIRONMENT: 'Area',
		CAMERA__FILTER_CAMERAS: 'Filtrar cámaras',
		CAMERA__LOCATION: 'Localización',
		CAMERA__IP: 'IP',
		CAMERA__STATUS: 'Status',
		CAMERA__STATUS__ACTIVE: 'Activo',
		CAMERA__STATUS__INACTIVE: 'Inactivo',
		CAMERA__DETAILS: 'Detalles de la cámara',
		CAMERA__TAB_DETAILS: 'Detalles',
		CAMERA__ENGINE_TAB: 'Engine',
		CAMERA__EVENTS_TAB: 'Eventos',
		CAMERA__IDENTIFICATION: 'Identificación',
		CAMERA__UNIT: 'Unidad',
		CAMERA__SELECT: 'Seleccionar',
		CAMERA__DEPARTAMENT: 'Departamento',
		CAMERA__INFORMATION: 'Información',
		CAMERA__CONNECTION: 'Conexión',
		CAMERA__CONNECT: 'Asociar cámara',
		CAMERA__CONNECTION_URL: 'URL de conexión',
		CAMERA__KINESIS_URL: 'URL kinesis de conexión',
		CAMERA__SERIAL_NUMBER: 'Núm. Serie',
		CAMERA__UID: 'UID',
		CAMERA__FIRMWARE: 'Firmware',
		CAMERA__STAGE: 'Etapa',
		CAMERA__STAGE_PRODUCTION: 'Producción',
		CAMERA__STAGE_TEST: 'Prueba',
		CAMERA__STAGE_STOCK: 'Stock',
		CAMERA__STAGE_TRANSPORT: 'Transporte',
		CAMERA__STAGE_INSTALLED: 'Instalado',
		CAMERA__USER: 'Usuário',
		CAMERA__PASSWORD: 'Contraseña',
		CAMERA__RESOLUTION: 'Resolución',
		CAMERA__OBSERVATIONS: 'Observaciones',
		CAMERA__ASSOCIATIONS: 'Asociaciones',
		CAMERA__ASSOCIATIONS_CAMERAS: 'Cámaras asociadas',
		CAMERA__ENGINE_NAME: 'Nome da Engine',
		CAMERA__ENGINE_INCLUSION_DATE: 'Data de inclusão',
		CAMERA__ENGINE_QTD_PARAMETERS: 'Qtde. de parâmetros',
		CAMERA__ENGINE_SOFTCORE: 'Softcore',
		CAMERA__DEVICE_TYPE__SOFTCORE: 'Softcore',
		CAMERA__CAMERAS_AVAILABLE: 'Cámaras disponibles',
		CAMERA__ENGINE_TOTAL_EVENTS: 'Total de eventos',
		CAMERA__ENGINE_NEW_ENGINE: 'Nova Engine',
		CAMERA__CLASSES: 'Classes',
		CAMERA__REKOGNITION_CLASSES: 'Classes de reconhecimento',
		CAMERA__CLASS_PRECISION: '% de precisión',
		CAMERA__VALUE__HELP: 'Elige un valor entre 40 y 99',
		CAMERA__TIMEOUT_SHOOT: 'Tiempo de captura(segundos)',
		CAMERA__DESCRIPTION: 'Descripción',
		CAMERA__DEFAULT_CLASS_ORIENTATION:
			'Valor único para todas las clases definidas a continuación',

		CAMERA__TITLE_ADD: 'Añadir cámara',
		CAMERA__MESSAGE_ADD: 'Quieres añadir una nueva cámara?',
		CAMERA__TITLE_UPDATE: 'Actualizar cámara',
		CAMERA__MESSAGE_UPDATE: 'Quieres actualizar esta cámara?',
		CAMERA__TITLE_REMOVE: 'Eliminar cámara',
		CAMERA__MESSAGE_REMOVE: 'Quieres eliminar esta cámara?',
		CAMERA__MESSAGE_CREATED: '¡Cámara añadida con éxito!',
		COMMON__ERROR__FORCE_EXIT: '¡Error al forzar la salida de la cámara!',
		CAMERA__REMOVED_SUCCESSFULLY: '¡Cámara eliminada con éxito!',
		CAMERA__ERROR__LOAD_CAMERA: 'Error al cargar la cámara',
		CAMERA__MESSAGE_UPDATED: '¡Cámara modificada con éxito!',
		CAMERA__MESSAGE_REMOVED: '¡Cámara eliminada con éxito!',
		CAMERA__ENGINE_DETAILS: 'Detalles de la Engine',
		CAMERA__NEW_ENGINE: 'Nueva Engine',

		CLIENT__ACCOUNTS: 'Cuentas',
		CLIENT__ACCOUNT: 'Cuenta',
		CLIENT__NAME: 'Nombre',
		CLIENT__ADDRESS: 'Dirección',
		CLIENT__ADDRESS__STATE: 'Estado',
		CLIENT__ADDRESS__CITY: 'Ciudad',
		CLIENT__ADDRESS__ZIP_CODE: 'Codigo Postal',
		CLIENT__ADDRESS__STREET: 'Dirección',
		CLIENT__ADDRESS__STREET2: 'Complemento',
		CLIENT__ADDRESS__DISTRICT: 'Barrio',
		CLIENT__ADDRESS__NUMBER: 'Número',
		CLIENT__ASSOCIATION_DATE: 'Fecha de asociación',
		CLIENT__FILTER_ACCOUNTS: 'Filtrar cuentas',
		CLIENT__LOCATION: 'Local',
		CLIENT__ACCOUNT_DETAILS: 'Detalles de la cuenta',
		CLIENT__TRADE_NAME: 'Nombre Comercial',
		CLIENT__COMPANY_NAME: 'Razón Social',
		CLIENT__ACCOUNT_NUMBER: 'Número de la cuenta',
		CLIENT__CNPJ: 'CNPJ',
		CLIENT__IE: 'Registro Estatal',
		CLIENT__IM: 'Registro Municipal',
		CLIENT__COMMENTS: 'Datos complementarios',
		CLIENT__HELPER_CENTER: 'Help Center',
		CLIENT__TICKETS: 'Tickets',
		CLIENT__KNOWLEDGE_BASE: 'Base de conocimientos',
		CLIENT__SUPPORT_EMAIL: 'Asistencia por correo electrónico',
		CLIENT__SUPPORT_EMAIL_TEXT: 'Soporte de texto por correo electrónico',
		CLIENT__SUPPORT_WHATSAPP: 'Whatsapp Soporte',
		CLIENT__SUPPORT_WHATSAPP_TEXT: 'Whatsapp Soporte Texto',
		CLIENT__DOCUMENTATION_URL: 'Documentación',
		CLIENT__DATA_INSIGHT: 'Data Insight',
		CLIENT__CUSTOMIZATIONS: 'Personalizaciones',
		CLIENT__URL: 'URL',
		CLIENT__COLORS: 'COLORES',
		CLIENT__ACCESS_LINK: 'Link de acceso',
		CLIENT__PRIMARY_COLOR: 'Color primario',
		CLIENT__SECONDARY_COLOR: 'Color secundario',
		CLIENT__PRIMARY_COLOR_DESCRIPTION:
			'El color principal se utilizará para los botones, menús, títulos y fuentes resaltadas.',
		CLIENT__SECONDARY_COLOR_DESCRIPTION:
			'Color utilizado para los botones destacados y los títulos de las secciones.',
		CLIENT__THEME_BACKGROUND: 'BACKGROUND',
		CLIENT__PREVIEW: 'Preview',
		CLIENT__MESSAGE_FILE_SIZE_LIMIT: 'El archivo no debe superar los 4 MB',
		CLIENT__SLOGAN: 'SLOGAN',
		CLIENT__LOGO: 'LOGOTIPO',
		CLIENT__NEW_CONTRACT: 'Nuevo contrato',
		CLIENT__NEW_ACCOUNT: 'Nueva cuenta',
		CLIENT__ACCOUNT__MESSAGE_CREATED: '¡Cuenta añadida con éxito!',
		CLIENT__ACCOUNT__MESSAGE_UPDATED: '¡Cuenta modificada con éxito!',
		CLIENT__ACCOUNT__MESSAGE_REMOVED: '¡Cuenta eliminada con éxito!',
		CLIENT__ACCOUNT__MESSAGE_IMAGE_REMOVED: '¡Imagen eliminada con éxito!',
		CLIENT__ACCOUNT_ADD: 'Añadir cuenta',
		CLIENT__ACCOUNT_UPDATE: 'Actualizar cuenta',
		CLIENT__ACCOUNT_REMOVE: 'Eliminar cuenta',
		CLIENT__ACCOUNT__MESSAGE_ADD: 'Quieres añadir una nueva cuenta?',
		CLIENT__ACCOUNT__MESSAGE_UPDATE: 'Quieres actualizar esta cuenta?',
		CLIENT__ACCOUNT__MESSAGE_REMOVE: 'Quieres eliminar esta cuenta?',
		CLIENT__ACCOUNT_MESSAGE_ADD: 'Quieres añadir una nueva cuenta?',
		CLIENT__ACCOUNT_MESSAGE_UPDATE: 'Quieres actualizar esta cuenta?',
		CLIENT__ACCOUNT_MESSAGE_REMOVE: 'Quieres eliminar esta cuenta?',

		CLIENT__LINK_DETAIL: 'Detalle del link',
		CLIENT__GENERAL_INFORMATION: 'Información general',
		CLIENT__TITLE: 'Título',
		CLIENT__SUBTITLE: 'Subtítulo',
		CLIENT__LINK: 'Link',
		CLIENT__REPORT_MESSAGE_CREATED: '¡Informe añadido con éxito!',
		CLIENT__REPORT_MESSAGE_UPDATED: '¡Informe modificado con éxito!',
		CLIENT__REPORT_MESSAGE_REMOVED: '¡Informe eliminada con éxito!',
		CLIENT__CONTROL_DETAIL: 'Detalle del control',
		CLIENT__PRODUCT_DATA: 'Datos del producto',
		CLIENT__PRODUCT: 'Producto',
		CLIENT__HIRED: 'Contratado',
		CLIENT__DELIVERED: 'Entregado',
		CLIENT__QUANTITY_HIRED: 'Cantidad contratada',

		CLIENT__RESPONSIBLE: 'Responsable',
		CLIENT__RESPONSIBLES: 'Responsable',
		CLIENT__DETAIL: 'Datos de la persona responsable',
		CLIENT__DATES: 'Datos de la persona responsable',
		CLIENT__CONTACT: 'Contacto',
		CLIENT__PHONE: 'Teléfono',
		CLIENT__EMAIL: 'Correo electrónico',
		CLIENT__DEPARTMENT: 'Departamento',
		CLIENT__CONTRACTS: 'Contratos',
		CLIENT__CONTRACTS__ACTIVES_SUBTITLE: 'Activos',
		CLIENT__CONTRACT_DETAIL: 'Detalles del contrato',
		CLIENT__CONTRACT_DETAILS: 'Detalles del contrato',
		CLIENT__REGISTRATION: 'Registro',
		CLIENT__CONTRACT_NUMBER: 'Número',
		CLIENT__CONTRACT__PURCHASE_ORDER: 'Orden de compra',
		CLIENT__CONTRACT__START_DATE: 'Inicio',
		CLIENT__CONTRACT__END_DATE: 'Fin',
		CLIENT__CONTRACT__END_WARRANTY: 'Fin de garantía',
		CLIENT__CONTRACT__STATUS: 'Status',
		CLIENT__CONTRACT_FILES: 'Ficheros',
		CLIENT__CONTRACT__UPLOAD_FILES: 'Cargar ficheros del contrato',
		CLIENT__CONTRACT__ERROR_MESSAGE:
			'La suma de los ficheros no puede superar los 10MB',
		CLIENT__CONTRACT__ACTION_ADD: 'Añadir',
		CLIENT__CONTRACT__CONTROL: 'Control',
		CLIENT__CONTRACT__DEVICES_HIRED: 'Dispositivos contratados',
		CLIENT__CONTRACT__DEVICES__HANDED_OUT: 'Dispositivos entregados',
		CLIENT__CONTRACT__COMMENTS: 'Observaciones',
		CLIENT__CONTRACT__DEVICES: 'Dispositivos',
		CLIENT__CONTRACT__DEVICES_PRODUCT: 'Producto',
		CLIENT__CONTRACT__DEVICES_TYPE_PROFILE: 'Tipo / perfil',
		CLIENT__CONTRACT__DEVICES_SERIAL_NUMBER: 'Núm. Serie',
		CLIENT__CONTRACT__DEVICES_UID: 'UID',
		CLIENT__CONTRACT__DEVICES_HARD_FIRM: 'Hard / Firm',
		CLIENT__CONTRACT__DEVICES_STAGE: 'Etapa',
		CLIENT__FILTER_CONTRACTS: 'Contratos de filtro',
		CLIENT__CONTRACT_NAME: 'Nombre',
		CLIENT__CONTRACT_PHONE: 'Teléfono',
		CLIENT__CONTRACT_EMAIL: 'Correo electrónico',
		CLIENT__CONTRACT__DEVICES_TOTAL_HIRED: 'Contratados',
		CLIENT__CONTRACT__DEVICES_TOTAL: 'Enlazados',
		CLIENT__CONTRACT__DEVICES_HIRED_ASSOCIATES:
			'Dispositivos (contratados/asociados)',
		CLIENT__CONTRACT__MESSAGE_CREATED: 'Contrato añadido con éxito!',
		CLIENT__CONTRACT__MESSAGE_UPDATED: 'Contrato modificado con éxito!',
		CLIENT__CONTRACT__MESSAGE_REMOVED: 'Contrato eliminado con éxito!',
		CLIENT__CONTRACT__MESSAGE_FILE_REMOVED: 'Fichero eliminado con éxito!',
		CLIENT_CONTRACT_TITLE: 'Título',
		CLIENT_CONTRACT_SUBTITLE: 'Subtítulo',
		CLIENT__CONTRACT__MODULES: 'Módulos',
		CLIENT__CONTRACT_MODALITY: 'Modalidad',
		CLIENT__CONTRACT_SUPPORT: 'Soporte',
		CLIENT__BACKGROUND_IMAGE: 'Imagen de fondo',
		CLIENT__MESSAGE_DOCUMENTATION_URL:
			'La URL de la documentación no es válida',
		CLIENT__MESSAGE_JIRA_URL: 'La URL de Jira no es válida',
		CLIENT__MESSAGE_CONNECT_URL:
			'Enlace personalizado de la cuenta, que servirá como acceso a la cámara de monitoreo',
		CLIENT__MESSAGE_CONNECT_KINESIS_URL:
			'Enlace personalizado de la cuenta, que servirá como acceso a la kinesis cámara de monitoreo',
		CLIENT__LOGO_IMAGE: 'Imagen del logotipo',
		CLIENT__MESSAGE_SUPPORT_EMAIL:
			'Correo electrónico personalizado de la cuenta, que servirá como canal para la apertura de tickets en Jira',
		CLIENT__MESSAGE_SUPPORT_WHATSAPP:
			'Número de contacto personalizado de la cuenta, que servirá como canal para comunicarse directamente con el soporte técnico.',
		CLIENT__MESSAGE_THEME_SLOGAN:
			'Eslogan para personalizar tu página de inicio de sesión. Se recomienda utilizar un máximo de 62 caracteres',
		CLIENT__MESSAGE_THEME_SLUG:
			'Definición de la URL de acceso al sistema A4 Solutions. No utilice espacios, acentos ni caracteres especiales en su URL',
		CLIENT__MESSAGE_TICKET_URL:
			'Enlace personalizado de la cuenta, el cual se accederá en caso de apertura y seguimiento de tickets en Jira',
		LOG_SCHEMA__PRIORITY:
			'Los esquemas con alta prioridad serán procesados primero para los registros recibidos',

		COMMON__TABLE__LOADING_TEXT: 'Cargando datos...',
		COMMON__TABLE__NO_DATA_TEXT: 'No se han encontrado registros',
		COMMON__TABLE__NO_RESULTS_PAGE: 'No se han encontrado registros',
		COMMON__TABLE__ITEMS_PER_PAGE_TEXT: 'Artículos por página',
		COMMON__FILTER: 'Filtro',
		COMMON__DETAILS: 'Detalles',
		COMMOM__MODULES: 'Módulos',
		COMMON__SELECT: 'Seleccionar:',
		COMMON__ALL: 'Todos:',
		COMMON__ACTION__SAVE: 'Guardar',
		COMMON__ACTION__REMOVE: 'Borrar',
		COMMON__ACTION__BACK: 'Atrás',
		COMMON__ACTION__INSERT: 'Incluir',
		COMMON__ACTION__CANCEL: 'Cancelar',
		COMMON__ACTION__CONFIRM: 'Confirmar',
		COMMON__ACTION__APPLY: 'Aplicar',
		COMMON__ACTION__DOWNLOAD: 'Descargar',
		COMMON__ACTION__INSERT_BATCH: 'Incluir en lote',
		COMMON__ACTION__UPDATE_BATCH: 'Modificar en lote',
		COMMON__ACTION__REMOVE_BATCH: 'Borrar en lote',
		COMMON__ACTION__ASSOCIATE: 'Asociar',
		COMMON__PAGE_TEXT_OF: 'Desde',
		COMMON__BULK__INCLUSION: 'Inclusión en lote',
		COMMON__BULK__UPDATE: 'Actualización en lote',
		COMMON__APPLICATION_LOGOUT_TITLE: 'Cerrar sesión',
		COMMON__APPLICATION_ACTION_LOGOUT_OK: 'Ok',
		COMMON__APPLICATION_LOGOUT_ATTENTION: 'Atención',
		COMMON__MESSAGE_APPLICATION_LOGOUT: '¿Quieres cerrar sesión?',
		COMMON__APPLICATION_LOGOUT: 'Cerrar sesión',
		COMMON__FILE_ACTION_REMOVE: 'Eliminar',
		COMMON__MESSAGE_FILE_REMOVE: '¿Quieres eliminar este archivo?',
		COMMON__TITLE_ADD: 'Añadir',
		COMMON__TITLE_UPDATE: 'Actualizar',
		COMMON__TITLE_REMOVE: 'Eliminar',
		COMMON__MESSAGE_REMOVE: '¿Quieres eliminar este registro?',
		COMMON__YES: 'Sí',
		COMMON__NO: 'No',
		COMMON__FILE_REMOVE: 'Eliminar archivo',
		SESSION_EXPIRED_ERROR_TOKEN:
			'Sesión expirada con error, por favor inicie sesión nuevamente',
		COMMON__REQUIRED_FIELD: 'Campo obligatorio',
		COMMON__INVALID_CPF: 'CPF no válido',
		COMMON__MINIMUM_CHARACTERS: 'Mínimo de 3 caracteres',
		COMMON__FIELD_MUST_BE_FILLED: 'El campo debe ser rellenado',
		COMMON__MAXIMUM_CHARACTERS: 'Máximo de 100 caracteres',
		COMMON__PASSWORD_LOWERCASE_LETTERS: 'Debe contener letras minúsculas',
		COMMON__PASSWORD_UPPERCASE_LETTERS: 'Debe contener letras mayúsculas',
		COMMON__PASSWORD_NUMBERS: 'Debe contener números',
		COMMON__PASSWORD_SPECIAL_CHARACTERS: 'Debe contener caracteres especiales',
		COMMON__PASSWORD_MINIMUM_LENGTH: 'Debe tener al menos 8 caracteres',
		COMMON__FILE__SIZE__LESS_THAN: 'El tamaño del archivo debe ser menor que',
		COMMON__DATE_END_NOT_BE_BIGGER_THAN_START:
			'La fecha de fin no puede ser mayor que la de inicio',
		COMMON__DATE_EQUAL_TO: 'A data mámixa permitida deve ser de 7 dias',
		COMMON__DATE_BEFORE__OR__EQUAL_TO:
			'A data mámixa permitida deve ser de 7 dias',
		COMMON__DATE_AFTER__OR__EQUAL_TO:
			'A data mámixa permitida deve ser de 7 dias',
		COMMON__FILE_LESS_THAN: 'El archivo debe ser menor que',

		DATA_INSIGHT__DATA_INSIGHT: 'Conocimiento de los datos',
		DATA_INSIGHT__ACCOUNT: 'Cuenta',
		DATA_INSIGHT__REPORT: 'Informe',
		DATA_INSIGHT__ACCOUNT_DETAILS: 'Detalles de la cuenta',

		DASHBOARD__HOMEPAGE: 'Página de inicio',
		DASHBOARD__EVENTS_PER_MONTH: 'Eventos por mes',
		DASHBOARD__WELCOME: 'Bienvenido',
		DASHBOARD__DESCRIPTION: 'Sigue el rendimiento de tu Smart Safety!',
		DASHBOARD__CLIENT_LIST__LABEL: 'Lista de cuentas',
		DASHBOARD__CLIENT_LIST__HEADER: 'Cuentas',
		DASHBOARD__CLIENT_LIST__SEARCH_PLACEHOLDER: 'Buscar una cuenta',
		DASHBOARD__CLIENT_LIST__COLUMN__NAME: 'Nombre',
		DASHBOARD__CLIENT_LIST__COLUMN__DEVICES: 'Dispositivos',
		DASHBOARD__CLIENT_LIST__COLUMN__EVENTS: 'Eventos',
		DASHBOARD__PRODUCT_STOCK_LIST__LABEL: 'Productos en stock',
		DASHBOARD__PRODUCT_STOCK_LIST__HEADER: 'Stock',
		DASHBOARD__PRODUCT_STOCK_LIST__SEARCH_PLACEHOLDER: 'Buscar un producto',
		DASHBOARD__PRODUCT_STOCK_LIST__COLUMN__PRODUCT: 'Producto',
		DASHBOARD__PRODUCT_STOCK_LIST__COLUMN__QUANTITY: 'Cantidad',
		DASHBOARD__EVENT_LIST__LABEL: 'Eventos del día',
		DASHBOARD__EVENT_LIST__HEADER: 'Últimos eventos próximos',
		DASHBOARD__EVENT_LIST__SEARCH_PLACEHOLDER: 'Buscar un evento',
		DASHBOARD__EVENT_LIST__COLUMN__TYPE: 'Tipo',
		DASHBOARD__EVENT_LIST__COLUMN__EQUIPMENT: 'Equipamiento',
		DASHBOARD__EVENT_LIST__COLUMN__TIME: 'Horario',
		DASHBOARD__EVENT_LIST__COLUMN__EMPLOYEE: 'Empleado',
		DASHBOARD__EMPLOYEE_LIST__LABEL: 'Ranking Empleado',
		DASHBOARD__EMPLOYEE_LIST__HEADER: 'Empleados',
		DASHBOARD__EMPLOYEE_LIST__SEARCH_PLACEHOLDER: 'Buscar un empleado',
		DASHBOARD__EMPLOYEE_LIST__COLUMN__NAME: 'Nombre',
		DASHBOARD__EMPLOYEE_LIST__COLUMN__EVENTS: 'Eventos',
		DASHBOARD__EMPLOYEE_LIST__COLUMN__LAST_EVENT: 'Último evento',
		DASHBOARD__METRICS__DEVICES__TITLE: 'Dispositivos',
		DASHBOARD__METRICS__DEVICES__SUBTITLE: 'Dispositivos',
		DASHBOARD__METRICS__EVENTS__TITLE: 'Eventos',
		DASHBOARD__METRICS__EVENTS__SUBTITLE: 'Hoy',
		DASHBOARD__METRICS__CLIENTS__TITLE: 'Cuentas',
		DASHBOARD__METRICS__CLIENTS__SUBTITLE: 'Registrado',
		DASHBOARD__METRICS__ACTIVE_DEVICES__TITLE: 'Dispositivos',
		DASHBOARD__METRICS__ACTIVE_DEVICES__SUBTITLE: 'Activo hoy',
		DASHBOARD__METRICS__EQUIPMENTS__TITLE: 'Equipos',
		DASHBOARD__METRICS__EQUIPMENTS__SUBTITLE: 'Registrado',
		DASHBOARD__METRICS__EMPLOYEES__TITLE: 'Empleados',
		DASHBOARD__METRICS__EMPLOYEES__SUBTITLE: 'Registrados',

		DASHBOARD_VISION__WELCOME: 'Bienvenido!',
		DASHBOARD_VISION__DESCRIPTION: 'Gestión de la visión',
		DASHBOARD_VISION__EVENT_LIST__HEADER: 'Últimos eventos',
		DASHBOARD_VISION__EVENT_LIST__LABEL: 'Eventos del día',
		DASHBOARD_VISION__QUICK_ACCESS: 'Acceso rápido',
		DASHBOARD_VISION__CHART_TITLE: 'Eventos de los últimos 12 meses',

		DASHBOARD_VISION__LINKS__ENVIRONMENT_TITLE: 'Zonas',
		DASHBOARD_VISION__LINKS__ENVIRONMENT_SUBTITLE: 'Registro',
		DASHBOARD_VISION__LINKS__CAMERA_TITLE: 'Cámaras',
		DASHBOARD_VISION__LINKS__CAMERA_SUBTITLE: 'Registro',
		DASHBOARD_VISION__LINKS__MONITOR_TITLE: 'Monitor',
		DASHBOARD_VISION__LINKS__MONITOR_SUBTITLE: 'Cámara',
		DASHBOARD_VISION__LINKS__NOTIFICATIONS_TITLE: 'Notificaciones',
		DASHBOARD_VISION__LINKS__NOTIFICATIONS_SUBTITLE:
			'Grupos de correo electrónico',
		DASHBOARD_VISION__LINKS__REPORTS_TITLE: 'Informes',
		DASHBOARD_VISION__LINKS__REPORTS_SUBTITLE: 'Eventos',
		DASHBOARD_VISION__LOCAL: 'Ubicación',
		DASHBOARD_VISION__CAMERA: 'Ubicación',
		DASHBOARD_VISION__START: 'Inicio',
		DASHBOARD_VISION__HOUR: 'Hora de captura',
		DASHBOARD_VISION__END: 'Fin',
		DASHBOARD_VISION__DURATION: 'Duración',
		DASHBOARD_VISION__ENVIRONMENT: 'Entorno',
		DASHBOARD_VISION__ALGORITHM: 'Engine',
		DASHBOARD_VISION__THRESHOLD: 'Umbral de confianza',
		DASHBOARD_VISION__DEVICE: 'Cámara',

		DEVICE__ALIAS: 'Alias',
		DEVICE__SMART_DEVICES: 'Dispositivos Smart',
		DEVICE__DEVICES: 'Dispositivos',
		DEVICE__DEVICE: 'Dispositivo',
		DEVICE__TYPE: 'Tipo',
		DEVICE__PROFILE: 'Perfil',
		DEVICE__PROFILE_SINGLE_POINT: 'SinglePoint',
		DEVICE__PROFILE_MULTI_POINT: 'MultiPoint',
		DEVICE__PROFILE_CROSS_POINT: 'CrossPoint',
		DEVICE__SOLUTIONS: 'Soluciones',
		DEVICE__ABOUT_DEFECT: 'Sobre el defecto',
		DEVICE__PROFILE_PORTAL: 'Portal',
		DEVICE__PROFILE_ZONE_MAP: 'ZoneMap',
		DEVICE__SERIAL_NUMBER: 'Núm. Serie',
		DEVICE__DEVICES_AVAILABLE: 'Dispositivos disponibles',
		DEVICE__UID: 'UID',
		DEVICE__HARDWARE: 'Hardware',
		DEVICE__HARDWARE_VERSION: 'Versión de hardware',
		DEVICE__FIRMWARE__VERSION: 'Versión de firmware',
		DEVICE__FIRMWARE: 'Firmware',
		DEVICE__CLIENT_NAME: 'Cuenta',
		DEVICE__LOT: 'Lote',
		DEVICE__STAGE: 'Etapa',
		DEVICE__STATUS: 'Estado',
		DEVICE__CONTRACT: 'Contrato',
		DEVICE__ACTION__FILTER: 'Filtrar dispositivos',
		DEVICE__NO_CLIENT_ASSOCIATED: 'Ningún cliente asociado',
		DEVICE__NO_ASSOCIATED: 'No asociado',
		DEVICE__PRODUCT: 'Producto',
		DEVICE__TYPE_PROFILE: 'Tipo / perfil',
		DEVICE__HARD_FIRM: 'Hard / Firm',
		DEVICE__MANUFACTURE_DATE: 'Fecha de fabricación',
		DEVICE__MANUFACTURE: 'Fabricación',
		DEVICE__ADDITIONAL_DATA: 'Datos adicionales',
		DEVICE__MESSAGE_CREATED: 'Dispositivo(s) añadido(s) con éxito',
		DEVICE__MESSAGE_UPDATED: 'Dispositivo(s) modificado(s) con éxito!',
		DEVICE__MESSAGE_REMOVED: 'Dispositivo(s) eliminado(s) con éxito!',
		DEVICE__MESSAGE__NO_DEVICE_FOUND: 'No se ha encontrado ningún dispositivo',
		DEVICE__CONNECT: 'Asociar dispositivo',
		DEVICE__ASSOCIATIONS: 'Asociaciones',
		DEVICE__HISTORY: 'Registro',
		DEVICE__NEW_SMART_DEVICE: 'Nuevo dispositivo smart',
		DEVICE__SMART_DEVICE_DETAILS: 'Detalles del dispositivo smart',
		DEVICE__SMART_DEVICE_DOCUMENTS: 'Documentos del dispositivo',
		DEVICE_DOCUMENTS_TIME: 'Hora',
		DEVICE_DOCUMENTS_DROP_DOCUMENT: 'Arrastra tus documentos aquí',
		DEVICE_DOCUMENTS_FILES_READY: 'Archivos listos',
		DEVICE__IDENTIFY_DEVICE: 'Identificar dispositivo',
		DEVICE__IDENTIFICATION: 'Identificación',
		DEVICE__INTERACTION: 'Interacción',
		DEVICE__LAST_COMMUNICATION_DATE: 'Fecha de la última comunicación',
		DEVICE__LAST_COMMUNICATION_TIME: 'Hora da última comunicación',
		DEVICE__TYPE_SERIAL_NUMBER: 'Digitar el número de serie',
		DEVICE__MESSAGE_SCAN_QRCODES:
			'Encuentra el Código QR en el dispositivo y colócalo en el área de abajo',
		DEVICE__READ_QR_CODE: 'Leer Código QR',
		DEVICE__MESSAGE_TYPE_SERIAL_NUMBER:
			'Introduzca el número de serie que aparece junto al código QR a continuación',
		DEVICE__SELECT: 'Seleccionar',
		DEVICE__ASSOCIATE_DEVICES: 'Asociar dispositivos',
		DEVICE__DOCUMENTS__ERROR_MESSAGE:
			'El tamaño de los archivos no puede superar los 4MB',

		DEVICE__BULK_INSTRUCTIONS:
			'1.Mantenga todas las columnas y el orden de la plantilla descargada, aunque algunos dispositivos no tengan toda la información de registro.;<br /><br />2.Los campos UID y Número de serie son obligatorios. No es posible dejarlos sin información única',
		DEVICE__UPDATE_BATCH: 'Edición por lotes',
		DEVICE__SYSTEM_FIELD: 'Campo del sistema',
		DEVICE__NEW_VALUE: 'Nuevo valor',
		DEVICE__CONTRACT_SELECT: 'Seleccionar un contrato',
		DEVICES__TITLE_UPDATE_BATCH: 'Actualizar en lote',
		DEVICES__MESSAGE_UPDATE_BATCH: 'Quieres actualizar este dispositivo?',
		DEVICES__TITLE_REMOVE_BATCH: 'Eliminar en lote',
		DEVICES__MESSAGE_REMOVE_BATCH: 'Quieres eliminar este dispositvo?',
		DEVICE_MAINTENANCE: 'Manutención',
		DEVICE_MAINTENANCE__DATE: 'Fecha',
		DEVICE_MAINTENANCE__START_DATE: 'Fecha de inicio',
		DEVICE_MAINTENANCE__END_DATE: 'Fecha de fin',
		DEVICE_MAINTENANCE__CREATE_DATE: 'Fecha de creación',
		DEVICE_MAINTENANCE__WANTENTY_DATE: 'Fecha de garantía',
		DEVICE_MAINTENANCE__DATE_START: 'Fecha de inicio de la manutención',
		DEVICE_MAINTENANCE__DATE_END: 'Fecha de fin de la manutención',
		DEVICE_MAINTENANCE__TICKET: 'Ticket',
		DEVICE_MAINTENANCE__TYPE_SERVICE: 'Tipo servicio',
		DEVICE__WARRANTY_MAINTENANCE: 'Garantía de manutención',
		DEVICE__WARRANTY_CONTRACT_END: 'Vencimiento de la garantía contractual',
		DEVICE__WARRANTY_MAINTENANCE_END:
			'Vencimiento de la garantía de manutención',
		DEVICE__SUPPORT: 'Soporte',
		DEVICE__WARRANTY: 'Garantía',
		DEVICE__NO_DEFECT: 'Sin defecto',
		DEVICE__MISUSE: 'Uso indebido',
		DEVICE__OUT_WARRANTY: 'Fuera de garantía',
		DEVICE__ACTION__MAINTENANCES_FILTER: 'Filtrar manutenciones',
		DEVICE__ACTION__DOCUMENTS_FILTER: 'Filtrar documentos',
		DEVICE_DOCUMENTS_NAME: 'Nombre del documento',
		DEVICE_DOCUMENTS_EXTENSION: 'Extension',
		DEVICE__MAINTENANCE_HISTORY: 'Historial de manutenciones',
		DEVICE_MAINTENANCE__STATUS: 'Estado',
		DEVICE__ADD: 'Añadir',
		DEVICE__MAINTENANCE_INFORMATION: 'Información',
		DEVICE_MAINTENANCE_DOCUMENTS: 'Documentos',
		DEVICE__MAINTENANCE__ADD: 'Añadir manutención',
		DEVICE__MAINTENANCE__UPDATE: 'Actualizar manutención',
		DEVICE__PROGRESS_START: 'Inicio del proceso',
		DEVICE__CLAIMED_DEFECT: 'Defecto reclamado',
		DEVICE__DEFECT: 'Defecto',
		DEVICE__SOLUTION: 'Solución',
		DEVICE__REPORT: 'Informe',
		DEVICE__ACTION__COMMENTS: 'Observaciones',
		DEVICE_MAINTENANCE_TYPE__RESOLVED: 'Resuelto',
		DEVICE_MAINTENANCE_TYPE__INPROGRESS: 'En proceso',
		DEVICE_MAINTENANCE_TYPE__UNRESOLVED: 'No resuelto',
		DEVICE__TITLE_ADD: 'Añadir dispositivo',
		DEVICE__MESSAGE_ADD: 'Quieres añadir un nuevo dispositivo?',
		DEVICE__TITLE_UPDATE: 'Actualizar dispositivo',
		DEVICE__MESSAGE_UPDATE: 'Quieres actualizar este dispositivo?',
		DEVICE__TITLE_REMOVE: 'Eliminar dispositivo',
		DEVICE__MESSAGE_REMOVE: 'Quieres eliminar este dispositivo?',
		DEVICE__MAINTENANCE__DOWNLOAD_FILE: 'Descargar archivo',
		DEVICE__MAINTENANCE_TITLE_ADD: 'Añadir manutención',
		DEVICE__MAINTENANCE_MESSAGE_ADD: 'Quieres añadir una nueva manutención?',
		DEVICE__MAINTENANCE_TITLE_UPDATE: 'Actualizar manutención',
		DEVICE__MAINTENANCE_MESSAGE_UPDATE: 'Quieres actualizar esta manutención?',
		DEVICE__MAINTENANCE_TITLE_REMOVE: 'Eliminar manutención',
		DEVICE__MAINTENANCE_MESSAGE_REMOVE: 'Quieres eliminar esta manutención?',
		DEVICE__MAINTENANCE__MESSAGE_CREATED: 'Manutención añadida con éxito!',
		DEVICE__MAINTENANCE__MESSAGE_UPDATED: 'Manutención modificada con éxito!',
		DEVICE__MAINTENANCE__MESSAGE_REMOVED: 'Manutención eliminada con éxito!',
		DEVICE__MAINTENANCE__MESSAGE_FILE_REMOVED: 'Archivo eliminado con éxito!',
		DEVICE__DOCUMENT__MESSAGE_FILE_REMOVED: 'Quieres eliminar este archivo?',
		DEVICE__DOCUMENT_TITLE_REMOVE: 'Eliminar documento',
		DEVICE__DOCUMENT_TITLE_ADD: 'Añadir documento',
		DEVICE__DOCUMENT_MESSAGE_ADD: 'Quieres añadir un nuevo documento?',
		DEVICE__DOCUMENT_TITLE_UPDATE: 'Actualizar documento',
		DEVICE__DOCUMENT_MESSAGE_UPDATE: 'Quieres actualizar este documento?',
		DEVICE__DOCUMENT__MESSAGE_CREATED: 'Documento añadido con éxito!',
		DEVICE__DOCUMENT__MESSAGE_UPDATED: 'Documento modificado con éxito!',
		DEVICE__DOCUMENT__MESSAGE_REMOVED: 'Documento eliminado con éxito!',
		DEVICE__DOCUMENT__FILE_REMOVED: 'Archivo eliminado con éxito!',
		DEVICE__DOCUMENT__MESSAGE_DELETED: 'Documento eliminado con éxito!',
		DEVICE__DOCUMENTS: 'Documentos',
		DEVICE__DOCUMENTS__UPLOAD_FILES: 'Cargar archivos del dispositivo',

		EMPLOYEE__EMPLOYEES: 'Empleados',
		EMPLOYEE__EMPLOYEE: 'Empleado',
		EMPLOYEE__NAME: 'Nombre',
		EMPLOYEE__PROFILE: 'Perfil',
		EMPLOYEE__REGISTRATION: 'Inscripción',
		EMPLOYEE__BIRTH_DATE: 'Fecha de nacimiento',
		EMPLOYEE__PICTURE: 'Foto',
		EMPLOYEE__MESSAGE__FILE_SIZE_ERROR: 'El archivo no debe pesar más de 4MB',
		EMPLOYEE__IMAGE__ERROR_MESSAGE: 'La imagen debe contener un máximo de 1MB',
		EMPLOYEE__BRIGADIER: 'Mimebro de Brigada',
		EMPLOYEE__UNIT: 'Unidad',
		EMPLOYEE__DEPARTMENT: 'Departamento',
		EMPLOYEE__DEVICE: 'Dispositivo',
		EMPLOYEE__FULL_NAME: 'Nombre completo',
		EMPLOYEE__SAFETY_TYPE: 'Seguridad',
		EMPLOYEE__STATUS: 'Estado',
		EMPLOYEE__FILTER_EMPLOYEE: 'Filtrar empleados',
		EMPLOYEE__CLIENT_NAME: 'Cuenta',
		EMPLOYEE__MESSAGE_CREATED: 'Empleado añadido con éxito!',
		EMPLOYEE__MESSAGE_UPDATED: 'Empleado(s) modificado(s) con éxito!',
		EMPLOYEE__MESSAGE_REMOVED: 'Empleado(s) eliminado(s) con éxito!',
		EMPLOYEE__PICTURE__REMOVED: 'Imagen eliminada con éxito!',
		EMPLOYEE__MESSAGE__DOCUMENT_FILE_REMOVED: 'Archivo eliminado con éxito!',
		EMPLOYEE__CIPA: 'Miembro de CIPA',
		EMPLOYEE__ACTION__ASSOCIATE: 'Asociaciones',
		EMPLOYEE__CONNECT: 'Asociar',
		EMPLOYEE__ASSOCIATED_GROUPS: 'Grupos asociados',
		EMPLOYEE__EVENT_HISTORY: 'Historial de eventos',
		EMPLOYEE__EVENT: 'Evento',
		EMPLOYEE__TIME: 'Hora',
		EMPLOYEE__NEW: 'Nuevo empleado',
		EMPLOYEE__DETAILS: 'Detalles del empleado',

		EMPLOYEE__BULK_INSTRUCTIONS:
			'1. Mantenga todas las columnas y el orden de la plantilla descargada, aunque algunos empleados no tengan toda la información de inscripción;<br /><br />2. Los campos Nombre completo, Inscripción y Estado son obligatorios, y la inscripción es única por empleado.',
		EMPLOYEE__BULK_CREATED: 'Empleados añadidos con éxito!',
		EMPLOYEE__BATCH_UPDATE: 'Edición por lotes',
		EMPLOYE__SYSTEM_FIELD: 'Campo del sistema',
		EMPLOYE__NEW_VALUE: 'Nuevo valor',
		EMPLOYEES__TITLE_UPDATE_BATCH: 'Actualizar en lote',
		EMPLOYEES__MESSAGE_UPDATE_BATCH: 'Quieres actualizar este empleado?',
		EMPLOYEES__TITLE_REMOVE_BATCH: 'Eliminar en lote',
		EMPLOYEES__MESSAGE_REMOVE_BATCH: 'Quieres eliminar este empleado?',
		EMPLOYEES__TITLE_ADD_BATCH: 'Añadir en lote',
		EMPLOYEES__MESSAGE_ADD_BATCH: 'Quieres añadir un nuevo empleado?',
		EMPLOYEES__MESSAGE_REMOVED: 'Empleado(s) eliminado(s) con éxito!',
		EMPLOYEES__MESSAGE_UPDATED: 'Empleado(s) modificado(s) con éxito!',
		EMPLOYEE_STATUS__ACTIVE: 'Activo',
		EMPLOYEE__DOCUMENTS: 'Documentos',
		EMPLOYEE__DOCUMENTS__UPLOAD_FILES: 'Cargar archivos del empleado',
		EMPLOYEE__DOCUMENTS__ERROR_MESSAGE:
			'El tamaño de los archivos no puede superar los 4MB',

		ENGINES: 'Motores',
		ENGINE: 'Engine',
		ENGINE__LIST: 'Lista de Motores',
		ENGINE__VERSION: 'Versión',
		ENGINE__NAME: 'Nombre',
		ENGINE__TYPE: 'Tipo',
		ENGINE__STAGE: 'Etapa',
		ENGINE__IN_DEVELOPMENT: 'En desarrollo',
		ENGINE__APPROVED: 'Aprobado',
		ENGINE__STANDART: 'Standard',
		ENGINE__CUSTOM: 'Custom',
		ENGINE__ACCOUNT: 'Cuenta',
		ENGINE__ACCOUNTS: 'Cuentas',
		ENGINE__STATUS: 'Estado',
		ENGINE__STATUS_ACTIVE: 'Activo',
		ENGINE__STATUS_INACTIVE: 'Inactivo',
		ENGINE__FILTER_ENGINES: 'Filtrar Motores',
		ENGINE__DETAILS_ENGINE: 'Detalles del Engine',
		ENGINE__DETAILS: 'Detalles',
		ENGINE__PARAMETERS: 'Parámetros',
		ENGINE__GENERAL_INFORMATIONS: 'Informaciones Generales',
		ENGINE__RELEASE: 'Lanzamiento',
		ENGINE__LAST_UPDATE: 'Última Actualización',
		ENGINE__DESCRIPTION: 'Descripción',
		ENGINE__LICENSE: 'Licencia',
		ENGINE__LICENSE_KEY: 'Clave de Licencia',
		ENGINE__CLASS: 'Clase',
		ENGINE__VALUE: 'Valor',
		ENGINE_CLASS_ID: 'ID de Clase',
		ENGINE__OBS: 'Observaciones',
		ENGINE__DOCUMENTATIONS: 'Documentaciones',
		ENGINE__PARAMETER: 'Parámetro',
		ENGINE__MODEL: 'Modelo',
		ENGINE__CHANGELOG: 'Registro de Cambios',
		ENGINE__COMMENTS: 'Comentarios',
		ENGINE__INCLUDE_PARAMETER: 'Incluir Parámetro',
		ENGINE__PARAMETER_DATA: 'Datos del Parámetro',
		ENGINE__PARAMETER_REQUIRED: 'Parámetro Requerido',
		ENGINE__VALUE_REQUIRED: 'Valor Requerido',
		ENGINE__CONTRACT: 'Contrato',
		ENGINE__FILTER_ACCOUNTS: 'Filtrar Cuentas',
		ENGINE__INIT: 'Inicio',
		ENGINE__END: 'Fin',
		ENGINE__SELECT_AN_CONTRACT: 'Seleccione un Contrato',
		ENGINE__SELECT_AN_ACCOUNT: 'Seleccione una Cuenta',
		ENGINE__INCLUDE_ACCOUNT: 'Incluir Cuenta',
		ENGINE__ACCOUNT_DATA: 'Datos de la Cuenta',
		ENGINE__CONTRACT_REQUIRED: 'Contrato Requerido',
		ENGINE__ACCOUNT_REQUIRED: 'Cuenta Requerida',
		ENGINE__NEW_ENGINE: 'Nuevo Engine',
		ENGINE__CREATE_SUCCESS: '¡Motor creado con éxito!',
		ENGINE__CREATE_ERROR: 'Error al crear el engine!',
		ENGINE__DELETE_ERROR: 'Error al eliminar el engine!',
		ENGINE__DELETE_SUCCESS: '¡Motor eliminado con éxito!',
		ENGINE__UPDATE_SUCCESS: '¡Motor actualizado con éxito!',
		ENGINE__UPDATE_ERROR: 'Error al actualizar el engine!',
		ENGINE__TITLE_ADD: 'Agregar Engine',
		ENGINE__MESSAGE_ADD: '¿Desea agregar un nuevo engine?',
		ENGINE__TITLE_UPDATE: 'Actualizar Engine',
		ENGINE__MESSAGE_UPDATE: '¿Desea actualizar el engine?',
		ENGINE__TITLE_REMOVE: 'Eliminar Engine',
		ENGINE__MESSAGE_REMOVE: '¿Desea eliminar el engine?',
		ENGINE__ACTION__FILTER: 'Filtrar Motores',
		ENGINE__CLASS_NAME: 'Nombre de la Clase',
		ENGINE__CLASS_PRECISION: 'Precisión de la Clase',
		ENGINE__CLASS_DESCRIPTION: 'Descripción de la Clase',
		ENGINE__CLASS_TIMEOUT: 'Tiempo de espera de la Clase',
		ENGINE__VALUE_SELECTION: 'Selección de Valor',
		ENGINE__RELIABILIY_LEVEL: 'Nivel de Fiabilidad',
		ENGINE__PERCENTAGE: 'Porcentaje %',
		ENGINE__TIGGER_TIMEOUT: 'Tiempo de espera del Disparador',
		ENGINE__SECONDS: 'Segundos',
		ENGINE__EXPIRED: 'Expirado',
		ENGINE__NEAR_EXPIRED: 'Cerca de Expirar',
		ENGINE__ACTIVE: 'Activo',

		EQUIPMENT__EQUIPMENTS: 'Equipamiento',
		EQUIPMENT__EQUIPMENT: 'Equipamiento',
		EQUIPMENT__NAME: 'Nombre',
		EQUIPMENT__TYPE: 'Tipo',
		EQUIPMENT__UNIT: 'Unidad',
		EQUIPMENT__DEPARTMENT: 'Departamento',
		EQUIPMENT__DEVICE: 'Dispositivo',
		EQUIPMENT__STATUS: 'Estado',
		EQUIPMENT__EVENT: 'Evento',
		EQUIPMENT__TIME: 'Hora',
		EQUIPMENT__FILTER_EQUIPMENT: 'Filtrar equipamientos',
		EQUIPMENT__NEW: 'Nuevo equipamiento',
		EQUIPMENT__DETAILS: 'Detalles del equipamiento',
		EQUIPMENT__ACTION__ASSOCIATE: 'Asociaciones',
		EQUIPMENT__CONNECT: 'Asociar',
		EQUIPMENT__CLIENT_NAME: 'Cuenta',
		EQUIPMENT__ACTIVE__NUMBER: 'Numero del Ativo',
		EQUIPMENT__MANUFACTURER: 'Fabricante',
		EQUIPMENT__YEAR__MANUFACTURER: 'Año de fabricación',
		EQUIPMENT__EVENT__HISTORY: 'Historial de eventos',
		EQUIPMENT__MODEL: 'Modelo',
		EQUIPMENT__ASSOCIATED_GROUPS: 'Grupos asociados',
		EQUIPMENT__MESSAGE_CREATED: 'Equipo añadido correctamente!',
		EQUIPMENT__MESSAGE_UPDATED: 'Equipo(s) modificado(s) con éxito!',
		EQUIPMENT__MESSAGE_REMOVED: 'Equipo(s) eliminado(s) con éxito!',
		EQUIPMENT__UPDATE_BATCH: 'Edición por lotes',
		EQUIPMENT__SYSTEM_FIELD: 'Campo del sistema',
		EQUIPMENT__NEW_VALUE: 'Nuevo valor',
		EQUIPMENTS__TITLE_ADD_BATCH: 'Añadir en lote',
		EQUIPMENTS__MESSAGE_ADD_BATCH: 'Quieres añadir un nuevo equipamiento?',
		EQUIPMENTS__TITLE_UPDATE_BATCH: 'Actualizar en lote',
		EQUIPMENTS__MESSAGE_UPDATE_BATCH: 'Quieres actualizar este equipamiento?',
		EQUIPMENTS__TITLE_REMOVE_BATCH: 'Eliminar en lote',
		EQUIPMENTS__MESSAGE_REMOVE_BATCH: 'Quieres eliminar este equipamiento?',
		EQUIPMENT__DOCUMENT: 'Documento',
		EQUIPMENT__DOCUMENTS__UPLOAD_FILES: 'Subir archivos',
		EQUIPMENT__DOCUMENTS__ERROR_MESSAGE:
			'El archivo debe contener un máximo de 4MB',

		EMPLOYEE__TITLE_UPDATE: 'Actualizar empleado',
		EMPLOYEE__MESSAGE_UPDATE: 'Quieres actualizar este empleado?',
		EMPLOYEE__TITLE_REMOVE: 'Eliminar empleado',
		EMPLOYEE__MESSAGE_REMOVE: 'Quieres eliminar este empleado?',
		PLACE__MESSAGE_REMOVE: 'Quieres eliminar este lugar?',
		PLACE__DOCUMENT__FILE_REMOVED: 'Archivo eliminado con éxito!',
		PLACE__DOCUMENT_MESSAGE_REMOVE: 'Quieres eliminar este documento?',
		PERMISSION_GROUP_TITLE_REMOVE: 'Eliminar grupo de permisos',
		PERMISSION_GROUP_TITLE_UPDATE: 'Actualizar grupo de permisos',
		PERMISSION_GROUP_MESSAGE_UPDATE:
			'Quieres actualizar este grupo de permisos?',
		PERMISSION_GROUP_MESSAGE_REMOVE: 'Quieres eliminar este grupo de permisos?',

		EQUIPMENT__BULK_INSTRUCTIONS:
			'1. Mantenga todas las columnas y la ordenación de la plantilla descargada, aunque algunos equipos no tengan toda la información de registro; 2. Los campos de nombre, tipo y estado son obligatorios. El tipo debe elegirse entre las opciones predefinidas en el registro individual',
		EQUIPMENT__BULK_CREATED: '¡Equipo añadido con éxito!',

		FIRMWARE__FIRMWARES: 'Firmwares',
		FIRMWARE__COMPATIBLE_FIRMWARES: 'Firmwares compatibles',
		FIRMWARE__NAME: 'Nombre',
		FIRMWARE__NEW_FIRMWARE: 'Nuevo firmware',
		FIRMWARE__REGISTRATION: 'Registro',
		FIRMWARE__STAGE: 'Etapa',
		FIRMWARE__VERSION: 'Versión',
		FIRMWARE__RELEASE_DATE: 'Fecha de lanzamiento',
		FIRMWARE__EXPIRATION_DATE: 'Fecha de caducidad',
		FIRMWARE__BOARDS: 'Boards',
		FIRMWARE__DOCUMENTATION: 'Documentación',
		FIRMWARE__CHANGELOG: 'Changelog',
		FIRMWARE__COMMENTS: 'Comentarios',
		FIRMWARE__COMPATIBILITY: 'Compatibilidad',
		FIRMWARE__PRODUCT: 'Producto',
		FIRMWARE__FEATURES: 'Features',
		FIRMWARE__DETAIL: 'Detalles del firmware',
		FIRMWARE__DETAILS: 'Detalles del firmware',
		FIRMWARE__FILTER_FIRMWARES: 'Filtrar firmwares',
		FIRMWARE__FIRMWARES_REPOSITORY: 'Repositorio de firmware',
		FIRMWARE__FILE: 'Archivo de firmware',
		FIRMWARE__PREVIEW: 'Vista previa',
		FIRMWARE__MESSAGE_FILE_SIZE_LIMIT: 'El archivo no puede superar los 4 MB',
		FIRMWARE__DOCUMENTATION_FILE: 'Archivo de documentación',
		FIRMWARE__MESSAGE_CREATED: 'Firmware añadido con éxito!',
		FIRMWARE__MESSAGE_UPDATED: 'Firmware modificado con éxito!',
		FIRMWARE__MESSAGE_REMOVED: 'Firmware eliminado con éxito!',
		FIRMWARE__MESSAGE_FILE_REMOVED: 'Fichero eliminado con éxito!',

		HELLO__MESSAGE: 'Hola',

		HELPER_CENTER: 'Centro de ayuda',
		HELPER__HELPER_OPTIONS: 'Opciones de ayuda',
		HELPER_SUPPORT: 'Soporte',
		HELPER__TICKET: 'Billete',
		HELPER__BASE_OF: 'Base de',
		HELPER__KNOWLEDGE: 'Conocimientos',
		HELPER__DOCUMENTATION: 'Documentación',
		HELPER__API_CONSULT: 'Consultar API',
		HELPER__INFO_TITLE: 'Si lo prefiere, póngase en contacto con nosotros!',
		HELPER__INFO_DESCRIPTION:
			'Si ninguna de las opciones anteriores le ha ayudado, póngase en contacto con nosotros a través de los canales de comunicación indicados:',
		HELPER__DESCRIPTION_DOCUMENTATION:
			'Documentación diseñada para que los equipos de desarrollo y TI faciliten los procesos de integración',
		HELPER__DESCRIPTIONS:
			'Artículos y documentos en una amplia base de datos sobre las herramientas del sistema y la optimización de los resultados',
		HELPER__OPEN_CALL_DESCRIPTIONS:
			'Solicitudes y llamadas abiertas para cuestiones de asistencia técnica, financiera o de soporte',

		INTEGRATION__INTEGRATIONS: 'Integraciones',
		INTEGRATION__NAME: 'Nombre',
		INTEGRATION__ACCOUNT: 'Cuenta',
		INTEGRATION__STATUS: 'Estado',
		INTEGRATION__FILTER_ACTIONS: 'Filtrar integraciones',
		INTEGRATION__INTEGRATION_DETAILS: 'Detalles de la integración',
		INTEGRATION__IDENTIFICATION: 'Identificación',
		INTEGRATION__ACCESS: 'Acceso',
		INTEGRATION__URL_SANDBOX: 'URL Sandbox',
		INTEGRATION__URL_PRODUCTION: 'URL de producción',
		INTEGRATION__CREDENTIAL: 'Credencial',
		INTEGRATION__TOKEN: 'Token',
		INTEGRATION__COPY_SECRET_KEY:
			'Copia esta clave y utilízala para la autenticación de la API. Esta clave no volverá a aparecer',
		INTEGRATION__PERMISSIONS: 'Permisos',
		INTEGRATION__NEW_INTEGRATION: 'Nueva integración',
		INTEGRATION__CONTENT_COPIED: 'Contenido copiado!',
		INTEGRATION__MESSAGE_CREATED: 'Integración añadida con éxito!',
		INTEGRATION__MESSAGE_UPDATED: 'Integración modificada con éxito',
		INTEGRATION__MESSAGE_REMOVED: 'Integración eliminada con éxito',

		LOG_SCHEMA__LOG_SCHEMAS: 'Esquemas de log',
		LOG_SCHEMA__LOG_SCHEMA: 'Esquema de log',
		LOG_SCHEMA__FILTER_LOG_SCHEMAS: 'Filtrar esquemas de log',
		LOG_SCHEMA__NAME: 'Nombre',
		LOG_SCHEMA__CODE_LOG: 'Código de log',
		LOG_SCHEMA__DESCRIPTION: 'Descripción',
		LOG_SCHEMA__JSON_SCHEMAS: 'Esquemas JSON',
		LOG_SCHEMA__LOG_EXAMPLE: 'Ejemplo de log',
		LOG_SCHEMA__LOG_DEFINITION: 'Definición del log',
		LOG_SCHEMA__LOG_METADATA: 'Metadatos de log',
		LOG_SCHEMA__LABEL: 'Etiqueta',
		LOG_SCHEMA__PROPERTY: 'Propiedad',
		LOG_SCHEMA__TYPE: 'Tipo',
		LOG_SCHEMA__FIXED_VALUE: 'Valor fijo',
		LOG_SCHEMA__OUTPUT: 'Salida',
		LOG_SCHEMA__MESSAGE_LOG: 'Mensaje de log',
		LOG_SCHEMA__MESSAGE_LOG_TEMPLATE: 'Plantilla de mensaje de log',
		LOG_SCHEMA__USE_VARIABLES_IN_FORMAT: 'Utilizar variables en formato',
		LOG_SCHEMA__GENERATED_LOG_MESSAGE: 'Mensaje de log generado',
		LOG_SCHEMA__ACKNOWLEDGE: 'Acknowledge',
		LOG_SCHEMA__SUCCESS_ACK: 'ACK exitoso',
		LOG_SCHEMA__ERROR_ACK: 'Error ACK',
		LOG_SCHEMA__GENERATED_ERROR_ACK: 'ACK de error generado',
		LOG_SCHEMA__MAIN_UID: 'UID principal',
		LOG_SCHEMA__EVENT_DATE: 'Fecha del evento',
		LOG_SCHEMA__NEW_LOG_SCHEMA: 'Nuevo esquema de log',
		LOG_SCHEMA__LOG_SCHEMA_DETAILS: 'Detalles del esquema de log',
		LOG_SCHEMA__MESSAGE_CREATED: 'Esquema de log añadido con éxito!',
		LOG_SCHEMA__MESSAGE_UPDATED: 'Esquema de log modificado con éxito',
		LOG_SCHEMA__MESSAGE_REMOVED: 'Esquema de log eliminado con éxito!',

		LOG_TYPE__EVENT_ERROR_INFORMATIVE: 'Informativo',
		LOG_TYPE__EVENT_ERROR_INFORMATION: 'Información',
		LOG_TYPE__EVENT_ERROR_ALERT: 'Alerta',
		LOG_TYPE__EVENT_ERROR_CRITICAL: 'Error crítico',
		LOG_TYPE__EVENT_ERROR_SUPER_CRITICAL: 'Crítico',
		LOG_TYPE__EVENT_NO_ERROR_INFORMATION: 'Sin información de error',
		LOG_TYPE__TYPE_ERROR: 'Tipo de error',
		LOG_TYPE__LOG_TYPES: 'Tipos de log',
		LOG_TYPE__LOG_TYPE: 'Tipo de log',
		LOG_TYPE__CODE: 'Código de log',
		LOG_TYPE__NAME: 'Nombre',
		LOG_TYPE__ONE: 'Tipo 1',
		LOG_TYPE__TWO: 'Tipo 2',
		LOG_TYPE__ACTION__FILTER: 'Filtrar tipos de log',
		LOG_TYPE__DESCRIPTION: 'Descripción',
		LOG_TYPE__UNIT: 'Unidad',
		LOG_TYPE__MESSAGE_CREATED: 'Tipo de log añadido con éxito',
		LOG_TYPE__MESSAGE_UPDATED: 'Tipo de log modificado con éxito!',
		LOG_TYPE__MESSAGE_REMOVED: 'Tipo de log eliminado con éxito!',
		LOG_TYPE__TITLE_ADD: 'Añadir tipo de log',
		LOG_TYPE__MESSAGE_ADD: 'Quieres añadir un nuevo tipo de log?',
		LOG_TYPE__TITLE_UPDATE: 'Actualizar tipo de log',
		LOG_TYPE__MESSAGE_UPDATE: 'Quieres actualizar este tipo de log?',
		LOG_TYPE__TITLE_REMOVE: 'Eliminar tipo de log',
		LOG_TYPE__MESSAGE_REMOVE: 'Quieres eliminar este tipo de log?',
		LOG__TYPES__TEMPERATURE: 'Temperatura',

		MENU__EXIT: 'Salir',
		MENU__GROUP__REGISTRATION: 'Inscripción',
		MENU__GROUP__VISION: 'Vision',
		MENU__GROUP__MONITORING: 'Análisis',
		MENU__GROUP__DATA: 'Datos',
		MENU__GROUP__EXTRA: 'Extra',
		MENU__HOME__TITLE: 'Inicio',
		MENU__NOTIFICATIONS__TITLE: 'Notificaciones',
		MENU__USERS__TITLE: 'Usuarios',
		MENU__CAMERAS__TITLE: 'Cámaras',
		MENU__VISION__MONITORING__TITLE: 'Monitorear',
		MENU__USERS__DESCRIPTION: 'Gestión',
		MENU__USUARIOS__DESCRIPCIÓN: 'Gestión',
		MENU__CÁMARAS__TILE: 'Cámaras',
		MENU__CLIENTS__TITLE: 'Cuentas',
		MENU__CLIENTS__DESCRIPTION: 'Gestión',
		MENU__CLIENT__TITLE: 'Mi cuenta',
		MENU__CLIENT__DESCRIPTION: 'Gestión',
		MENU__DEVICES__TITLE: 'Dispositivos',
		MENU__DEVICES__DESCRIPTION: 'Smart',
		MENU__INTEGRATION__TITLE: 'Integraciones',
		MENU__INTEGRATION__DESCRIPTION: 'Registro',
		MENU__ACTIONS__TITLE: 'Acciones',
		MENU__ACTIONS__DESCRIPTION: 'Registro',
		MENU__PLACES__TITLE: 'Zonas',
		MENU__PLACES__DESCRIPTION: 'Registro',
		MENU__EMPLEADOS__TILE: 'Empleados',
		MENU__EMPLOYEES__DESCRIPTION: 'Inscripción',
		MENU__EQUIPMENTS__TITLE: 'Equipamiento',
		MENU__EMPLOYEES__TITLE: 'Empleados',
		MENU__EQUIPMENTS__TILE: 'Equipamiento',
		MENU__EQUIPMENTS__DESCRIPTION: 'Registro',
		MENU__PERMISSION_GROUPS__TITLE: 'Grupos de permisos',
		MENU__PERMISSION_GROUPS__DESCRIPTION: 'Registro',
		MENU__PRODUCTS__TITLE: 'Productos',
		MENU__PRODUCTS__DESCRIPTION: 'Registro',
		MENU__LOG_TYPES__TITLE: 'Tipos de log',
		MENU__LOG_TYPES__DESCRIPTION: 'Registro',
		MENU__ZONEMAP__TITLE: 'Zone Map',
		MENU__ZONEMAP__DESCRIPTION: 'Monitorización',
		MENU__BRIGADIER_PANEL__TITLE: 'Panel de Brigada',
		MENU__BRIGADIER_PANEL__DESCRIPTION: 'Monitorización',
		MENU__MONITORING__TITLE: 'Estado del dispositivo',
		MENU__MONITORING__DESCRIPTION: 'Monitorización',
		MENU__SYNOPTIC__TILE: 'Sinóptico',
		MENU__SYNOPTIC__DESCRIPTION: 'Monitorización',
		MENU__REPORTS__TITLE: 'Informes',
		MENU__REPORTS__DESCRIPTION: 'Historial',
		MENU__INSIGHTS__TITLE: 'Data Insight',
		MENU__INSIGHTS__DESCRIPTION: 'Historial',
		MENU__SEARCH_DEVICE__TITLE: 'Identificar dispositivo',
		MENU__SEARCH_DEVICE__DESCRIPTION: 'Buscar',
		MENU__FIRMWARES__TILE: 'Firmwares',
		MENU__FIRMWARES__DESCRIPTION: 'Registro',
		MENU__BOARDS__TILE: 'Boards',
		MENU__BOARDS__DESCRIPTION: 'Registro',
		MENU__TAGS__TITLE: 'Etiquetas',
		MENU__TAGS__DESCRIPTION: 'Registro',
		MENU__LOG_SCHEMAS__TITLE: 'Esquemas de log',
		MENU__LOG_SCHEMAS__DESCRIPTION: 'Registro',
		MENU__MODULES__TITLE: 'Módulos',
		MENU__ENGINES__TITLE: 'Motores VS',

		MODALITY_TYPES__RENTAL: 'Alquiler',
		MODALITY_TYPES__SALE: 'Venta',

		MODULE_SELECTION__ACCESS: 'Inicio de sesión',
		MODULE_SELECTION__WELCOME: 'Bienvenido',
		MODULE_SELECTION__DESCRIPTION:
			'Seleccione uno de los productos de A4 Solutions',
		MODULE_SELECTION__SMART_SAFETY_DESCRIPTION:
			'Solución para aumentar la seguridad en el trabajo que monitoriza la posición de las personas en zonas de riesgo',
		MODULE_SELECTION__VISION_DESCRIPTION:
			'Con VISION puede extraer información empresarial mediante imágenes estáticas o monitorización en tiempo real.',

		MONITORING__MONITORING: 'Monitorización',
		MONITORING__EVENT_HISTORY: 'Historial de eventos',
		MONITORING__STATUS_DEVICES: 'Estado del dispositivo',
		MONITORING__TITLE: 'Estado del dispositivo',
		MONITORING__DASHBOARD: 'Dashboard',
		MONITORING__MONITOR_BY: 'Monitor por',
		MONITORING__MONITOR: 'Monitorear',
		MONITORING__EMPLOYEES: 'Empleados',
		MONITORING__DATA_HOUR: 'Hora',
		MONITORING__EMPLOYEE__SUBTITLE: 'Todos los tipos de etiquetas',
		MONITORING__FILTER_EMPLOYEES: 'Filtrar empleados',
		MONITORING__EQUIPMENT__SUBTITLE: 'Todos los dispositivos core',
		MONITORING__EQUIPMENT__FILTER: 'Filtrar equipamientos',
		MONITORING__PERMISSION_GROUP: 'Grupos de permisos',
		MONITORING__PERMISSION_GROUP__SUBTITLE: 'Equipos en un grupo',
		MONITORING__PERMISSION_GROUP__FILTER: 'Filtrar grupos de permisos',
		MONITORING__PLACES: 'Zonas',
		MONITORING__PLACE__SUBTITLE: 'Dispositivos en una zona',
		MONITORING__PLACE__FILTER: 'Filtrar zonas',
		MONITORING__ONLINE: 'Online',
		MONITORING__OFFLINE: 'Offline',
		MONITORING__WARNING: 'Warning',
		MONITORING__ACTIVE: 'Activo',
		MONITORING__INACTIVE: 'Inactivo',
		MONITORING__DEVICES: 'Dispositivos',
		MONITORING__EQUIPMENTS: 'Equipos',
		MONITORING__PERMISSION_GROUPS: 'Grupos de permisos',
		MONITORING__LAST_EVENTS: 'Últimos eventos',
		MONITORING__EVENT: 'Evento',
		MONITORING__START: 'Inicio',
		MONITORING__MIDIA: 'Mídia',
		MONITORING__TIME: 'Hora',
		MONITORING__CAMERA_FILTER: 'Filtrar cámaras',
		MONITORING__CAMERAS: 'Cámaras',
		MONITORING__CAMERA: 'Cámara',
		MONITORING__MOSAIC: 'Mosaico',
		MONITORING__CREATE_MOSAIC: 'Crear mosaico',
		MONITORING__MONITOR_CAMERA: 'Monitorear la cámara',
		MONITORING__MOSAIC_CAMERA: 'Monitor mosaico',
		MONITORING__MAX_MOSAIC: 'El límite máximo permitido es de 6 cámaras',
		NOTIFICATION__ALERT_PANIC: 'Alerta de pánico',
		NOTIFICATION__EMPLOYEE: 'Empleado',
		NOTIFICATION__REPORT_BY: 'Informado por',
		NOTIFICATION__TIME: 'Hora',
		NOTIFICATION__MESSAGE_FINE: 'ESTÁ TODO BIEN?',
		NOTIFICATION__MESSAGE_NOTIFICATIONS:
			'Antes de cerrar esta notificación, asegúrese de que todo está bien con los implicados',
		NOTIFICATION__ALERT_CLOSE: 'Cerrar alerta',

		OPEN_TICKET: 'Billete abierto',

		PERMISSION_GROUP__PERMISSION_GROUPS: 'Grupos de permisos',
		PERMISSION_GROUP__EMPLOYEES_GROUP: 'Grupos de empleados',
		PERMISSION_GROUP__EMPLOYEES: 'Empleados',
		PERMISSION_GROUP__EQUIPMENTS_PLACES: ' Grupos de equipamientos / zonas',
		PERMISSION_GROUP__PERMISSION_GROUP_DETAILS:
			'Detalles del grupo de permisos',
		PERMISSION_GROUP__NAME: 'Nombre',
		PERMISSION_GROUP__TYPE: 'Tipo',
		PERMISSION_GROUP__CREATED: 'Fecha',
		PERMISSION_GROUP__CLIENT: 'Cliente',
		PERMISSION_GROUP__ACCOUNT: 'Cuenta',
		PERMISSION_GROUP__NEW_PERMISSION_GROUP: 'Nuevo grupo de permisos',
		PERMISSION_GROUP__FILTER_PERMISSION_GROUP: 'Filtrar grupos de permisos',
		PERMISSION_GROUP__MESSAGE_CREATED: 'Grupo de permisos añadido con éxito!',
		PERMISSION_GROUP__MESSAGE_UPDATED:
			'Grupo de permisos modificado con éxito!',
		PERMISSION_GROUP__MESSAGE_REMOVED: 'Grupo de permisos eliminado con éxito!',
		PERMISSION_GROUP__EMPLOYEE: 'Empleado',
		PERMISSION_GROUP__EQUIPMENT_PLACE: 'Equipamento/Zona',

		PLACE__PLACES: 'Zonas',
		PLACE__PLACE: 'Zona',
		PLACE__NAME: 'Nombre',
		PLACE__TYPE: 'Tipo',
		PLACE__CLIENT_NAME: 'Cuenta',
		PLACE__UNIT: 'Unidad',
		PLACE__DEPARTMENT: 'Departamento',
		PLACE__ACTION__STATUS: 'Estado',
		PLACE__FILTER_PLACE: 'Filtrar zonas',
		PLACE__ZONE_MAP: 'Zone Map',
		PLACE__ACTIVATE_ZONE_MAP: 'Activar Zone map',
		PLACE__TIME_AVAILABLE_WEEK: 'Tiempo disponible en la semana (H)',
		PLACE__MAX_TIME_STAY: 'Tiempo máximo de estancia (m)',
		PLACE__BRIGADIER: 'Miembro de Brigada',
		PLACE__BRIGADIER_PANEL: 'Panel de Brigada',
		PLACE__ACTION__ACTIVATE_BRIGADIER_PANEL: 'Activar Panel de Brigada',
		PLACE__MINIMUM_QUANTITY_CIPA: 'Cantidad Mínima de miembros de CIPA',
		PLACE__BRIGADIER_MINIMUM_QUANTITY: 'Cantidad Mínima de miembros de Brigada',
		PLACE__ACTION__ASSOCIATE: 'Asociaciones',
		PLACE__ACTION__DEVICES_ASSOCIATED: 'Dispositivos asociados',
		PLACE__CONNECT: 'Asociados',
		PLACE__CONNECT_DEVICES: 'Asociar dispositivos',
		PLACE__CONNECT_CAMERAS: 'Asociar cámaras',
		PLACE__ASSOCIATED_GROUPS: 'Grupos asociados',
		PLACE__EVENT_HISTORY: 'Historial de eventos',
		PLACE__EVENT: 'Evento',
		PLACE__TIME: 'Hora',
		PLACE__NEW: 'Nueva zona',
		PLACE__DETAILS: 'Detalles de la zona',
		PLACE__MESSAGE_CREATED: 'Zona añadida con éxito!',
		PLACE__MESSAGE_UPDATED: 'Zona modificada con éxito!',
		PLACE__MESSAGE_REMOVED: 'Zona eliminada con éxito!',
		PLACE__STATUS: 'Estado',
		PLACE__TYPE__WAREHOUSE: 'Almacén',
		PLACE__TYPE__STORAGE_SHED: 'Cobertizo',
		PLACE__TYPE__KITCHENETTE: 'Cocina',
		PLACE__TYPE__LOUNGE: 'Salón',
		PLACE__TYPE__RES_AREA: 'Área de descanso',
		PLACE__TYPE__DINING_ROOM: 'Comedor',
		PLACE_STATUS__ACTIVE: 'Activo',
		PLACE_STATUS__INACTIVE: 'Inactivo',
		PLACE__TYPE__REST_AREA: 'Área de descanso',
		PLACE__TITLE_UPDATE: 'Actualizar ambiente',
		PLACE__MESSAGE_UPDATE: 'Quieres actualizar este ambiente?',
		PLACE__DOCUMENTS__ERROR_MESSAGE:
			'El archivo debe contener un máximo de 10MB',
		PLACE__DOCUMENTS__UPLOAD_FILES: 'Subir archivos',
		PLACE__DOCUMENTS__DOCUMENT: 'Documento',
		PLACE__TITLE_REMOVE: 'Eliminar lugar',
		PLACE__DOCUMENT_TITLE_REMOVE: 'Eliminar documento',
		PLACE__TITLE_DOWNLOAD: 'Descargar documento',
		PLACE__DOCUMENT_MESSAGE_DOWNLOAD: 'Quieres descargar este documento?',

		PRODUCT__PRODUCTS: 'Productos',
		PRODUCT__PRODUCT: 'Producto',
		PRODUCT__NAME: 'Nombre',
		PRODUCT__PART_NUMBER: 'Part number',
		PRODUCT__ACTION__FILTER: 'Filtrar productos',
		PRODUCT__TYPE: 'Tipo',
		PRODUCT__NEW: 'Nuevo producto',
		PRODUCT__DETAILS: 'Detalles del producto',
		PRODUCT__PROFILES: 'Perfiles',
		PRODUCT__MESSAGE_CREATED: '¡Producto añadido con éxito!',
		PRODUCT__MESSAGE_UPDATED: '¡Producto modificado con éxito!',
		PRODUCT__MESSAGE_REMOVED: '¡Producto eliminado con éxito!',

		REPORTS__REPORTS: 'Informes',
		REPORTS__ACCOUNTS: 'Cuentas',
		REPORTS__MANAGEMENT: 'Gestión',
		REPORTS__EMPLOYEES: 'Empleados',
		REPORTS__EQUIPMENTS: 'Equipamiento',
		REPORTS__PLACES: 'Zonas',
		REPORTS__DEVICES: 'Dispositivos',
		REPORTS__SMART: 'Smart',
		REPORTS__GROUPS: 'Grupos',
		REPORTS__EVENTS: 'Eventos',
		REPORTS__ALL__EVENTS: 'Todos los Eventos',
		REPORTS__REGISTER: 'Registro',
		REPORTS__EMPLOYEE_APPROXIMATION: 'Acercamiento por empleado',
		REPORTS__REPORT_EVENTS: 'Informe de eventos',
		REPORTS__START_DATE: 'Fecha de inicio',
		REPORTS__END_DATE: 'Fecha de finalización',
		REPORTS__DEVICE: 'Dispositivo',
		REPORTS__UID: 'UID',
		REPORTS__UID_TAG: 'UID de la etiqueta',
		REPORTS__PORTAL_UID: 'Del portal - UID',
		REPORTS__EMPLOYEE: 'Empleado',
		REPORTS__NAME: 'Nombre',
		REPORTS__REGISTRATION: 'Registro',
		REPORTS__UNIT: 'Unidad',
		REPORTS__DEPARTMENT: 'Departamento',
		REPORTS__ACTIVE_NUMBER: 'Número Activo',
		REPORTS__ALL_EVENTS: 'Todos los eventos',
		REPORTS__EQUIPMENT: 'Equipamiento',
		REPORTS__MAINTENANCE: 'Mantenimiento',
		REPORTS__MAINTENANCE_EVENTS: 'Eventos de mantenimiento',
		REPORTS__EVENT_PASSAGE: 'Evento de pasaje',
		REPORTS__EVENT_COD_LOG: 'Código de log: 508 e 509',

		SAFETY__DESCRIPTION_STEP1: 'Inicie el proceso',
		SAFETY__DESCRIPTION_STEP2: 'Hágase una foto',
		SAFETY__DESCRIPTION_STEP3: 'Confirmar identificación',
		SAFETY__DESCRIPTION_STEP4: 'Hecho! Finalizado',
		SAFETY__CAPTURE_PHOTO: 'Reconocer',
		SAFETY__INSTRUCTIONS:
			'Sitúe su cara en la zona de la foto y pulse el botón RECOGNISE para iniciar el proceso de IDENTIFICACIÓN.',
		SAFETY__EMPLOYEE_IDENTIFYING: 'Identificando empleado...',
		SAFETY__REGISTRATION_NUMBER: 'Introduzca su número de registro!',
		SAFETY__LICENSE_PLATE: 'Introducir el registro',
		SAFETY__IDENTIFY: 'Identificar',
		SAFETY__HELPER: 'Ayuda?',
		SAFETY__INSTRUCTION_PROCESS:
			'Compruebe los pasos siguientes y complete el proceso. Si aún necesita ayuda, utilice los botones siguientes:',
		SAFETY__PROCESS: 'Entendido, realiza el proceso',
		SAFETY__EMPLOYEE: 'Hola, Colaborador!',
		SAFETY__MANDATORY_BRIGADIER_OR_EMPLOYEE:
			'Si eres miembro de la Brigada o CIPA, debes identificarte. ¡Comprueba el proceso!',
		SAFETY__START: 'Inicio',
		SAFETY__MESSAGE_ERROR: '¡No hemos podido identificar!',
		SAFETY__MESSAGE_CREATED: '¡Identificación completada con éxito!',
		SAFETY__SELECT: 'Seleccione una de las opciones siguientes:',
		SAFETY__TRY_AGAIN: 'Vuelva a intentarlo',
		SAFETY__TYPE_IDENTIFICATION: 'Identificar con registro',
		SAFETY__VIEW_HELPER: 'Solicitar ayuda',
		SAFETY__REGISTRATION: 'Inscripción',
		SAFETY__EXIT: 'Salir',
		SAFETY__PROHIBITED: 'Entrada',
		SAFETY__CONFIRM: 'Soy yo, confirme',
		SAFETY__REDO: 'No soy yo, rehacer',
		SAFETY__REGISTRATION_REDO: 'No soy yo, rehacer con inscripción',
		SAFATY__START_BACK: 'Volver al inicio en',

		SLOGAN_BOX__INFORMATION: 'Su seguridad, nuestro patrimonio',

		SUPPORT__BASIC: 'Básico',
		SUPPORT__BUSINESS: 'Business',
		SUPPORT__NO_SUPPORT: 'No soporte',

		SYNOPTIC__SYNOPTIC: 'Sinóptico',
		SYNOPTIC__MAP: 'Mapa',
		SYNOPTIC__LEGEND: 'Leyenda',
		SYNOPTIC__SECURITY_AREA: 'Área de seguridad',
		SYNOPTIC__SECURITY_CROSSING: 'Paso de peatones',
		SYNOPTIC__ONLINE_DEVICE: 'Dispositivo online',
		SYNOPTIC__OFFLINE_DEVICE: 'Dispositivo offline',
		SYNOPTIC__PASSAGE_EVENT: 'Evento de pasaje',
		SYNOPTIC__EVENT_ERROR: 'Evento de error',
		SYNOPTIC__EVENTS: 'Eventos',
		SYNOPTIC__EVENT: 'Evento',
		SYNOPTIC__SAFE_ZONE: 'Zona segura',
		SYNOPTIC__ACCESS: 'Acceso',
		SYNOPTIC__EQUIPMENT: 'Carretilla elevadora',
		SYNOPTIC__TIME: 'Horario',
		SYNOPTIC__EMPLOYEE: 'Empleado',
		SYNOPTIC__TF_PORTAL: 'Portal TF',

		SYNOPTIC__ANALYTIC_FORKLIFT_STOPS: 'PARADA DEL MONTACARGAS',
		SYNOPTIC__ANALYTIC_ERROR_PASSAGE: 'PASAJE DE ERROR',
		SYNOPTIC__ANALYTIC_BATTERY: 'BATERÍA',
		SYNOPTIC__ANALYTIC__EQUIPMENT: 'MONTACARGAS',
		SYNOPTIC__ANALYTIC__DEVICE: 'DISPOSITIVO',
		SYNOPTIC__ANALYTIC__ALERT: 'ALERTA',
		SYNOPTIC__ANALYTIC__EMPLOYEE: 'COLABORADOR',
		SYNOPTIC__ANALYTIC__APPROXIMATION: 'APROXIMACIÓN',
		SYNOPTIC__ANALYTIC__DATE_HOUR: 'FECHA/HORA',
		SYNOPTIC__ANALYTIC__PORTAL: 'PORTAL',
		SYNOPTIC__ANALYTIC__MSG: 'MENSAJE',
		SYNOPTIC__ANALYTIC__CODE_LOG_122: 'Equipamento Aéreo',
		SYNOPTIC__ANALYTIC__CODE_LOG_131: 'TAG PLUS V3',
		SYNOPTIC__ANALYTIC__CODE_LOG_137: 'TAG STD V3',
		SYNOPTIC__ANALYTIC__CODE_LOG_140: '?',
		SYNOPTIC__ANALYTIC__CODE_LOG_510: 'Pase de entrada inválido',
		SYNOPTIC__ANALYTIC__CODE_LOG_513: 'Pase de salida inválido',

		TAGS__TAGS: 'Etiquetas',
		TAGS__TAG: 'Etiqueta',
		TAGS__SCOPE: 'Modelo',
		TAGS__ACCOUNT: 'Cuenta',
		TAGS__GROUP: 'Grupo',
		TAGS__VALUE: 'Valor',
		TAGS__FILTER_TAGS: 'Filtrar Etiquetas',
		TAGS__TOTAL_REFERENCES: 'Referencias totales',
		TAGS__NEW_TAG: 'Nueva etiqueta',
		TAGS__TAG_DETAILS: 'Detalles de la etiqueta',
		TAGS__MESSAGE_UPDATED: 'Etiqueta modificada con éxito!',
		TAGS__MESSAGE_REMOVED: 'Etiqueta eliminada con éxito!',
		TAGS__INSTRUCTIONS:
			'Introduzca un valor y pulse <strong>Enter</strong> para crear un nuevo elemento.',

		TAGS__TITLE_REMOVE: 'Eliminar tag',
		TAGS__MESSAGE_REMOVE: '¿Desea eliminar la tag?',

		USER__USERS: 'Usuarios',
		USER__NAME: 'Nombre',
		USER__ACCOUNT: 'Cuenta',
		USER__PROFILE: 'Perfil',
		USER__EMAIL: 'Correo electrónico',
		USER__ACTION__FILTER: 'Filtrar usuarios',
		USER__CLIENT: 'Cliente',
		USER_USER: 'Usuario',
		USER__NEW_USER: 'Nuevo usuario',
		USER__USER_DETAILS: 'Detalles de usuario',
		USER__FULL_NAME: 'Nombre completo',
		USER__CPF: 'CPF',
		USER__PHONE: 'Teléfono',
		USER__MODULE: 'Módulos',
		USER__NEW_PASSWORD: 'Nueva contraseña',
		USER__CONFIRM_PASSWORD: 'Repetir contraseña',
		USER__MESSAGE_PASSWORD_ERROR: 'La contraseña no coincide',
		USER__MESSAGE_CREATED: 'Usuario añadido con éxito!',
		USER__MESSAGE_UPDATE_USER:
			'Para aplicar la nueva configuración de idioma, se cerrará tu sesión y deberás iniciar sesión nuevamente. Gracias por tu comprensión.',
		USER__MESSAGE_UPDATED: 'El usuario se ha modificado con éxito!',
		USER__MESSAGE_REMOVED: 'Usuario eliminado con éxito!',
		USER_STATUS__ACTIVE: 'Activo',
		USER_STATUS__INACTIVE: 'Inactivo',
		USER__MESSAGE_ADD: 'Desea añadir el usuario?',
		USER__MESSAGE_UPDATE: 'Desea actualizar el usuario?',
		USER__TITLE_UPDATE: 'Actualizar usuario',
		USER__TITLE_ADD: 'Añadir usuario',
		USER__TITLE_REMOVE: 'Eliminar usuario',
		USER__MESSAGE_REMOVE: 'Desea eliminar el usuario?',
		USER__IDIOM: 'Idioma',
		USER__MESSAGE_CLIENT_WITHOUT__CONTRACT:
			'No añair usuario. El cliente no tiene contrato activo',

		VISION__LIVE_CAMERA_TITLE: 'Monitorización de cámaras',
		VISION__CAMERA_LIST: 'Monitorización',
		VISION__SELECTED_CAMERA: 'Cámara seleccionada',
		VISION__CAMERA_DATA: 'Datos de la cámara',
		VISION__FAVORITE_CAMERA: 'Cámara favorita',
		VISION__CAMERA_AMBIENCE: 'Zona',
		VISION__INITIAL_HOUR: 'Hora',
		VISION__EVENT: 'Evento',
		VISION__MIDIA: 'Medio',
		VISION__MONITORING__MONITOR: 'Monitorear',

		ZONE_MAP__ZONE_MAP: 'Zone Map',
		ZONE_MAP__ZONE_MAPS: 'Zone Maps',
		ZONE_MAP__NAME: 'Nombre',
		ZONE_MAP__ACCOUNT: 'Cuenta',
		ZONE_MAP__TYPE: 'Tipo',
		ZONE_MAP__UNIT: 'Unidad',
		ZONE_MAP__DEPARTMENT: 'Departamento',
		ZONE_MAP__STATUS: 'Estado',
		ZONE_MAP__FILTER_ZONES: 'Filtrar Zonas',
		ZONE_MAP__ZONES: 'Zonas',
		ZONE_MAP__MONITOR: 'Monitor',
		ZONE_MAP__MONITORING: 'Monitorización',
		ZONE_MAP__DEVICES: 'Dispositivos',
		ZONE_MAP__IN_ZONE_NOW: 'En la Zona Ahora',
		ZONE_MAP__MINUTES: 'Minutos',
		ZONE_MAP__MAX_STAY_TIME: 'Tiempo máximo de estancia',
		ZONE_MAP__STAY: 'Estancia',
		ZONE_MAP__FORCE_EXIT: 'Forzar salida',

		WELCOME_WELCOME: 'Gracias!',

		EQUIPMENT__FORKLIFT: 'Carretilla elevadora',
		EQUIPMENT__OVERHEAD_CRANE: 'Puente grúa',
		EQUIPMENT__TRUCK: 'Camión',
		EQUIPMENT__LOADER: 'Cargador de ruedas',
		EQUIPMENT__TRAIN: 'Tren',
		EQUIPMENT__AREA: 'Área',
		EQUIPMENT__CAR: 'Coche',
		EQUIPMENT__TRACTOR: 'Tractor',
		EQUIPMENT__CRANE: 'Grúa',
		EQUIPMENT__TITLE_ADD: 'Añadir equipamiento',
		EQUIPMENT__MESSAGE_ADD: 'Desea añadir nuevo equipamiento?',
		EQUIPMENT__TITLE_UPDATE: 'Actualizar equipamiento',
		EQUIPMENT__MESSAGE_UPDATE: 'Desea actualizar el equipamiento?',
		EQUIPMENT__TITLE_REMOVE: 'Eliminar equipamiento',
		EQUIPMENT__DOCUMENT_TITLE_REMOVE: 'Eliminar documento',
		EQUIPMENT__TITLE_DOWNLOAD: 'Descargar documento',
		EQUIPMENT__MESSAGE_REMOVE: 'Desea eliminar un equipamiento?',
		EQUIPMENT__MESSAGE_ERROR_REMOVING_FILE: 'Error al eliminar el documento',
		EQUIPMENT__MESSAGE_REMOVED_FILE: 'Documento eliminado con éxito!',
		EQUIPMENT__DOCUMENT_MESSAGE_REMOVE: 'Desea eliminar el documento?',
		EQUIPMENT__DOCUMENT_MESSAGE_DOWNLOAD: 'Desea descargar el documento?',
		EQUIPMENTS__TITLE_ADD: 'Añadir equipamiento(s)',
		EQUIPMENTS__MESSAGE_ADD: '¿Desea añadir nuevo(s) equipamiento(s)?',
		EQUIPMENTS__TITLE_UPDATE: 'Actualizar equipamiento(s)',
		EQUIPOS__MENSAJE_ACTUALIZACION:
			'¿Desea modificar el/los equipamiento(s) seleccionado(s)?',
		EQUIPMENTS__TITLE_REMOVE: 'Eliminar equipamiento(s)',
		EQUIPOS__MENSAJE_ELIMINAR:
			'¿Desea eliminar el/los equipamiento(s) seleccionado(s)?',

		ACTION__ACTIVE: 'Activo',
		ACTION__INACTIVE: 'Inactivo',

		EQUIPMENT_STATUS__ACTIVE: 'Activo',
		ESTATUS_EQUIPO__INACTIVO: 'Inactivo',
		ESTATUS_BRIGADIER_PANEL__ACTIVO: 'Activo',
		BRIGADIER_PANEL_STATUS__INACTIVE: 'Inactivo',
		BRIGADIER_PANEL_STATUS__ACTIVE: 'Activo',
		EMPLOYEE_STATUS_ACTIVE: 'Activo',
		EMPLOYEE_STATUS__INACTIVE: 'Inactivo',
		EQUIPMENT_STATUS__INACTIVE: 'Inactivo',

		CONTRACT_STATUS__ACTIVE: 'Activo',
		CONTRACT_STATUS__INACTIVE: 'Inactivo',
		CONTRACT__TITLE_ADD: 'Añadir contrato',
		CONTRACT__MESSAGE_ADD: '¿Desea añadir un nuevo contrato?',
		CONTRACT__TITLE_UPDATE: 'Actualizar contrato',
		CONTRACT__MESSAGE_UPDATE: '¿Desea actualizar el contrato?',
		CONTRACT__TITLE_REMOVE: 'Eliminar contrato',
		CONTRACT__MESSAGE_REMOVE: '¿Desea eliminar el contrato?',

		DEVICE_STAGE__PRODUCTION: 'Producción',
		DEVICE_STAGE__TEST: 'Prueba',
		DEVICE_STAGE__STOCK: 'Stock',
		DEVICE_STAGE__TRANSPORT: 'Transporte',
		DEVICE_STAGE__INSTALLED: 'Instalado',
		DEVICE_STATUS__ACTIVE: 'Activo',
		DEVICE_STATUS__INACTIVE: 'Inactivo',

		DEVICE_TYPE__CORE: 'Core',
		DEVICE_TYPE__TAG: 'Tag',
		DEVICE_TYPE__ACCESSORY: 'Accesorio',
		DEVICE_TYPE__CAMERA: 'Cámara',
		DEVICE_TYPE__SOFTCORE: 'Softcore',

		BOARD_STAGES__TESTING: 'En pruebas',
		BOARD_STAGES__APPROVED: 'Aprobado',
		BOARD_STAGES__NOT_APPROVED: 'No aprobado',

		EVENT_LEVEL__ALERT: 'Alerta',
		EVENT_LEVEL__DANGER: 'Peligro',
		EVENT_LEVEL__INFORMATIVE: 'Informativo',

		EVENT_TYPE__APPROXIMATION: 'Aproximación',
		EVENT_TYPE__APPROXIMATION_4M: 'Aproximación 4 metros',
		EVENT_TYPE__APPROXIMATION_6M: 'Aproximación 6 metros',
		EVENT_TYPE__ENTRY: 'Entrada',
		EVENT_TYPE__EXIT: 'Salida',
		EVENT_TYPE__ERROR: 'Error',

		FIRMWARE_STAGE__TESTING: 'En pruebas',
		FIRMWARE_STAGE__APPROVED: 'Aprobado',
		FIRMWARE_STAGE__NOT_APPROVED: 'Fallido',

		INTEGRATION_STATUS__ACTIVE: 'Activo',
		INTEGRATION_STATUS__INACTIVE: 'Inactivo',
		INTEGRATION__TITLE_ADD: 'Añadir integración',
		INTEGRATION__MESSAGE_ADD: 'Desea añadir una nueva integración?',
		INTEGRATION__TITLE_UPDATE: 'Actualizar integración',
		INTEGRATION__MESSAGE_UPDATE: 'Quieres actualizar una integración?',
		INTEGRATION__TITLE_REMOVE: 'Eliminar integración',
		INTEGRATION__MESSAGE_REMOVE: 'Desea eliminar la integración?',

		LANGUAGE__ENGLISH: 'Inglés',
		LANGUAGE__PORTUGUESE_BR: 'Portugués',
		LANGUAGE__SPANISH: 'Español',
		LOG_PRIORITY__HIGH: 'Alta',
		LOG_PRIORITY__LOW: 'Baja',
		LOG_TYPES__TEXT: 'Texto',
		LOG_TYPES__MEASUREMENT: 'Medida',
		LOG_TYPES__NULL: 'Nulo',
		LOG_TYPES__UID: 'UID',
		LOG_TYPES__TITLE_ADD: 'Añadir tipo de log',
		LOG_TYPES__MESSAGE_ADD: 'Desea añadir un nuevo tipo de log?',
		LOG_TYPES__TITLE_UPDATE: 'Actualizar tipo de log',
		LOG_TYPES__MESSAGE_UPDATE: 'Desea actualizar el tipo de log?',
		LOG_TYPES__TITLE_REMOVE: 'Eliminar tipo de log',

		USER__CONFIRM_PASSOWRD: 'Confirmar contraseña',
	},
};

const i18n = new VueI18n({
	fallbackLocale: {
		'en-US': 'en',
		'pt-BR': 'pt',
		'es-ES': 'es',
	},
	messages,
});

export function setLanguage(locale) {
	i18n.locale = getBrowserLanguage(locale);
}

export function getBrowserLanguage(language) {
	let existLocaleMessage = i18n.messages[navigator.language];
	if (navigator.language === 'pt-BR' && !language) {
		language = navigator.language.replace(navigator.language, 'pt');
		existLocaleMessage = i18n.messages[language];
	}

	if (!language && existLocaleMessage) {
		i18n.locale = navigator.language;
	} else {
		i18n.locale = language || 'en';
	}
	return i18n.locale;
}

export default i18n;
